
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eiCiP", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $i6sMX = parcelRequire("i6sMX");

async function $ce9420cf2e1537b9$export$aa71e886f3713f68() {
    const { userId: userId, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $i6sMX.getRemoteLocalStorage)({
        userId: userId,
        isLicensed: isLicensed
    });
}
module.exports["preloadLocalStorage"] = $ce9420cf2e1537b9$export$aa71e886f3713f68;

});

parcelRegister("eS4vC", function(module, exports) {


/**
 * Registry of SSR requests that have been started but have not come back yet,
 * keyed by the query boundary (data fetcher name) they were started under.
 *
 * A data fetcher times out *because* one of its requests has not returned, so the
 * culprit can only be named while it is still in flight. Logging when a response
 * arrives misses the request that never responds at all — which is the common case.
 */ const $1679d946d02f36e7$var$noop = ()=>{};
function $1679d946d02f36e7$export$63a8b60d5caf2194(queryBoundary, request) {
    return $1679d946d02f36e7$var$noop;
}
function $1679d946d02f36e7$export$a3d85ec9ac026af(queryBoundary) {
    return [];
}



var $g277M = parcelRequire("g277M");


var $1xpoY = parcelRequire("1xpoY");

const $a98f386ac75dbb32$export$2bcc2781b0b77b6c = 3000;
class $a98f386ac75dbb32$var$DataFetcherTimeoutError extends Error {
}
function $a98f386ac75dbb32$export$818f8a0f43a80504() {
    if (window.__SSR_REACT_STREAMING__) return Object.values(window.__dataFetcherForSuspense__ || {}).every((dataFetcher)=>{
        // All query are put into default category. No Suspense should wait for default.
        return !dataFetcher.isPending();
    });
    return true;
}
async function $a98f386ac75dbb32$export$bcf8c46c380b2b4c(promises) {
    return Promise.allSettled(promises).then((results)=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- Existing helper iterates over bounded dataFetcher result arrays for clear error collection.
        const errors = results.filter((result)=>result.status === 'rejected').map((result)=>result.reason);
        // Keep the same interface as Promise.all putting all other errors in otherErrors field
        if (errors.length > 0) {
            // eslint-disable-next-line no-console
            console.error(`Error caught by createDataFetcherForSuspense`, {
                errors: errors.map((error)=>error.message)
            });
            const error = errors[0];
            if (errors.length > 1) error.otherErrors = errors.slice(1);
            throw error;
        }
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- Existing helper iterates over bounded dataFetcher result arrays for clear fulfilled-value collection.
        return results.filter((result)=>result.status === 'fulfilled').map((result)=>result.value);
    });
}
function $a98f386ac75dbb32$export$51ac369f090007c2(dataFetcherName, callback) {
    let promise = null;
    try {
        (0, $g277M.runInQueryBoundary)(dataFetcherName, ()=>{
            promise = $a98f386ac75dbb32$var$runWithFrontendDataFetcherBoundary(dataFetcherName, callback);
        });
    } catch (error) {
        promise = Promise.reject(error);
    }
    promise = promise ?? Promise.resolve();
    if (Array.isArray(promise)) promise = $a98f386ac75dbb32$export$bcf8c46c380b2b4c(promise);
    return promise;
}
function $a98f386ac75dbb32$var$runWithFrontendDataFetcherBoundary(dataFetcherName, callback) {
    /* eslint-disable check-react-ssr-usage/no-react-ssr -- This helper uses the SSR flag as a non-rendering runtime guard. */ if (typeof window === 'undefined') return callback();
    /* eslint-enable check-react-ssr-usage/no-react-ssr */ const previousBoundary = window.__CONFLUENCE_CURRENT_DATA_FETCHER_BOUNDARY__;
    window.__CONFLUENCE_CURRENT_DATA_FETCHER_BOUNDARY__ = dataFetcherName;
    try {
        return callback();
    } finally{
        if (previousBoundary !== undefined) window.__CONFLUENCE_CURRENT_DATA_FETCHER_BOUNDARY__ = previousBoundary;
        else delete window.__CONFLUENCE_CURRENT_DATA_FETCHER_BOUNDARY__;
    }
}
/**
 * Names the requests that were still awaiting a response when the data fetcher timed
 * out — i.e. the actual causes of the timeout. This has to be reported from here: a
 * request that never comes back cannot log anything from the fetch layer.
 *
 * Only requests attributed to a query boundary are reported. A fetch fired outside a
 * boundary is blocked by SSR and never sent, so it is not tracked and never blamed.
 */ function $a98f386ac75dbb32$var$logRequestsInFlightAtTimeout(dataFetcherName, dataFetcherTimeout) {
    const inflightRequests = (0, $1679d946d02f36e7$export$a3d85ec9ac026af)(dataFetcherName);
    if (inflightRequests.length === 0) {
        // No request to blame: the boundary was held up by something other than a tracked
        // fetch — non-fetch async work, a blocked event loop, or a fetch fired outside the
        // boundary that SSR blocked.
        // eslint-disable-next-line no-console
        console.info(`Data fetcher "${dataFetcherName}" timeout at ${dataFetcherTimeout}ms with no request in flight`);
        return;
    }
    const timedOutAt = Date.now();
    for (const { method: method, url: url, startTime: startTime } of inflightRequests)// eslint-disable-next-line no-console
    console.info(`Data fetcher "${dataFetcherName}" timeout caused by: ${method} ${url} (still in flight after ${timedOutAt - startTime}ms)`);
}
function $a98f386ac75dbb32$var$guardTimeout(name, promise) {
    const dataFetcherTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_data_fetcher_timeout', $a98f386ac75dbb32$export$2bcc2781b0b77b6c);
    let timer;
    const timeoutPromise = new Promise((_, reject)=>{
        timer = setTimeout(()=>{
            $a98f386ac75dbb32$var$logRequestsInFlightAtTimeout(name, dataFetcherTimeout);
            reject(new $a98f386ac75dbb32$var$DataFetcherTimeoutError(`Data fetcher "${name}" timeout at ${dataFetcherTimeout}ms`));
        }, dataFetcherTimeout);
    });
    // Cancel the timer once the race is decided, so a data fetcher that finished in time
    // never reports its already settled requests as timeout causes.
    return Promise.race([
        promise,
        timeoutPromise
    ]).finally(()=>clearTimeout(timer));
}
function $a98f386ac75dbb32$export$728d3ea8195fe601(dataFetcherName, promise) {
    let dataResult = null;
    let errorResult = null;
    let promiseState = 'pending';
    const measureName = `ssr-app/prepare/preloadQuery/dataFetcher:${dataFetcherName}`;
    const suspender = new Promise((resolve)=>{
        $a98f386ac75dbb32$var$guardTimeout(dataFetcherName, promise).then((result)=>{
            dataResult = result;
            promiseState = 'resolved';
            resolve();
        }).catch((error)=>{
            errorResult = error;
            promiseState = 'error';
            // When encountered multiple errors, errors other than the first one are stored in otherErrors field.
            const errors = [
                error
            ].concat(error.otherErrors || []);
            for (const err of errors)// eslint-disable-next-line no-console
            console.error(`Data fetcher "${dataFetcherName}" error: ${err.stack || err.message}`);
            resolve();
        });
    });
    return {
        getName () {
            return dataFetcherName;
        },
        isTimeout () {
            return errorResult instanceof $a98f386ac75dbb32$var$DataFetcherTimeoutError;
        },
        getError () {
            return errorResult;
        },
        isPending () {
            return promiseState === 'pending';
        },
        getPromise () {
            return promise;
        },
        read () {
            if (promiseState === 'pending') throw suspender;
            else if (promiseState === 'error') // Data fetcher is a wrapper of preloader. If an error happened we don't want to blow up the tree too early.
            // Return null here to signal the Suspense to continue.
            // The normal error handling in the component will take care of it.
            return null;
            else if (promiseState === 'resolved') return dataResult;
        }
    };
}
module.exports["createDataFetcherForSuspense"] = $a98f386ac75dbb32$export$51ac369f090007c2;

});

parcelRegister("iUV81", function(module, exports) {
parcelRequire("furnK");
var $7WOVi = parcelRequire("7WOVi");


var $4zhNK = parcelRequire("4zhNK");


var $eS4vC = parcelRequire("eS4vC");


var $iV8Fk = parcelRequire("iV8Fk");


var $fyUox = parcelRequire("fyUox");


var $1i2qc = parcelRequire("1i2qc");


var $6mKj3 = parcelRequire("6mKj3");


var $kquO1 = parcelRequire("kquO1");


var $9wGTI = parcelRequire("9wGTI");


var $aOHMQ = parcelRequire("aOHMQ");


var $cvj7x = parcelRequire("cvj7x");


var $7tT2b = parcelRequire("7tT2b");


var $d9tcB = parcelRequire("d9tcB");


var $wPrRK = parcelRequire("wPrRK");


var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");


var $kkLBe = parcelRequire("kkLBe");


var $9ycGg = parcelRequire("9ycGg");


var $lcQ5b = parcelRequire("lcQ5b");


var $8nle6 = parcelRequire("8nle6");


var $gBI6h = parcelRequire("gBI6h");


var $h8QBE = parcelRequire("h8QBE");


var $lt4mJ = parcelRequire("lt4mJ");


var $dhOY2 = parcelRequire("dhOY2");


var $1xpoY = parcelRequire("1xpoY");


var $eSLr0 = parcelRequire("eSLr0");


var $5Rwa0 = parcelRequire("5Rwa0");


var $28DDG = parcelRequire("28DDG");


var $gDMf3 = parcelRequire("gDMf3");

/**
 * @generated SignedSource<<6cb049c04c0f434ff98cbd6cfc8bde7c>>
 * @relayHash bba66764bbafcab2a61fad47a47389c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6138908df8b372f8000648922d74b7db5d0149ba7e1fedd3ae15a92cfdda9329
const $f3a2015b254b5cf4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isUsdSsr"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft"
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "value"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v8 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ], v11 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v12 = {
        "alias": "emojiTitleDraft",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-draft\")"
    }, v13 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "defaultTitleEmoji"
                    }
                ]
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-draft\")"
    }, v15 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "coverPictureWidth"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "color"
    }, v18 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v19 = {
        "args": [
            {
                "kind": "Literal",
                "name": "isDraft",
                "value": false
            }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isCallerPermitted"
            }
        ],
        "storageKey": "contentState(isDraft:false)"
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "USER_FRIENDLY"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "contentStateLastUpdated",
        "plural": false,
        "selections": [
            v8 /*: any*/ 
        ],
        "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }, v21 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v23 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v25 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ]
    }, v26 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                v16 /*: any*/ 
            ]
        }
    ], v27 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "concreteType": "SpaceSettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SpaceSettingsMetadata",
                        "kind": "LinkedField",
                        "name": "customHeaderAndFooter",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": v26 /*: any*/ 
                            },
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "footer",
                                "plural": false,
                                "selections": v26 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v28 = {
        "args": [
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "AvailableContentStates",
        "kind": "LinkedField",
        "name": "availableContentStates",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "customContentStates",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v5 /*: any*/ 
                ]
            },
            {
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "spaceContentStates",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v5 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ]
    }, v29 = {
        "condition": "isUsdSsr",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    }
                ]
            }
        ]
    }, v30 = {
        "alias": "user",
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "userId"
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "displayName"
            },
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "preloadLivePageDataQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "preloadLivePageDataQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v7 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "bba66764bbafcab2a61fad47a47389c3",
            "id": "6138908df8b372f8000648922d74b7db5d0149ba7e1fedd3ae15a92cfdda9329",
            "metadata": {},
            "name": "preloadLivePageDataQuery",
            "operationKind": "query",
            "text": "query preloadLivePageDataQuery($userId:ID,$contentId:ID!,$spaceKey:String!,$isUsdSsr:Boolean!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,status,type,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}},properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth},currentuser{favourited{isFavourite}}},contentState(isDraft:false){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY){value},operations{operation,targetType},subType,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},labels{nodes{id,name}}}},space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}},publicLinkPage(pageId:$contentId)@include(if:$isUsdSsr){pageId,pageStatus},user:confluence_atlassianUser(id:$userId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$f3a2015b254b5cf4$var$node.hash = "fc27c69a6916f3d6cce88a681314b6ab";
var $f3a2015b254b5cf4$export$2e2bcd8739ae039 = $f3a2015b254b5cf4$var$node;






var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");





var $4vyfK = parcelRequire("4vyfK");


var $9OYfw = parcelRequire("9OYfw");


var $7Ndnw = parcelRequire("7Ndnw");


var $8CHHT = parcelRequire("8CHHT");


var $hr9NW = parcelRequire("hr9NW");


var $kDt9L = parcelRequire("kDt9L");


var $cRQNp = parcelRequire("cRQNp");


var $7K6Nt = parcelRequire("7K6Nt");





var $l1kdf = parcelRequire("l1kdf");


var $4trRg = parcelRequire("4trRg");


var $9sGCn = parcelRequire("9sGCn");

const $fcf64901f9c33eb1$var$preloadLivePageDataQuery = (0, $f3a2015b254b5cf4$export$2e2bcd8739ae039);
function $fcf64901f9c33eb1$export$1806ccc2683c4734({ userId: userId, contentId: contentId, spaceKey: spaceKey, cloudId: cloudId }) {
    const preloaders = [];
    // 1. Editor data
    // specific native collab editor queries
    if (!!contentId) {
        const collabDraftPromise = (0, $9OYfw.preloadCollabDraftContent)(contentId, '', false);
        preloaders.push(collabDraftPromise);
        preloaders.push((0, $7K6Nt.preloadMacroDataFromCollabDraft)({
            collabDraftPromise: collabDraftPromise,
            context: {
                contentId: contentId,
                spaceKey: spaceKey || ''
            },
            route: 'live'
        }));
        preloaders.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId, cloudId, false));
        // Get isArchived from cached page data
        const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
        preloaders.push((0, $4trRg.preloadContentMode)({
            contentId: contentId,
            isDraft: false,
            useCache: false,
            isArchived: isArchived
        }));
        preloaders.push((0, $kDt9L.preloadMentionsProvider)());
    }
    preloaders.push(// Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
    (0, $4vyfK.preloadWebItemLocation)({
        contentId: contentId,
        location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
    }), (0, $8CHHT.preloadUseExtensionList)({
        spaceKey: spaceKey || '',
        moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
    }));
    preloaders.push((0, $cRQNp.preloadReadTime)({
        contentId: contentId,
        useCache: false
    }));
    // 2. Unified data
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: $fcf64901f9c33eb1$var$preloadLivePageDataQuery,
            variables: {
                userId: userId,
                contentId: contentId,
                spaceKey: spaceKey,
                isUsdSsr: (0, $9wGTI.fg)('confluence_frontend_usd_ssr')
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "load-live-page"
        }).then((response)=>{
            if (response.data) {
                const nativeCollabVariables = {
                    contentId: contentId,
                    status: [
                        'draft',
                        'current'
                    ]
                };
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $l1kdf.NativeCollabQuery),
                    variables: nativeCollabVariables,
                    data: response.data,
                    __callerPackage__: "load-live-page"
                });
            }
        }),
        ...preloaders
    ]);
}









var $3U5ab = parcelRequire("3U5ab");


var $jsQRz = parcelRequire("jsQRz");


var $1swiX = parcelRequire("1swiX");


var $kM8fE = parcelRequire("kM8fE");


var $dpyxe = parcelRequire("dpyxe");


var $22UVa = parcelRequire("22UVa");


var $1k2r8 = parcelRequire("1k2r8");





var $dd33Q = parcelRequire("dd33Q");

function $44a5ebd8cbdc9221$export$67733ea10e8e9b52(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $dd33Q.default),
        errorPolicy: 'all',
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "create-blank-fabric-page"
    });
}



var $3gyyc = parcelRequire("3gyyc");


var $3HGWr = parcelRequire("3HGWr");


var $cHjca = parcelRequire("cHjca");




const $1ea9096d5494c833$export$28d5266f1c2acac4 = ({ isReactSsr: isReactSsr, isLoggedIn: isLoggedIn, cloudId: cloudId, contentId: contentId, isBlog: isBlog })=>isReactSsr && isLoggedIn && Boolean(cloudId) && Boolean(contentId) && !isBlog && // The existing byline UI owns exposure for this experiment.
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', true);


/**
 * Fire-and-forget warm-up of the third-party connector-config *code chunk* that
 * `useConnectedThirdPartyProductKeys` loads at editor mount (for the
 * `confluence_quick_insert_embeds` experiment).
 *
 * Dynamically importing `@atlassian/rovo-connectors-config/hooks` during the
 * live-page-route preload — before the live-edit editor mounts — means the
 * module and its dependency graph are already fetched, parsed, and evaluated by
 * the time the editor needs them, keeping that JS cost off the hydration
 * critical path.
 *
 * IMPORTANT: this intentionally does NOT call `get3pProductKeys` / issue the
 * connector-config network request. That request is served by a shared
 * stale-while-revalidate cache (`SEARCH_3P_CONFIG`). Firing it here — before the
 * editor mounts — plants a fresh-TTL, still-pending cache entry; the editor-mount
 * hook then sees a "not expired" entry and, because the cache serves the last
 * resolved value during refresh, is handed the previously-persisted (stale)
 * connector list instead of awaiting the fresh response. `useThirdPartyConfig`
 * commits that value once and never re-fetches, so the quick-insert menu gets
 * stuck showing a stale/partial set of apps (e.g. only Figma). Leaving the
 * network request to the editor-mount hook keeps it as the first cache caller,
 * so it awaits fresh data.
 *
 * Client-only: the underlying module assumes a browser environment, so callers
 * must not invoke this during SSR.
 */ 
const $9f5c0425db90797e$export$d8f603dd70536f4f = ()=>{
    (parcelRequire("1QSQz")).catch(()=>{
    // Best-effort chunk warm-up only. Any failure is swallowed so it can never
    // affect the route transition; the editor-mount hook loads it on demand.
    });
};


const $9ca0f3e234cc6f7f$export$b30d199cd0e05754 = async (match, url)=>{
    const { isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, environment: environment } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    // Warm byline SSR state (mirrors preloadViewPageRoute) to avoid the live-page post-paint flash.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isReactSsr = Boolean(undefined);
    const shouldPreloadBylineConnections = (0, $1ea9096d5494c833$export$28d5266f1c2acac4)({
        isReactSsr: isReactSsr,
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        contentId: contentId,
        isBlog: isBlog
    });
    // Invoked exactly once per request (see streaming/non-streaming scheduling below).
    const createBylinePreloadTasks = ()=>shouldPreloadBylineConnections ? [
            (0, $3HGWr.preloadIncomingLinksSsrState)({
                cloudId: cloudId,
                contentId: contentId,
                route: 'live'
            }),
            (0, $cHjca.preloadOutboundBylineSsrState)(contentId)
        ] : [];
    if ((0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true)) {
        const preloadPromise = (0, $fcf64901f9c33eb1$export$1806ccc2683c4734)({
            userId: userId,
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId
        });
        tasks.push((0, $3gyyc.isSSRStreaming)() ? (0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>[
                preloadPromise,
                ...createBylinePreloadTasks()
            ]) : preloadPromise);
    } else {
        const preloadPromise = (0, $kkLBe.prepareGuardExceptionTask)('EditorData', ()=>(0, $cvj7x.preloadEditorData)({
                spaceKey: spaceKey,
                contentId: contentId,
                shouldPreloadMentionsProvider: true,
                useCache: false,
                cloudId: cloudId,
                isBlog: isBlog,
                isLivePage: true
            }));
        tasks.push((0, $3gyyc.isSSRStreaming)() ? (0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>[
                preloadPromise,
                ...createBylinePreloadTasks()
            ]) : preloadPromise);
    }
    // Non-streaming SSR awaits every task before render, so top-level byline tasks suffice.
    if (!(0, $3gyyc.isSSRStreaming)()) tasks.push(...createBylinePreloadTasks());
    // Warm the third-party connector-config *code chunk* off the editor's critical
    // path so `useConnectedThirdPartyProductKeys` has its module ready at editor
    // mount. This intentionally does NOT issue the connector-config network request
    // — doing so here plants a stale-while-revalidate cache entry that the
    // editor-mount hook then serves stale from, wedging the quick-insert menu on a
    // partial app list. See preloadConnectedThirdPartyConfig for the full rationale.
    // Client-only, scoped to the `confluence_quick_insert_embeds` experiment cohort.
    // Read without exposure — the authoritative exposure fires inside the provider
    // builder at editor mount. Fire-and-forget: intentionally not pushed into `tasks`.
    if ((0, $6mKj3.UNSAFE_expValNoExposure)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control') (0, $9f5c0425db90797e$export$d8f603dd70536f4f)();
    // 1. Byline and possibly content prerequisites
    tasks.push((0, $7WOVi.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        username: username,
        edition: edition,
        isPrevEditRoute: false,
        useNewContentTopper: true,
        isLivePageRoute: true,
        isContentTypePublicLinkEligible: true
    }).then((resultOrHasErrorBoolean)=>{
        if (typeof resultOrHasErrorBoolean === 'boolean') {
            if (resultOrHasErrorBoolean) return (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey);
        } else {
            const { results: results, hasErrors: hasErrors } = resultOrHasErrorBoolean;
            if (!hasErrors) return results;
            return (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey);
        }
    }), (0, $lt4mJ.preloadLegacyBridge)({
        contentId: contentId,
        isBlog: isBlog
    }));
    if (!(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true)) tasks.push((0, $gBI6h.preloadPageStatusQuery)(contentId));
    // 2. Page title
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceKey
    }));
    // 2a. Space enabled content types
    if (spaceKey) tasks.push((0, $44a5ebd8cbdc9221$export$67733ea10e8e9b52)(spaceKey));
    // 3. Space details
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && tasks.push((0, $8nle6.preloadSpaceDetail)(spaceKey));
    if ((0, $3gyyc.isSSRStreaming)()) {
        tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
            const contentTypesHeaderPreloadTasks = [];
            // 4. Content types header (object header)
            contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
            // (No need to call preloadPageRestrictionsQuery() here; it will be called by
            //  preloadContentHeader() above)
            // 4a. Unified Share and Restrict Button
            if (!(0, $9wGTI.fg)('confluence_vp_access_frag_reader')) {
                if (!(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
            }
            return contentTypesHeaderPreloadTasks;
        }));
        // 5. Navigation and page tree
        if (shouldPreloadNavigation) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
            return (0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog);
        }));
    } else {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // (No need to call preloadPageRestrictionsQuery() here; it will be called by
        //  preloadContentHeader() above)
        if (!(0, $9wGTI.fg)('confluence_vp_access_frag_reader')) {
            if (!(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
        }
        if (shouldPreloadNavigation) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog));
    }
    // 6. Inline Comments
    if (match?.query.focusedCommentId) tasks.push((0, $aOHMQ.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    // 7. Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // TODO: delete
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        tasks.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    // 10. Stuff only needed for initial load
    tasks.push(// We only refresh token when it is about to expire.
    (0, $1i2qc.preloadMediaToken)(contentId, cloudId));
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey);
    // Preload onboarding state for live page
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) tasks.push((0, $1k2r8.preloadAllOnboardingState)());
    if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
        contentId: contentId,
        locations: [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ]
    }));
    else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    // 11. Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('ai-floating-context-menu', ()=>(0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog)));
    // 12. Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // 14. Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor') || (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('object-comments', ()=>[
            // 15. Preload footer comments
            (0, $3U5ab.preloadObjectComments)(contentId),
            // Preload add comment permission check for the redesigned footer comment experience
            (0, $jsQRz.preloadAddCommentPermissionCheck)(contentId, [
                'draft',
                'current'
            ])
        ]));
    // 17. Recommendations
    // Only preload recommendations for authenticated users (knowledge_discovery service requires auth)
    if (isLoggedIn) {
        const recommendationsTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_recommendation_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        tasks.push((0, $wPrRK.slowQueryGuard)('preloadEndOfPageRecommendation', ()=>{
            return (0, $dhOY2.preloadEndOfPageRecommendation)({
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: isBlog ? 'blogpost' : 'page',
                cloudId: cloudId
            });
        }, recommendationsTimeout));
        if (!isBlog && // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
        (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_3p_in_related_content', 'shouldEvaluate', true)) tasks.push((0, $kquO1.preloadOutgoingLinks)(contentId));
    }
    //18. Preload Smart Create Feedback Banner
    tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    //19. Add Onboarding State for revamped bpqa
    tasks.push((0, $h8QBE.preloadLandUsersInEditorWithRevampedBpqa)());
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
module.exports["preloadLivePageRoute"] = $9ca0f3e234cc6f7f$export$b30d199cd0e05754;

});

parcelRegister("furnK", function(module, exports) {
$parcel$export(module.exports, "preloadContentHeader", () => (parcelRequire("7WOVi")).preloadContentHeader);

var $7WOVi = parcelRequire("7WOVi");


});

parcelRegister("3D1KL", function(module, exports) {
/**
 * @generated SignedSource<<e5b98efc5915c7510e361cd61db1fcea>>
 * @relayHash 28437bd051bb517523bd8bb255843261
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 85b3986006d63f89d3e19402da0bff784515f638a958aa69ec615c07da730c60
const $11a6e253e07228af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "spaceHomepage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "embedded"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "collabService"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "28437bd051bb517523bd8bb255843261",
            "id": "85b3986006d63f89d3e19402da0bff784515f638a958aa69ec615c07da730c60",
            "metadata": {},
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadEditButtonWithSpaceKeyQuery($spaceKey:String!){space(key:$spaceKey){id,key},spaceHomepage(spaceKey:$spaceKey){id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType}}"
        }
    };
}();
$11a6e253e07228af$var$node.hash = "d44363b7caa9c4f4861198079067c51c";
var $11a6e253e07228af$export$2e2bcd8739ae039 = $11a6e253e07228af$var$node;



var $fEmGS = parcelRequire("fEmGS");


var $dYU3e = parcelRequire("dYU3e");


var $4YBSq = parcelRequire("4YBSq");

const $da246eeeea807732$var$preloadEditButtonWithSpaceKeyQuery = (0, $11a6e253e07228af$export$2e2bcd8739ae039);
function $da246eeeea807732$export$ba72223e933caac5({ spaceKey: spaceKey, contentId: contentId = '' }) {
    // spaceKey will always be passed for both space overviews and view pages, but contentId is
    // distinct for the latter
    if (spaceKey && !contentId) return (0, $dYU3e.query)({
        query: $da246eeeea807732$var$preloadEditButtonWithSpaceKeyQuery,
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "edit-button"
    }).then(({ data: data })=>{
        if (data?.spaceHomepage?.id) (0, $fEmGS.writeQueryInterop)({
            query: (0, $4YBSq.default),
            variables: {
                contentId: data?.spaceHomepage?.id
            },
            data: {
                content: data?.spaceHomepage ? {
                    nodes: [
                        {
                            ...data.spaceHomepage,
                            space: data?.space || null
                        }
                    ],
                    // @ts-ignore
                    __typename: 'PaginatedContentListWithChild'
                } : null
            },
            __callerPackage__: "edit-button"
        });
    });
    return (0, $dYU3e.query)({
        query: (0, $4YBSq.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "edit-button"
    });
}
module.exports["preloadEditButton"] = $da246eeeea807732$export$ba72223e933caac5;

});

parcelRegister("5rHrW", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $kwDQA = parcelRequire("kwDQA");

const $e023a6d7dfd4d02c$export$1ca7520ec7e7778c = (contentId)=>(0, $dYU3e.query)({
        query: (0, $kwDQA.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "confluence-analytics"
    });
module.exports["preloadContentAnalyticsViewers"] = $e023a6d7dfd4d02c$export$1ca7520ec7e7778c;

});

parcelRegister("3Tnjq", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $7tFTF = parcelRequire("7tFTF");


var $gYXuI = parcelRequire("gYXuI");

function $9c352464269d89b9$export$112a35af77c910a7(contentId, includeAncestors) {
    return (0, $dYU3e.query)({
        query: (0, $7tFTF.default),
        variables: {
            contentId: contentId,
            status: (0, $gYXuI.ALLOWED_CONTENT_STATUSES),
            includeAncestors: includeAncestors
        },
        // Preloaders are called both on server at initial load AND transition on client-side.
        // On server-side it doesn't matter fetch policy because we only gonna request once.
        // On client-side it must be network-only to get fresh data.
        fetchPolicy: 'network-only',
        __callerPackage__: "page-restrictions-context"
    });
}
module.exports["preloadPageRestrictionsQuery"] = $9c352464269d89b9$export$112a35af77c910a7;

});

parcelRegister("4zhNK", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $568fA = parcelRequire("568fA");


var $6mKj3 = parcelRequire("6mKj3");

function $391f3ac88e545944$export$9da8ccc82535deaf(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $568fA.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "content-types-header"
    }).then((result)=>{
        if ((0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) {
            const contentIsRestrictedBySpacePermissions = result?.errors?.find((e)=>e?.path?.[0] === 'content' && e?.message?.includes('Space is restricted'));
            window['__SPACE_RESTRICTED_ERROR__'] = contentIsRestrictedBySpacePermissions ? contentId : null;
        }
        return result;
    });
}
module.exports["preloadContentTypesHeader"] = $391f3ac88e545944$export$9da8ccc82535deaf;

});

parcelRegister("iV8Fk", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lPNkm = parcelRequire("lPNkm");

function $c05bed830e3069e7$export$87b3e636f25ecc1e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $lPNkm.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "custom-header-footer"
    });
}
module.exports["preloadCustomHeaderAndFooter"] = $c05bed830e3069e7$export$87b3e636f25ecc1e;

});

parcelRegister("aOHMQ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $k5dl6 = parcelRequire("k5dl6");

function $e0d84e65a2045ce5$export$2d90e27e1463a533(commentId, contentId) {
    return (0, $dYU3e.query)({
        query: (0, $k5dl6.default),
        variables: {
            commentId: commentId,
            contentId: contentId
        },
        __callerPackage__: "inline-comments"
    });
}
module.exports["preloadFocusedInlineComment"] = $e0d84e65a2045ce5$export$2d90e27e1463a533;

});

parcelRegister("7tT2b", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");




const $613de45c1bdfbc89$export$2e09de8d75f18000 = ({ accessStatus: accessStatus, isLoggedIn: isLoggedIn })=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};











const $9f6d8fef975ab9be$export$3380c638fe82cae3 = (accessStatus)=>{
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};



var $5CUwy = parcelRequire("5CUwy");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");


var $dHiKK = parcelRequire("dHiKK");


var $i8Ofl = parcelRequire("i8Ofl");


var $c5JFM = parcelRequire("c5JFM");

async function $147f74e0bc8a9b5a$export$da2224e4c5ce5572({ cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, userId: userId, environment: environment }) {
    const isLoomDisabled = (0, $613de45c1bdfbc89$export$2e09de8d75f18000)({
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn
    });
    const isBetaEnabled = (0, $9f6d8fef975ab9be$export$3380c638fe82cae3)(accessStatus);
    const [isLoomEntryPointsEnabledResult, licensedProductsQueryResult] = await Promise.allSettled([
        $147f74e0bc8a9b5a$var$preloadIsLoomEntryPointsEnabledQuery(cloudId, activationId, accessStatus),
        (0, $dYU3e.query)({
            query: (0, $2gAEP.default),
            __callerPackage__: "loom-utils"
        })
    ]);
    const loomConfiguration = isLoomEntryPointsEnabledResult.status === 'fulfilled' ? isLoomEntryPointsEnabledResult.value : {
        isLoomEntryPointsEnabled: true
    };
    const isLoomEntryPointsEnabled = loomConfiguration?.isLoomEntryPointsEnabled;
    const meetingRecorderEligibility = loomConfiguration?.meetingRecorderEligibility;
    const setPreloadedEntryPoint = (variant)=>{
        window['__SSR_LOOM_ENTRY_POINT__'] = meetingRecorderEligibility ? {
            ...variant,
            meetingRecorderEligibility: meetingRecorderEligibility
        } : variant;
    };
    if (window['__SSR_LOOM_ENTRY_POINT__']) return Promise.resolve();
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        setPreloadedEntryPoint({
            entryPointVariant: 'DISABLED'
        });
        return Promise.resolve();
    }
    if (isBetaEnabled) {
        setPreloadedEntryPoint({
            entryPointVariant: 'BETA'
        });
        return Promise.resolve();
    }
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) {
        setPreloadedEntryPoint({
            entryPointVariant: 'DISABLED'
        });
        return Promise.resolve();
    }
    if (licensedProductsQueryResult.status === 'fulfilled') {
        const licenseQueryData = licensedProductsQueryResult.value.data;
        const isTenantLicensed = licenseQueryData?.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        const loomTenantProvisionStatus = isTenantLicensed ? (0, $5CUwy.LoomTenantProvisionStatus).PROVISIONED : (0, $5CUwy.LoomTenantProvisionStatus).NOT_PROVISIONED;
        if (loomTenantProvisionStatus === (0, $5CUwy.LoomTenantProvisionStatus).NOT_PROVISIONED) {
            setPreloadedEntryPoint({
                entryPointVariant: 'CROSS_FLOW'
            });
            // if entry point variant is "CROSS_FLOW" but FF is enabled, return "DISABLED"
            if ((0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) setPreloadedEntryPoint({
                entryPointVariant: 'DISABLED'
            });
            return Promise.resolve();
        }
    } else {
        setPreloadedEntryPoint({
            entryPointVariant: 'CROSS_FLOW',
            error: true
        });
        // if entry point variant is "CROSS_FLOW" but FF is enabled, return "DISABLED"
        if ((0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) setPreloadedEntryPoint({
            entryPointVariant: 'DISABLED'
        });
        return Promise.resolve();
    }
    // tenant is provisioned at this point, switch to "CROSS_JOIN" and attempt permissions check
    setPreloadedEntryPoint({
        entryPointVariant: 'CROSS_JOIN'
    });
    // PERMISSIONS CHECK
    const loomUserPermissionStatus = (0, $6mKj3.isExperimentEnabled)('confluence_frontend_loom_agg_perm_check_exp') ? await $147f74e0bc8a9b5a$var$preloadLoomUserPermissionStatus(cloudId, userId, activationId) : await (0, $5CUwy.getLoomUserLegacyPermissionStatus)(cloudId, userId, environment);
    if (loomUserPermissionStatus === (0, $5CUwy.LoomUserPermissionStatus).NOT_PERMITTED) // if not permitted, entryPointVariant is already 'CROSS_JOIN' so resolve promise
    return Promise.resolve();
    if (loomUserPermissionStatus === (0, $5CUwy.LoomUserPermissionStatus).ERROR) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (Boolean(undefined) && Boolean(undefined)) window['__SSR_LOOM_ENTRY_POINT__'] = null;
        else setPreloadedEntryPoint({
            entryPointVariant: 'CROSS_JOIN',
            error: true
        });
        return Promise.resolve();
    }
    setPreloadedEntryPoint({
        entryPointVariant: 'CO_USE'
    });
    return Promise.resolve();
}
const $147f74e0bc8a9b5a$var$preloadLoomUserPermissionStatus = async (cloudId, userId, activationId)=>{
    if (!userId) return (0, $5CUwy.LoomUserPermissionStatus).NOT_PERMITTED;
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, hasErrors: hasErrors } = await (0, $dYU3e.queryAgg)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            context: {
                headers: {
                    ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
                }
            },
            errorPolicy: 'all',
            __callerPackage__: "loom-utils"
        });
        if (hasErrors) return (0, $5CUwy.LoomUserPermissionStatus).ERROR;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? (0, $5CUwy.LoomUserPermissionStatus).PERMITTED : (0, $5CUwy.LoomUserPermissionStatus).NOT_PERMITTED;
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return (0, $5CUwy.LoomUserPermissionStatus).ERROR;
    }
};
const $147f74e0bc8a9b5a$var$preloadIsLoomEntryPointsEnabledQuery = async (cloudId, activationId, accessStatus)=>{
    const shouldSkip = !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS);
    if (shouldSkip) return;
    const includeMeetingRecorderEligibility = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
    const { data: data, hasErrors: hasErrors } = await (0, $dYU3e.queryAgg)({
        query: (0, $dHiKK.default),
        variables: {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        errorPolicy: 'all',
        __callerPackage__: "loom-utils"
    });
    if (hasErrors) return {
        isLoomEntryPointsEnabled: true
    };
    return {
        isLoomEntryPointsEnabled: data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled,
        meetingRecorderEligibility: includeMeetingRecorderEligibility ? {
            meetingRecordingsAvailable: data?.loom_settings?.meetingRecordingsAvailable,
            meetingNotesEligible: data?.loom_settings?.meetingNotesEligible,
            connectedCalendars: data?.loom_connectedCalendars
        } : undefined
    };
};
module.exports["preloadRecordLoomButton"] = $147f74e0bc8a9b5a$export$da2224e4c5ce5572;

});

parcelRegister("kkLBe", function(module, exports) {

var $9WAeG = parcelRequire("9WAeG");

const $b973d0b9aa217224$export$14621363d65ac00 = [];
const $b973d0b9aa217224$export$53a56b40d8963332 = async (queryName, task)=>{
    const wrappedTask = (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/guardException:${queryName}`, task);
    $b973d0b9aa217224$export$14621363d65ac00.push(wrappedTask);
    return wrappedTask;
};
module.exports["prepareGuardExceptionTask"] = $b973d0b9aa217224$export$53a56b40d8963332;

});

parcelRegister("9ycGg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8wyJO = parcelRequire("8wyJO");

function $8ac918fba64f5f59$export$de4621222fb13b43({ pageId: pageId, containerId: containerId }) {
    const { query: reactionsQuery, queryVariables: queryVariables } = (0, $8wyJO.getReactionsQueryInfo)(false, pageId, containerId);
    return (0, $dYU3e.query)({
        query: reactionsQuery,
        variables: queryVariables,
        __callerPackage__: "reactions"
    });
}
module.exports["preloadPageReactions"] = $8ac918fba64f5f59$export$de4621222fb13b43;

});

parcelRegister("lcQ5b", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $9inwL = parcelRequire("9inwL");


var $4uNpa = parcelRequire("4uNpa");

const $dbc6a71de2a3ffc4$var$preloadContentPrerequisitesQuery = (contentId, spaceKey, status)=>(0, $dYU3e.query)({
        query: (0, $9inwL.default),
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            missingSpaceKey: !spaceKey,
            spaceKey: spaceKey,
            ...status ? {
                status: status
            } : {}
        },
        __callerPackage__: "content-prerequisites"
    });
const $dbc6a71de2a3ffc4$var$preloadContentRedirectQuery = ({ contentId: contentId, versionOverride: versionOverride })=>(0, $dYU3e.query)({
        query: (0, $4uNpa.default),
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            versionOverride: versionOverride
        },
        __callerPackage__: "content-prerequisites"
    });
const $dbc6a71de2a3ffc4$export$22caa92111fd8d1d = (contentId, spaceKey, namedArgs)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $dbc6a71de2a3ffc4$var$preloadContentPrerequisitesQuery(contentId, spaceKey, namedArgs?.status),
        $dbc6a71de2a3ffc4$var$preloadContentRedirectQuery({
            contentId: contentId,
            ...namedArgs
        })
    ]);
};
module.exports["preloadContentPrerequisites"] = $dbc6a71de2a3ffc4$export$22caa92111fd8d1d;

});

parcelRegister("gBI6h", function(module, exports) {
/**
 * @generated SignedSource<<2c6eb1111fab3cae282abf53159ed228>>
 * @relayHash 36fc33b8824e2e4792b3cf3cf3aebfb6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c7487ad22d00750f24223e1a79378561d3785a6cbff5ca92abdd6c24d5b6e42
const $bcb0e8888b3b7f05$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadPageStatusQueryDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadPageStatusQueryDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "36fc33b8824e2e4792b3cf3cf3aebfb6",
            "id": "1c7487ad22d00750f24223e1a79378561d3785a6cbff5ca92abdd6c24d5b6e42",
            "metadata": {},
            "name": "preloadPageStatusQueryDataQuery",
            "operationKind": "query",
            "text": "query preloadPageStatusQueryDataQuery($contentId:ID!){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$bcb0e8888b3b7f05$var$node.hash = "0d6c073c14eeaf92de7a0a60300e5d15";
var $bcb0e8888b3b7f05$export$2e2bcd8739ae039 = $bcb0e8888b3b7f05$var$node;



var $dYU3e = parcelRequire("dYU3e");

const $8d43735f3bb06581$var$PreloadPageStatusQuery = (0, $bcb0e8888b3b7f05$export$2e2bcd8739ae039);
function $8d43735f3bb06581$export$ad9216fbfde1ea82(contentId) {
    return (0, $dYU3e.query)({
        query: $8d43735f3bb06581$var$PreloadPageStatusQuery,
        variables: {
            contentId: contentId
        },
        __callerPackage__: "query-preloaders-common"
    });
}
module.exports["preloadPageStatusQuery"] = $8d43735f3bb06581$export$ad9216fbfde1ea82;

});

parcelRegister("h8QBE", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $dBcar = parcelRequire("dBcar");


var $8Z78B = parcelRequire("8Z78B");

const $0b2e6fb8cfab3270$export$6554070330cad05b = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $dBcar.LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA))
        },
        __callerPackage__: "onboarding-helpers"
    });
};
module.exports["preloadLandUsersInEditorWithRevampedBpqa"] = $0b2e6fb8cfab3270$export$6554070330cad05b;

});

parcelRegister("lt4mJ", function(module, exports) {

var $98Fgg = parcelRequire("98Fgg");


var $dYU3e = parcelRequire("dYU3e");

/**
 * see next/packages/view-page/src/LegacyBridgeNextInner.tsx for the query usage
 */ const $66b1e969a9746f31$var$PreloadLegacyBridgeQuery = (0, $98Fgg.default);
async function $66b1e969a9746f31$export$aca348026d93fa81({ contentId: contentId, isBlog: isBlog }) {
    if (!contentId) return;
    return (0, $dYU3e.query)({
        query: $66b1e969a9746f31$var$PreloadLegacyBridgeQuery,
        variables: {
            contentId: contentId,
            isBlog: isBlog
        },
        errorPolicy: 'all',
        __callerPackage__: "query-preloaders-common"
    });
}
module.exports["preloadLegacyBridge"] = $66b1e969a9746f31$export$aca348026d93fa81;

});

parcelRegister("dhOY2", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $2HQyh = parcelRequire("2HQyh");


var $2rapj = parcelRequire("2rapj");


var $ky8L5 = parcelRequire("ky8L5");

const $3b0bcd4ef0479f8b$var$NOOP_RESULT = {
    data: undefined,
    hasErrors: false
};
function $3b0bcd4ef0479f8b$export$ae057a53ebe0d3cd({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, cloudId: cloudId }) {
    // Treatment preloads the TWG query (not cc-smarts) to prime the cache for the
    // client consumers. NO-EXPOSURE reader: this runs during SSR for every view-page
    // load, so exposure is logged at the loader instead (not here).
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_eop_recs_twg_source_exp', 'isEnabled', true)) {
        // Variables must be byte-identical to the client hook for the cache-first hit.
        if (!(0, $ky8L5.isTwgSupportedContentType)(contentType) || !cloudId || !contentId) return Promise.resolve($3b0bcd4ef0479f8b$var$NOOP_RESULT);
        return (0, $dYU3e.queryAgg)({
            query: (0, $2rapj.default),
            variables: {
                cypherQuery: (0, $ky8L5.buildTwgRecsCypher)((0, $ky8L5.buildTwgContentAri)(cloudId, contentId, contentType)),
                first: (0, $ky8L5.MAX_TWG_RECS),
                key: spaceKey,
                keyString: spaceKey
            },
            context: {
                headers: {
                    'X-Query-Context': (0, $ky8L5.buildTwgQueryContext)(cloudId)
                }
            },
            __callerPackage__: "page-recommendations"
        });
    }
    return (0, $dYU3e.query)({
        query: (0, $2HQyh.default),
        variables: {
            type: contentType,
            id: contentId,
            exp: (0, $6mKj3.expVal)('cc_ai_discovery_linked_pages_on_related_pages', 'experience', 'end_of_page_v5'),
            key: spaceKey,
            keyString: spaceKey
        },
        __callerPackage__: "page-recommendations"
    });
}
module.exports["preloadEndOfPageRecommendation"] = $3b0bcd4ef0479f8b$export$ae057a53ebe0d3cd;

});

parcelRegister("5Rwa0", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $eq95w = parcelRequire("eq95w");

function $9736b8942eb99a2e$export$fe7f338d767a5e6b(variables) {
    return (0, $dYU3e.query)({
        query: (0, $eq95w.default),
        variables: variables,
        __callerPackage__: "web-panel-location"
    });
}
const $9736b8942eb99a2e$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
function $9736b8942eb99a2e$export$369ae2eed9f7124({ locations: locations, contentId: contentId = null, spaceKey: spaceKey = null }) {
    const uniqueLocations = $9736b8942eb99a2e$var$getUniqueLocations(locations);
    if (uniqueLocations.length === 0) return Promise.resolve({
        data: undefined
    });
    if (uniqueLocations.length === 1) return $9736b8942eb99a2e$export$fe7f338d767a5e6b({
        location: uniqueLocations[0],
        ...contentId != null ? {
            contentId: contentId
        } : {},
        ...spaceKey != null ? {
            spaceKey: spaceKey
        } : {}
    });
    const variables = {
        location: null,
        locations: uniqueLocations,
        ...contentId != null ? {
            contentId: contentId
        } : {},
        ...spaceKey != null ? {
            spaceKey: spaceKey
        } : {}
    };
    return (0, $dYU3e.query)({
        query: (0, $eq95w.default),
        variables: variables,
        __callerPackage__: "web-panel-location"
    }).then((result)=>{
        const { data: data } = result;
        if (data?.webPanels != null) {
            const panelsByLocation = new Map();
            data.webPanels.forEach((panel)=>{
                if (panel?.location) {
                    const panels = panelsByLocation.get(panel.location) ?? [];
                    panels.push(panel);
                    panelsByLocation.set(panel.location, panels);
                }
            });
            uniqueLocations.forEach((location)=>{
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $eq95w.default),
                    variables: {
                        location: location,
                        ...contentId != null ? {
                            contentId: contentId
                        } : {},
                        ...spaceKey != null ? {
                            spaceKey: spaceKey
                        } : {}
                    },
                    data: {
                        webPanels: panelsByLocation.get(location) ?? []
                    },
                    __callerPackage__: "web-panel-location"
                });
            });
        }
        return result;
    });
}
module.exports["preloadWebPanelLocation"] = $9736b8942eb99a2e$export$fe7f338d767a5e6b;
module.exports["preloadWebPanelLocations"] = $9736b8942eb99a2e$export$369ae2eed9f7124;

});

parcelRegister("28DDG", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8G3G6 = parcelRequire("8G3G6");

function $83b608e86b4ad2f7$export$6f71137e78694699(contentId, isBlog) {
    const contentType = isBlog ? 'BLOGPOST' : 'PAGE';
    return (0, $dYU3e.query)({
        query: (0, $8G3G6.default),
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        __callerPackage__: "ai-floating-context-menu"
    });
}
module.exports["preloadAIFloatingContextMenu"] = $83b608e86b4ad2f7$export$6f71137e78694699;

});

parcelRegister("gDMf3", function(module, exports) {
/**
 * @generated SignedSource<<46342085946da246426d0df4033f772c>>
 * @relayHash 7238294bac8d5857c56c3c4ea7c78b36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e07f6094c93b3b1c879faf4cc355f0fb438eb7906e827c5ff0dcff14366a812
const $df54146d5a704aad$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v2 = [
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "spaceHomepage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                v1 /*: any*/ 
            ],
            "concreteType": "PublicLinkPage",
            "kind": "LinkedField",
            "name": "confluence_publicLinkSpaceHomePage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "pageStatus"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7238294bac8d5857c56c3c4ea7c78b36",
            "id": "3e07f6094c93b3b1c879faf4cc355f0fb438eb7906e827c5ff0dcff14366a812",
            "metadata": {},
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "operationKind": "query",
            "text": "query preloadShareAndRestrictButtonQuerySpaceOverviewQuery($cloudId:ID!,$spaceKey:String!){spaceHomepage(spaceKey:$spaceKey){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},confluence_publicLinkSpaceHomePage(cloudId:$cloudId,spaceKey:$spaceKey)@optIn(to:\"AskInCcApiPlatformBeforeUsing\"){pageId,pageStatus}}"
        }
    };
}();
$df54146d5a704aad$var$node.hash = "d2db11b68f255ee089316a1bfb1d4b92";
var $df54146d5a704aad$export$2e2bcd8739ae039 = $df54146d5a704aad$var$node;



var $fEmGS = parcelRequire("fEmGS");


var $xwvlW = parcelRequire("xwvlW");


var $dYU3e = parcelRequire("dYU3e");


var $38Ncj = parcelRequire("38Ncj");

const $ef82cacd2239f1cb$export$bc3279977acfeb66 = (0, $df54146d5a704aad$export$2e2bcd8739ae039);
function $ef82cacd2239f1cb$var$transformSpaceHomepageData(data) {
    return {
        singleContent: data?.spaceHomepage || null,
        publicLinkPage: data?.confluence_publicLinkSpaceHomePage || null
    };
}
async function $ef82cacd2239f1cb$export$be8d82af5bf2b0e(contentId, spaceKey) {
    const { isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    if (!contentId && spaceKey) {
        const result = await (0, $dYU3e.query)({
            query: $ef82cacd2239f1cb$export$bc3279977acfeb66,
            variables: {
                cloudId: cloudId,
                spaceKey: spaceKey
            },
            errorPolicy: 'all',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (result.hasErrors) return result;
        const data = result.data;
        const homepageId = data?.spaceHomepage?.id;
        if (!homepageId) return;
        const transformedData = $ef82cacd2239f1cb$var$transformSpaceHomepageData(data);
        // Prime Apollo cache so the button component finds its data already cached
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $38Ncj.default),
            variables: {
                contentId: homepageId,
                isContentTypePublicLinkEligible: true
            },
            data: transformedData,
            __callerPackage__: "share-and-restrict-dialog"
        });
        return;
    }
    if (contentId) {
        const result = await (0, $dYU3e.query)({
            query: (0, $38Ncj.default),
            variables: {
                contentId: contentId,
                isContentTypePublicLinkEligible: true
            },
            errorPolicy: 'all',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (result.hasErrors) return result;
        return;
    }
    // eslint-disable-next-line no-console
    console.error('Either contentId or spaceKey must be provided');
    return;
}
module.exports["preloadShareAndRestrictButtonQuery"] = $ef82cacd2239f1cb$export$be8d82af5bf2b0e;

});

parcelRegister("3U5ab", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $9wGTI = parcelRequire("9wGTI");


var $1ydBT = parcelRequire("1ydBT");


var $MJaSd = parcelRequire("MJaSd");

const $c1e059434ab4dff9$export$b4767927145ffa8f = async (contentId)=>{
    if (!contentId) return Promise.resolve({
        data: null
    });
    // Clear the cache BEFORE load
    // Don't clear in SSR - if the preload times out there we won't have a way to overwrite this
    try {
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $1ydBT.default),
            variables: (0, $MJaSd.buildPreloadObjectCommentsQueryVariables)(contentId, (0, $9wGTI.fg)('confluence_vp_conversation_data_frag_reader')),
            data: {
                comments: {
                    nodes: [],
                    totalCount: (0, $MJaSd.PRELOAD_LOADING_FLAG),
                    __typename: 'PaginatedCommentList'
                }
            },
            __callerPackage__: "object-comments"
        });
    } catch  {
    // Do nothing, this is expected if the query is not in the cache
    }
    // Use query from preloader-tools to trigger the network-only query
    // This will fetch the data and update the cache automatically
    // The hook query will pick up the changes from cache
    const result = await (0, $dYU3e.query)({
        query: (0, $1ydBT.default),
        variables: (0, $MJaSd.buildPreloadObjectCommentsQueryVariables)(contentId, (0, $9wGTI.fg)('confluence_vp_conversation_data_frag_reader')),
        fetchPolicy: 'network-only',
        __callerPackage__: "object-comments"
    });
    // Return in the same format as queryInterop for compatibility
    return {
        data: result.data
    };
};
module.exports["preloadObjectComments"] = $c1e059434ab4dff9$export$b4767927145ffa8f;

});

parcelRegister("jsQRz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");

/**
 * @generated SignedSource<<0ca0486328baf1fc83c5a63423866e3c>>
 * @relayHash 690a768cd10ff2fe00b9f55894124315
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d28ca435bce3308db3c80cfadbc4de93549d50bca0fbcb8d3a17dd7c843c2cb
const $53e8528240c564b4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "690a768cd10ff2fe00b9f55894124315",
            "id": "1d28ca435bce3308db3c80cfadbc4de93549d50bca0fbcb8d3a17dd7c843c2cb",
            "metadata": {},
            "name": "PermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query PermissionCheckAddCommentQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$53e8528240c564b4$var$node.hash = "960ae1c1af2a4defe66e75f7638a978c";
var $53e8528240c564b4$export$2e2bcd8739ae039 = $53e8528240c564b4$var$node;


function $23dc12875344febc$export$d9630e5941a0faf1(contentId, status = [
    'draft',
    'current'
]) {
    return (0, $dYU3e.query)({
        query: (0, $53e8528240c564b4$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId,
            status: status
        },
        __callerPackage__: "comments-panel-queries"
    });
}
module.exports["preloadAddCommentPermissionCheck"] = $23dc12875344febc$export$d9630e5941a0faf1;

});

parcelRegister("1swiX", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $2da08b1abbbb9472$export$914b80ef7b05e6be = (match)=>Boolean(match?.query.embedded || match?.query.parentProduct);
const $2da08b1abbbb9472$export$b04bf7ed076c9866 = (feature, match)=>match?.query.initialAllowedFeatures?.indexOf(feature) || match?.query.initialAllowedFeatures === 'all';
const $2da08b1abbbb9472$export$204da773c0191bd8 = (match)=>{
    const username = match?.query.username;
    if (!username) return '';
    if (Array.isArray(username)) return username[0];
    return username;
};
const $2da08b1abbbb9472$export$96d52eb4c89741b4 = (previousMatch)=>previousMatch?.name === (0, $1NBp8.HOME).name || previousMatch?.name === (0, $1NBp8.ADVANCED_SEARCH).name || previousMatch?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
module.exports["getIsEmbeddedConfluence"] = $2da08b1abbbb9472$export$914b80ef7b05e6be;
module.exports["hasEmbeddedAllowedFeatures"] = $2da08b1abbbb9472$export$b04bf7ed076c9866;
module.exports["getUsername"] = $2da08b1abbbb9472$export$204da773c0191bd8;
module.exports["shouldPreloadNavigationForTransition"] = $2da08b1abbbb9472$export$96d52eb4c89741b4;

});

parcelRegister("kM8fE", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $9sGCn = parcelRequire("9sGCn");

const $04e58c16bcbc1952$export$74e73cc91cadfbcb = (url)=>(0, $1NBp8.BASE).match(url) || (0, $1NBp8.WIKI).match(url) || (0, $1NBp8.HOME).match(url);
const $04e58c16bcbc1952$export$9b5271c8016c128c = (url)=>{
    const viewMatch = (0, $1NBp8.VIEW_PAGE).match(url);
    const contentId = viewMatch?.params?.contentId;
    if (contentId) {
        const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
        if (subType === 'live' && !isArchived) return viewMatch;
    }
    return null;
};
const $04e58c16bcbc1952$export$3e3db362037b34f = (url)=>{
    return (0, $1NBp8.VIEW_PAGE).match(url) || $04e58c16bcbc1952$export$192c834e0bea39fe(url);
};
const $04e58c16bcbc1952$export$192c834e0bea39fe = (url)=>(0, $1NBp8.VIEW_BLOG).match(url) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(url);
const $04e58c16bcbc1952$export$a5aebc3364387341 = (url)=>(0, $1NBp8.WHITEBOARD_BOARD).match(url);
const $04e58c16bcbc1952$export$3f2440066ae1f23 = (url)=>(0, $1NBp8.DATABASE_VIEW).match(url);
const $04e58c16bcbc1952$export$b1c34ea376f57e50 = (url)=>(0, $1NBp8.EMBED_VIEW).match(url);
const $04e58c16bcbc1952$export$60329dc4f3d156ce = (url)=>(0, $1NBp8.SPACE_OVERVIEW).match(url) || (0, $1NBp8.SPACE_INDEX).match(url);
const $04e58c16bcbc1952$export$56eec48d64616d8b = (url)=>(0, $1NBp8.COMPANY_HUB).match(url);
const $04e58c16bcbc1952$export$3f29957b70348eca = (url)=>(0, $1NBp8.EDIT_PAGE_V2).match(url) || (0, $1NBp8.EDIT_BLOG_V2).match(url) || (0, $1NBp8.COMPANY_HUB_EDIT).match(url) || (0, $1NBp8.HUB_EDIT).match(url);
const $04e58c16bcbc1952$export$9449ab1a743aa4d4 = (url)=>(0, $1NBp8.EDIT_BLOG_V2).match(url);
const $04e58c16bcbc1952$export$3ce40e86c460686d = (url)=>(0, $1NBp8.EXTERNAL_SHARE).match(url);
const $04e58c16bcbc1952$export$37a7eec3ef2ec73c = (url)=>(0, $1NBp8.ACCESS_LINK).match(url);
const $04e58c16bcbc1952$export$efe2eb904cd9c81a = (url)=>(0, $1NBp8.SPACE_PAGES).match(url);
const $04e58c16bcbc1952$export$3c3929e91c626c02 = (url)=>(0, $1NBp8.CONTENT_HISTORY).match(url);
const $04e58c16bcbc1952$export$552d39bb9dd5531a = (url)=>(0, $1NBp8.ATTACHMENTS_PAGE).match(url);
const $04e58c16bcbc1952$export$7c8524eeca3a9c2d = (url)=>(0, $1NBp8.EDIT_PAGE_EMBED).match(url);
const $04e58c16bcbc1952$export$a8abe18ba382dbab = (url)=>(0, $1NBp8.EDIT_PAGE_SMART_CREATE).match(url);
const $04e58c16bcbc1952$export$b5c8ff5b11237476 = (url)=>(0, $1NBp8.CREATE_CONTENT).match(url);
const $04e58c16bcbc1952$export$a2b8fd5ca9c2a95e = (url)=>(0, $1NBp8.PDF_EXPORT_PAGE).match(url);
const $04e58c16bcbc1952$export$87f5c7a0305c2dc7 = (url)=>(0, $1NBp8.ADVANCED_SEARCH).match(url);
const $04e58c16bcbc1952$export$322d41741edb8fa4 = (url)=>(0, $1NBp8.FOLDER_VIEW).match(url);
module.exports["matchHome"] = $04e58c16bcbc1952$export$74e73cc91cadfbcb;
module.exports["matchLivePage"] = $04e58c16bcbc1952$export$9b5271c8016c128c;
module.exports["matchViewPage"] = $04e58c16bcbc1952$export$3e3db362037b34f;
module.exports["matchBlogPage"] = $04e58c16bcbc1952$export$192c834e0bea39fe;
module.exports["matchWhiteboardPage"] = $04e58c16bcbc1952$export$a5aebc3364387341;
module.exports["matchDatabasePage"] = $04e58c16bcbc1952$export$3f2440066ae1f23;
module.exports["matchEmbedPage"] = $04e58c16bcbc1952$export$b1c34ea376f57e50;
module.exports["matchSpaceOverview"] = $04e58c16bcbc1952$export$60329dc4f3d156ce;
module.exports["matchCompanyHub"] = $04e58c16bcbc1952$export$56eec48d64616d8b;
module.exports["matchFabricEditor"] = $04e58c16bcbc1952$export$3f29957b70348eca;
module.exports["matchEditBlog"] = $04e58c16bcbc1952$export$9449ab1a743aa4d4;
module.exports["matchExternalShare"] = $04e58c16bcbc1952$export$3ce40e86c460686d;
module.exports["matchAccessLink"] = $04e58c16bcbc1952$export$37a7eec3ef2ec73c;
module.exports["matchSpacePages"] = $04e58c16bcbc1952$export$efe2eb904cd9c81a;
module.exports["matchContentHistory"] = $04e58c16bcbc1952$export$3c3929e91c626c02;
module.exports["matchAttachmentsPage"] = $04e58c16bcbc1952$export$552d39bb9dd5531a;
module.exports["matchEmbeddedEditor"] = $04e58c16bcbc1952$export$7c8524eeca3a9c2d;
module.exports["matchSmartCreateEditor"] = $04e58c16bcbc1952$export$a8abe18ba382dbab;
module.exports["matchCreateContent"] = $04e58c16bcbc1952$export$b5c8ff5b11237476;
module.exports["matchPdfExport"] = $04e58c16bcbc1952$export$a2b8fd5ca9c2a95e;
module.exports["matchSearch"] = $04e58c16bcbc1952$export$87f5c7a0305c2dc7;
module.exports["matchFolderPage"] = $04e58c16bcbc1952$export$322d41741edb8fa4;

});

parcelRegister("dpyxe", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lj2R9 = parcelRequire("lj2R9");

function $d0a9c91d619f4c3a$export$768c9c91046a1ca6(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $lj2R9.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "space-guest-list"
    });
}



var $9WAeG = parcelRequire("9WAeG");


var $3y0Sn = parcelRequire("3y0Sn");


var $jhATi = parcelRequire("jhATi");


var $hR977 = parcelRequire("hR977");

// string begins with 1+ characters other than "/", has a "/", and is followed by one character other than "/"
// OR string begins with "/", is followed by 1 character other than "/", ends with any # of any character
// while ignoring capitalization
const $03224f8a12cf9d3e$var$relativeUrlMatch = new RegExp(`^[^\/]+\/[^\/].*$|^\/[^\/].*$`, 'i');
const $03224f8a12cf9d3e$var$isSpaceSidebarLink = (node)=>{
    return node?.['__typename'] === 'SpaceSidebarLink';
};
const $03224f8a12cf9d3e$export$52277eb7dc68d9b = (res)=>{
    const content = res?.data?.spaceSidebarLinks?.quick ?? [];
    return content.filter($03224f8a12cf9d3e$var$isSpaceSidebarLink).map((node)=>{
        return {
            appearance: 'inline',
            // adding domain to relative confluence URLs so smart links don't error
            resourceUrl: $03224f8a12cf9d3e$var$relativeUrlMatch.test(node?.url) ? window.location.origin + node?.url : node?.url
        };
    });
};



var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $l1uFv = parcelRequire("l1uFv");


var $8tmcF = parcelRequire("8tmcF");





var $g277M = parcelRequire("g277M");


var $3mugH = parcelRequire("3mugH");


var $60cDW = parcelRequire("60cDW");


var $1xpoY = parcelRequire("1xpoY");


var $g2a13 = parcelRequire("g2a13");

/**
 * @generated SignedSource<<fb17fb3cc53429bffa53efccc4e34526>>
 * @relayHash 6d3cda5114c1d606399b11a6636db3e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7db31b068cec62e93fddfe2bcf08ccec80873bee7f945d8eae9bc25e7a1226c2
const $4bf3284d087e51be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceShortcutSmartLinkConnection",
            "kind": "LinkedField",
            "name": "confluence_shortcutSmartLinksBySpaceKey",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceShortcutSmartLink",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "position"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "customTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "emojiTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canView"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolved"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resourceType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "shortcutsSmartLinksQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "shortcutsSmartLinksQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "6d3cda5114c1d606399b11a6636db3e6",
            "id": "7db31b068cec62e93fddfe2bcf08ccec80873bee7f945d8eae9bc25e7a1226c2",
            "metadata": {},
            "name": "shortcutsSmartLinksQuery",
            "operationKind": "query",
            "text": "query shortcutsSmartLinksQuery($spaceKey:String!,$cloudId:ID!){confluence_shortcutSmartLinksBySpaceKey(spaceKey:$spaceKey,cloudId:$cloudId){nodes{id,position,styleClass,url,title,customTitle,emojiTitle,canView,resolved,product,subType,resourceType,iconUrl}}}"
        }
    };
}();
$4bf3284d087e51be$var$node.hash = "284925f2d66f00e9e3485699d4069814";
var $4bf3284d087e51be$export$2e2bcd8739ae039 = $4bf3284d087e51be$var$node;


const $b5105ad8602ba5b6$export$c33c605417f88817 = (0, $4bf3284d087e51be$export$2e2bcd8739ae039);


const $7f218a294dcdf804$var$SMART_LINK_MAX_TIME = 250;
const $7f218a294dcdf804$var$getSidenavSmartLinksORSMeasureName = ()=>{
    const queryBoundary = (0, $g277M.getQueryBoundary)();
    if (!queryBoundary || queryBoundary === 'default') return 'ssr-app/prepare/preloadQuery/fetch:sidenavSmartLinksORS';
    return `ssr-app/prepare/preloadQuery/dataFetcher:${queryBoundary}/fetch:sidenavSmartLinksORS`;
};
/**
 * Shared ORS fetch logic: resolves a list of smart links via ORS and returns
 * their SmartCardProvider initial state. Used by both the legacy and experiment paths.
 */ const $7f218a294dcdf804$var$fetchORSInitialState = async (links, objectResolverURL, userContext)=>{
    let orsInitialState = {};
    await (0, $9WAeG.SSRMeasures).run($7f218a294dcdf804$var$getSidenavSmartLinksORSMeasureName(), async ()=>{
        const timeout = (0, $1xpoY.default).getNumber('confluence_ssr_sidenav_smart_link_max_time', $7f218a294dcdf804$var$SMART_LINK_MAX_TIME);
        const resolvedSmartLinks = await (0, $8tmcF.timeGuard)(async ()=>{
            try {
                const res = await (0, $jhATi.fetchORSForSSR)({
                    url: `${objectResolverURL}?timeout=${timeout}`,
                    userContext: userContext,
                    body: JSON.stringify(links)
                });
                if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
                return res.json();
            } catch (e) {
                (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Smart link shortcuts ORS call failed: ${e.message}`));
            }
            return [];
        }, [], timeout);
        if (resolvedSmartLinks.length) orsInitialState = (0, $hR977.getInitialState)(resolvedSmartLinks);
    });
    return orsInitialState;
};
const $7f218a294dcdf804$export$ce708b69aef66f83 = async (spaceKey)=>{
    const { customURLs: customURLs, userContext: userContext, cloudId: cloudId } = (0, $60cDW.getSSRRenderInputs)();
    const objectResolverURL = customURLs?.['object-resolver-service'];
    if ((0, $6mKj3.expVal)('confluence_skip_ors_shortcut_smartlinks', 'isEnabled', false)) {
        // Experiment ON: use the new confluence_shortcutSmartLinksBySpaceKey query which returns
        // enriched metadata for Confluence links, skipping ORS for those.
        // Non-Confluence links (Jira, external) still fall back to ORS.
        if (!cloudId) return;
        const res = await (0, $dYU3e.query)({
            query: (0, $b5105ad8602ba5b6$export$c33c605417f88817),
            variables: {
                spaceKey: spaceKey,
                cloudId: cloudId
            },
            __callerPackage__: "space-shortcuts"
        });
        // Map GQL nodes to SmartLinkType — the common shape used by partitionResolvedLinks
        // and buildResolvedSmartLinkState, keeping logic uniform with preloadContentSmartLinks.
        // Note: resolved and canView are always the same value from the BE.
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        const allLinks = (res?.data?.confluence_shortcutSmartLinksBySpaceKey?.nodes ?? []).filter((node)=>node !== null && node !== undefined && Boolean(node.url)).map((node)=>({
                appearance: 'inline',
                resourceUrl: node.url,
                title: node.customTitle || node.title || null,
                emojiTitle: node.emojiTitle ?? null,
                canView: node.canView ?? null,
                product: node.product ?? null,
                resourceType: node.resourceType ?? null,
                subType: node.subType ?? null,
                iconUrl: node.iconUrl ?? null,
                resolved: node.resolved ?? null
            }));
        if (!allLinks.length) return;
        // Partition: Confluence-resolved links skip ORS; unresolved (Jira, external) still need ORS.
        // Mirrors the same partitioning used in preloadContentSmartLinksWithSuspense.
        const { resolvedFromGql: resolvedFromGql, linksForORS: linksForORS } = (0, $3y0Sn.partitionResolvedLinks)(allLinks);
        const confluenceInitialState = resolvedFromGql.length > 0 ? (0, $3y0Sn.buildResolvedSmartLinkState)(resolvedFromGql) : {};
        let orsInitialState = {};
        if (linksForORS.length > 0) {
            if (objectResolverURL) {
                // ORS only accepts { resourceUrl, appearance } — strip extra SmartLinkType fields
                // to avoid 400 errors. The legacy path uses getSmartShortcuts() which already
                // returns only these two fields, so sanitization is only needed here.
                const sanitizedLinksForORS = linksForORS.map(({ resourceUrl: resourceUrl, appearance: appearance })=>({
                        resourceUrl: resourceUrl,
                        appearance: appearance
                    }));
                orsInitialState = await $7f218a294dcdf804$var$fetchORSInitialState(sanitizedLinksForORS, objectResolverURL, userContext);
            } else (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Smart link shortcuts: ${linksForORS.length} unresolved link(s) could not be sent to ORS \u{2014} object-resolver-service URL is missing from SSR render inputs.`));
        }
        const initialState = {
            ...confluenceInitialState,
            ...orsInitialState
        };
        if (Object.keys(initialState).length > 0) window['__SSR_SHORTCUTS__'] = initialState;
        window['__SSR_SHORTCUTS_STATS__'] = {
            gql: {
                totalLinks: allLinks.length,
                resolvedFromGqlCount: resolvedFromGql.length,
                linksForORSCount: linksForORS.length,
                skippedORS: linksForORS.length === 0
            }
        };
    } else {
        // Experiment OFF (legacy): use spaceSidebarLinks.quick + ORS for all shortcuts.
        if (!objectResolverURL) return;
        const res = (0, $9wGTI.fg)('confluence_space_nav_core_frag_reader') ? {
            data: (0, $l1uFv.readQueryInterop)({
                query: (0, $g2a13.default),
                variables: {
                    spaceKey: spaceKey
                },
                __callerPackage__: "space-shortcuts"
            })
        } : await (0, $dYU3e.query)({
            query: (0, $g2a13.default),
            variables: {
                spaceKey: spaceKey
            },
            __callerPackage__: "space-shortcuts"
        });
        const smartLinks = (0, $03224f8a12cf9d3e$export$52277eb7dc68d9b)(res);
        if (!smartLinks?.length) return;
        const initialState = await $7f218a294dcdf804$var$fetchORSInitialState(smartLinks, objectResolverURL, userContext);
        if (Object.keys(initialState).length > 0) // Format response to fit SmartCard Provider storeOptions initial state
        // Save correctly formatted response to window obj so it can be used on SSR and SPA (no duplicate calls)
        window['__SSR_SHORTCUTS__'] = initialState;
        window['__SSR_SHORTCUTS_STATS__'] = {
            gql: {
                totalLinks: smartLinks.length,
                resolvedFromGqlCount: 0,
                linksForORSCount: smartLinks.length,
                skippedORS: false
            }
        };
    }
};


parcelRequire("bFNdd");
var $cdE3K = parcelRequire("cdE3K");


var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");





var $eS4vC = parcelRequire("eS4vC");


var $wPrRK = parcelRequire("wPrRK");





var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $4vyfK = parcelRequire("4vyfK");


var $eSLr0 = parcelRequire("eSLr0");


var $2fsJn = parcelRequire("2fsJn");


var $euL71 = parcelRequire("euL71");








var $eKTWO = parcelRequire("eKTWO");

function $63aa2dd20a144582$export$24087f514a906340(spaceKey, cloudId) {
    return (0, $dYU3e.queryAgg)({
        query: (0, $eKTWO.RemoteObjectSuggestionCountQuery),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        __callerPackage__: "space-curation"
    });
}










var $2fQCH = parcelRequire("2fQCH");

function $c0d8eea1db3e88bb$export$6b492303c3449855(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $2fQCH.default),
        errorPolicy: 'all',
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "create-blank-fabric-page"
    });
}






var $7Sm4c = parcelRequire("7Sm4c");


var $gsSsC = parcelRequire("gsSsC");

async function $45b1f1af9e45fa1f$export$4b4ce1c480b7c267(spaceKey) {
    const result = await (0, $dYU3e.query)({
        query: (0, $gsSsC.default),
        variables: {
            spaceKey: spaceKey
        },
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        __callerPackage__: "anonymous-access"
    });
    if (result?.errors) result.errors.forEach((error)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
    });
    // When a space is restricted, the query returns a 403 PermissionException with
    // `data.space === null`. Apollo's error handler evicts this from the cache, so by the
    // time the React tree renders during SSR the cache entry is gone and `useQueryInterop`
    // returns `loading: true`. On the client, however, the same query resolves with
    // `loading: false` — causing a hydration mismatch in the SideNav footer.
    //
    // To bridge this gap we persist the restricted-space signal in a global that
    // `useIsUserViewingSpaceAsAnon` can read synchronously during both SSR and hydration,
    // bypassing the evicted Apollo cache.
    if (result?.errors?.length && result?.data?.space === null) {
        const target = typeof window !== 'undefined' ? window : globalThis;
        target['__RESTRICTED_SPACES_FROM_PRELOAD__'] = target['__RESTRICTED_SPACES_FROM_PRELOAD__'] || {};
        target['__RESTRICTED_SPACES_FROM_PRELOAD__'][spaceKey] = true;
    }
}



var $fdq4F = parcelRequire("fdq4F");


var $ezNhb = parcelRequire("ezNhb");


var $dGmBZ = parcelRequire("dGmBZ");

// Dynamic config for the space curation preload timeout; tunable without a deploy.
const $ffe798577d563302$var$SPACE_CURATION_PRELOAD_TIMEOUT_CONFIG = 'confluence_space_curation_preload_timeout';
async function $ffe798577d563302$export$f5bb385ed55e90ad(spaceKey, previousSpaceKey, navigationVariables) {
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { cloudId: cloudId, edition: edition, isLicensed: isLicensed, userId: userId } = preloadedSessionContext;
    // Only preload space-curation data on SSR or when navigating to a different space.
    // Within-space navigation (page-to-page) can reuse the Apollo cache.
    const shouldPreloadSpaceCuration = // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined) || previousSpaceKey !== spaceKey;
    const includePersistentInviteLicense = edition !== (0, $euL71.ConfluenceEdition).FREE && isLicensed && Boolean(userId);
    const includeSpaceCurationCount = shouldPreloadSpaceCuration && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_autonomous_space_curation', 'isEnabled', true) && (0, $6mKj3.expValEquals)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', true);
    const tasks = [];
    if ((0, $9wGTI.fg)('navx-global-side-nav-confluence')) {
        tasks.push((0, $fdq4F.preloadPlatformNavigationQuery)());
        // Self-gates on the kill-switch gate + experiment; no-ops for non-cohort users.
        tasks.push((0, $ezNhb.preloadInvitedAppShortcutsRecommendationsQuery)());
    }
    const routeQueryResult = (0, $dYU3e.query)({
        query: (0, $dGmBZ.default),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey,
            isLicensed: isLicensed,
            includePersistentInviteLicense: includePersistentInviteLicense,
            includeSpaceCurationCount: includeSpaceCurationCount,
            includeSpaceViewsPersistence: preloadedSessionContext.isLicensed,
            ...navigationVariables
        },
        __callerPackage__: "side-navigation"
    });
    tasks.push(routeQueryResult);
    if (navigationVariables && (0, $9wGTI.fg)('confluence_space_nav_core_frag_reader')) {
        const preloadShortcuts = ()=>(0, $7f218a294dcdf804$export$ce708b69aef66f83)(spaceKey);
        tasks.push((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_skip_ors_shortcut_smartlinks', 'isEnabled', true) ? preloadShortcuts() : routeQueryResult.then(preloadShortcuts));
    }
    if (navigationVariables && (0, $9wGTI.fg)('confluence_space_nav_trees_frag_reader')) tasks.push((0, $c0d8eea1db3e88bb$export$6b492303c3449855)(spaceKey));
    if (navigationVariables && (0, $9wGTI.fg)('confluence_space_nav_affordances_frag_reader')) tasks.push(routeQueryResult.then((result)=>result.data?.space ? Promise.resolve() : (0, $45b1f1af9e45fa1f$export$4b4ce1c480b7c267)(spaceKey)).catch(()=>(0, $45b1f1af9e45fa1f$export$4b4ce1c480b7c267)(spaceKey)));
    tasks.push((0, $8CHHT.preloadUseExtensionList)({
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE),
        ...(0, $9wGTI.fg)('confluence_space_apps_ssr_preload') ? {
            spaceContextOnly: true
        } : {}
    }));
    if (!(0, $9wGTI.fg)('confluence_space_nav_affordances_frag_reader')) tasks.push((0, $2fsJn.preloadPersistentInviteButtonEligible)({
        spaceKey: spaceKey
    }, false));
    if ((0, $6mKj3.expValEquals)('web_item_query_batch_system_call', 'isEnabled', true)) // Keep distinct cache keys per location and let the transport batch the requests together.
    tasks.push((0, $4vyfK.preloadWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
        context: {
            single: false
        }
    }), (0, $4vyfK.preloadWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER),
        context: {
            single: false
        }
    }));
    else // Fallback: Original behavior - only preload SYSTEM_HEADER_LEFT separately
    tasks.push((0, $4vyfK.preloadWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_HEADER_LEFT)
    }));
    tasks.push((0, $cdE3K.preloadPostOfficeConfluenceSideNav)());
    if (includeSpaceCurationCount && !(0, $9wGTI.fg)('confluence_space_nav_affordances_frag_reader')) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('space-curation', ()=>[
            // Guard inside the callback so it wraps the real query (an outer guard no-ops on the
            // SSR-streaming path).
            (0, $wPrRK.slowQueryGuard)('preloadSpaceCuration', ()=>(0, $lyWac.waitForAllReturnWhenError)([
                    (0, $63aa2dd20a144582$export$24087f514a906340)(spaceKey, cloudId)
                ]), (0, $1xpoY.default).getNumber($ffe798577d563302$var$SPACE_CURATION_PRELOAD_TIMEOUT_CONFIG, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT)))
        ]));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
}



var $7A94k = parcelRequire("7A94k");


var $fEmGS = parcelRequire("fEmGS");















var $1oGPE = parcelRequire("1oGPE");


var $9eCf8 = parcelRequire("9eCf8");

/**
 * @generated SignedSource<<0689dd60e696c12754b34e0ed7644ac5>>
 * @relayHash 82b2265735f350b04303aa356c63fa98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c8bcc1494388137507cfc8874c8299406aa298c24af339e264e7dc02dc5cbbd
const $82ebf4e3df58271b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "ScalarField",
        "name": "value"
    }, v9 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v8 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v10 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v11 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v12 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "type"
    }, v14 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v15 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v16 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v8 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v17 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v18 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v17 /*: any*/ 
            ]
        }
    ], v19 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v21 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "enablePaging",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "pageTree",
                            "variableName": "paginationLimit"
                        },
                        v5 /*: any*/ 
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "pageTree",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PTPage",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        {
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": false,
                            "selections": v18 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                v5 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v20 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQueryWithSpaceKeyQuery",
            "selections": v21 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQueryWithSpaceKeyQuery",
            "selections": v21 /*: any*/ 
        },
        "params": {
            "cacheID": "82b2265735f350b04303aa356c63fa98",
            "id": "4c8bcc1494388137507cfc8874c8299406aa298c24af339e264e7dc02dc5cbbd",
            "metadata": {},
            "name": "PageTreeQueryWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query PageTreeQueryWithSpaceKeyQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean!){space(key:$spaceKey){id,homepageId,pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},operations{operation,targetType}},ptpage(spaceKey:$spaceKey,status:$ptStatuses){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}}"
        }
    };
}();
$82ebf4e3df58271b$var$node.hash = "64d740604525cae99e4c3d3a3a2b8b21";
var $82ebf4e3df58271b$export$2e2bcd8739ae039 = $82ebf4e3df58271b$var$node;


const $d25c822192ffc860$var$validSpaceKey = /^~?[a-z0-9]+$/i;
async function $d25c822192ffc860$export$45a75125fd859f7b({ spaceKey: spaceKey, statuses: statuses, isSuperAdmin: isSuperAdmin, contentId: contentId = '', fetchPolicy: fetchPolicy }) {
    const pageTreeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_pagetree_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return (0, $wPrRK.slowQueryGuard)('preloadPageTree', ()=>(0, $lyWac.waitForAllReturnWhenError)([
            $d25c822192ffc860$export$75e59f1581543cac({
                spaceKey: spaceKey,
                statuses: statuses,
                isSuperAdmin: isSuperAdmin,
                contentId: contentId,
                fetchPolicy: fetchPolicy
            }),
            (0, $c0d8eea1db3e88bb$export$6b492303c3449855)(spaceKey)
        ]), pageTreeTimeout);
}
async function $d25c822192ffc860$export$75e59f1581543cac({ spaceKey: spaceKey, statuses: statuses, isSuperAdmin: isSuperAdmin, contentId: contentId = '', fetchPolicy: fetchPolicy }) {
    // only fetch using PageTreeQueryWithSpaceKeyQuery if contentId does not exist AND FF is enabled (only for SSR space overviews).
    // This is to differentiate between other use cases where contentId is not passed (according to prop types, it is an optional param)
    //skip preloading if we do not have a valid spacekey (we are likely redirecting)
    if (spaceKey && $d25c822192ffc860$var$validSpaceKey.test(spaceKey) && !contentId) {
        const { data: data } = await (0, $dYU3e.query)({
            query: (0, $82ebf4e3df58271b$export$2e2bcd8739ae039),
            ...fetchPolicy && {
                fetchPolicy: fetchPolicy
            },
            variables: {
                spaceKey: spaceKey,
                isSuperAdmin: isSuperAdmin,
                statuses: statuses,
                // @ts-ignore
                ptStatuses: statuses,
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE)
            },
            __callerPackage__: "page-tree"
        });
        if (data?.space?.homepageId && data?.space?.id) (0, $fEmGS.writeQueryInterop)({
            query: (0, $9eCf8.default),
            variables: {
                spaceKey: spaceKey,
                isSuperAdmin: isSuperAdmin,
                statuses: statuses,
                // @ts-ignore
                ptStatuses: statuses,
                contentId: data?.space?.homepageId,
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE)
            },
            data: {
                currentPage: data?.space?.pageTree || null,
                ptpage: data?.ptpage || null,
                space: data?.space ? {
                    id: data?.space?.id,
                    homepage: {
                        id: data?.space?.homepageId,
                        // @ts-ignore
                        __typename: 'Content'
                    },
                    operations: data?.space?.operations,
                    // @ts-ignore
                    __typename: 'Space'
                } : null
            },
            __callerPackage__: "page-tree"
        });
    //skip preloading if we do not have a valid spacekey (we are likely redirecting)
    } else if (spaceKey && $d25c822192ffc860$var$validSpaceKey.test(spaceKey)) await (0, $dYU3e.query)({
        query: (0, $9eCf8.default),
        ...fetchPolicy && {
            fetchPolicy: fetchPolicy
        },
        variables: {
            spaceKey: spaceKey,
            isSuperAdmin: isSuperAdmin,
            statuses: statuses,
            ptStatuses: statuses,
            ...contentId && {
                contentId: contentId
            },
            paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE)
        },
        __callerPackage__: "page-tree"
    });
}






var $eiCiP = parcelRequire("eiCiP");


var $1UApO = parcelRequire("1UApO");


var $fL5TY = parcelRequire("fL5TY");


var $6DMfJ = parcelRequire("6DMfJ");

async function $704f9f1df7736cb5$export$e0f4d61001a4aebf() {
    try {
        const entries = await (0, $eiCiP.preloadLocalStorage)();
        const sideNavExpandState = entries.find((entry)=>entry.key.endsWith((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES));
        if (sideNavExpandState.value) {
            const expandedStates = JSON.parse(sideNavExpandState.value);
            if (expandedStates.blogTree) return true;
        }
    } catch  {
    // Return value might be malformed
    }
    return false;
}
const $704f9f1df7736cb5$export$af00c4ac24735b9 = async ({ spaceKey: spaceKey, fetchPolicy: fetchPolicy })=>{
    // blog tree is default collapsed, and is only expanded when user lands directly on a blog.
    // Or use explicity expanded the blog tree section
    const blogTreeQueryPromise = (0, $dYU3e.query)({
        query: (0, $fL5TY.default),
        ...fetchPolicy && {
            fetchPolicy: fetchPolicy
        },
        variables: {
            spaceKey: spaceKey,
            first: (0, $6DMfJ.PAGE_SIZE),
            statuses: (0, $6DMfJ.BLOG_STATUSES),
            orderBy: 'metadata.createdDate desc'
        },
        __callerPackage__: "blog-tree"
    });
    // isBlogTreeExpanded() is much faster then blogTreeQueryPromise
    // If section is not expanded we don't wait for the blog tree query to finish
    return $704f9f1df7736cb5$export$e0f4d61001a4aebf().then((expanded)=>{
        if (expanded) return blogTreeQueryPromise;
    });
};



var $ivyMZ = parcelRequire("ivyMZ");











const $b40f909d573440e2$export$9a7c1b3da2b1bad4 = async (spaceKey, contentId, isLicensed, isBlog, previousSpaceKey)=>{
    const includePageTree = Boolean(contentId) && !isBlog;
    const includeHomepageTreeVariant = !includePageTree;
    const includeBlogTreePromise = isBlog ? Promise.resolve(true) : (0, $704f9f1df7736cb5$export$e0f4d61001a4aebf)();
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $d0a9c91d619f4c3a$export$768c9c91046a1ca6)(spaceKey),
        (0, $9wGTI.fg)('confluence_space_nav_core_frag_reader') ? Promise.resolve() : (0, $7f218a294dcdf804$export$ce708b69aef66f83)(spaceKey),
        includeBlogTreePromise.then((includeBlogTree)=>(0, $ffe798577d563302$export$f5bb385ed55e90ad)(spaceKey, previousSpaceKey, {
                contentId: contentId,
                includeBlogTree: includeBlogTree,
                includeHomepageTreeVariant: includeHomepageTreeVariant,
                includePageTree: includePageTree,
                isSuperAdmin: false,
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
                ptStatuses: (0, $ivyMZ.PAGE_TREE_STATUSES)
            })),
        (0, $9wGTI.fg)('confluence_space_nav_space_views_frag_reader') ? Promise.resolve() : (0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed),
        (0, $9wGTI.fg)('confluence_space_nav_affordances_frag_reader') ? Promise.resolve() : (0, $45b1f1af9e45fa1f$export$4b4ce1c480b7c267)(spaceKey),
        (0, $9wGTI.fg)('confluence_space_nav_trees_frag_reader') ? Promise.resolve() : (0, $d25c822192ffc860$export$45a75125fd859f7b)({
            spaceKey: spaceKey,
            ...isBlog ? {} : {
                contentId: contentId
            },
            statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
            isSuperAdmin: false
        }),
        (0, $9wGTI.fg)('confluence_space_nav_trees_frag_reader') ? Promise.resolve() : (0, $704f9f1df7736cb5$export$af00c4ac24735b9)({
            spaceKey: spaceKey
        })
    ]);
};
module.exports["preloadNavigationTasks"] = $b40f909d573440e2$export$9a7c1b3da2b1bad4;

});

parcelRegister("3y0Sn", function(module, exports) {

var $8XUSS = parcelRequire("8XUSS");

const $37592cc5d5c1e3cb$export$f75f259a21c2ee98 = (links)=>{
    const resolvedFromGql = [];
    const linksForORS = [];
    for (const link of links)if (link.product === 'confluence' && link.resolved === true) resolvedFromGql.push(link);
    else linksForORS.push(link);
    return {
        resolvedFromGql: resolvedFromGql,
        linksForORS: linksForORS
    };
};
const $37592cc5d5c1e3cb$export$5079bd68f592c783 = (resolvedLinks)=>{
    if (!resolvedLinks?.length) return {};
    return resolvedLinks.reduce((map, link)=>{
        const url = link.resourceUrl;
        if (!url) return map;
        const iconUrl = $37592cc5d5c1e3cb$var$getStaticIconUrl(link.resourceType, url) ?? link.iconUrl;
        const cardState = {
            status: link.canView === true ? (0, $8XUSS.RESOLVED) : (0, $8XUSS.FORBIDDEN),
            details: {
                meta: {
                    access: link.canView === true ? 'granted' : 'forbidden',
                    auth: [],
                    definitionId: $37592cc5d5c1e3cb$var$getDefinitionId(link.resourceType),
                    resourceType: link.resourceType,
                    product: 'confluence'
                },
                data: {
                    '@context': {
                        '@vocab': 'https://www.w3.org/ns/activitystreams#',
                        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
                        schema: 'https://schema.org/'
                    },
                    '@type': $37592cc5d5c1e3cb$var$getResourceType(link.resourceType, link.subType),
                    name: link.title || '',
                    url: url,
                    ...$37592cc5d5c1e3cb$var$hasTopLevelIcon(link.resourceType) && iconUrl ? {
                        icon: {
                            '@type': 'Image',
                            url: iconUrl
                        }
                    } : {},
                    ...$37592cc5d5c1e3cb$var$hasTitlePrefix(link.resourceType) && link.emojiTitle ? {
                        'atlassian:titlePrefix': {
                            '@type': 'atlassian:Emoji',
                            text: link.emojiTitle
                        }
                    } : {},
                    generator: {
                        '@type': 'Application',
                        '@id': $37592cc5d5c1e3cb$var$getGeneratorId(link.resourceType),
                        name: $37592cc5d5c1e3cb$var$getGeneratorName(link.resourceType),
                        ...iconUrl ? {
                            icon: {
                                '@type': 'Image',
                                url: iconUrl
                            }
                        } : {}
                    }
                }
            }
        };
        return {
            ...map,
            [url]: cardState
        };
    }, {});
};
/**
 * Map resourceType to the ORS definitionId.
 * Whiteboards and databases use a different provider than pages/blogs/spaces.
 */ function $37592cc5d5c1e3cb$var$getDefinitionId(resourceType) {
    switch(resourceType){
        case 'whiteboard':
        case 'database':
        case 'slide':
            return 'canvas-native-object-provider';
        default:
            return 'integrations-confluence-object-provider';
    }
}
/**
 * Whether this resourceType has a top-level `icon` field in the ORS data response.
 * Pages and blogs do not; whiteboards, databases, slides, folders, and spaces do.
 */ function $37592cc5d5c1e3cb$var$hasTopLevelIcon(resourceType) {
    switch(resourceType){
        case 'whiteboard':
        case 'database':
        case 'slide':
        case 'folder':
        case 'space':
            return true;
        default:
            return false;
    }
}
/**
 * Returns a hardcoded icon URL for resource types that do not have an icon URL returned by the
 * GraphQL API. Whiteboards and databases fall into this category.
 * These URL must match those listed in https://bitbucket.org/atlassian/canvas/src/68e87076d0168bb32184f72e66cea5cfc0a96516/services/canvas-server/canvas-server/src/routes/private/smart-link/smart-link-utils.ts
 * For database links with an `entryId` query parameter, a database-entry icon is used instead.
 */ function $37592cc5d5c1e3cb$var$getStaticIconUrl(resourceType, url) {
    switch(resourceType){
        case 'whiteboard':
            return 'https://canvas-frontend.prod-east.frontend.public.atl-paas.net/assets/whiteboard-logo.svg';
        case 'database':
            if (url) try {
                const parsedUrl = new URL(url);
                if (parsedUrl.searchParams.has('entryId')) return 'https://canvas-frontend.prod-east.frontend.public.atl-paas.net/assets/database-entry-logo.svg';
            } catch  {
            // If URL parsing fails, fall through to the default database icon
            }
            return 'https://canvas-frontend.prod-east.frontend.public.atl-paas.net/assets/database-logo.svg';
        case 'slide':
            return 'https://canvas-frontend.prod-east.frontend.public.atl-paas.net/assets/slides-logo.svg';
        case 'folder':
            return 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT1315J.svg';
        default:
            return null;
    }
}
/**
 * Whether this resourceType includes `atlassian:titlePrefix` in the ORS data response.
 * Pages, blogs, and spaces do; whiteboards and databases do not.
 */ function $37592cc5d5c1e3cb$var$hasTitlePrefix(resourceType) {
    switch(resourceType){
        case 'whiteboard':
        case 'database':
        case 'slide':
            return false;
        default:
            return true;
    }
}
/**
 * Map resourceType to the generator @id used by the SmartCard Provider.
 * Values are based on actual ORS responses.
 */ function $37592cc5d5c1e3cb$var$getGeneratorId(resourceType) {
    switch(resourceType){
        case 'whiteboard':
            return 'https://www.atlassian.com/#ConfluenceWhiteboards';
        case 'database':
            return 'https://www.atlassian.com/#ConfluenceDatabases';
        case 'slide':
            return 'https://www.atlassian.com/#ConfluenceSlides';
        default:
            return 'https://www.atlassian.com/#Confluence';
    }
}
/**
 * Map resourceType to the generator display name.
 * Values are based on actual ORS responses.
 */ function $37592cc5d5c1e3cb$var$getGeneratorName(resourceType) {
    switch(resourceType){
        case 'whiteboard':
            return 'Confluence Whiteboards';
        case 'database':
            return 'Confluence Databases';
        case 'slide':
            return 'Confluence Slides';
        default:
            return 'Confluence';
    }
}
/**
 * Map resourceType to an ActivityStreams @type value for Confluence content.
 * Values are based on actual ORS responses.
 */ function $37592cc5d5c1e3cb$var$getResourceType(resourceType, subType) {
    switch(resourceType){
        case 'blogpost':
            return [
                'Document',
                'schema:BlogPosting'
            ];
        case 'page':
            if (subType === 'live') return [
                'Document',
                'schema:DigitalDocument'
            ];
            return [
                'Document',
                'schema:TextDigitalDocument'
            ];
        case 'whiteboard':
        case 'database':
        case 'slide':
            return 'Document';
        case 'space':
            return [
                'Object',
                'atlassian:Project'
            ];
        default:
            return [
                'Document',
                'schema:TextDigitalDocument'
            ];
    }
}
module.exports["partitionResolvedLinks"] = $37592cc5d5c1e3cb$export$f75f259a21c2ee98;
module.exports["buildResolvedSmartLinkState"] = $37592cc5d5c1e3cb$export$5079bd68f592c783;

});

parcelRegister("jhATi", function(module, exports) {
/* eslint-disable check-credentials-option/has-credentials-option */ 
var $6mKj3 = parcelRequire("6mKj3");


var $f7B1p = parcelRequire("f7B1p");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");


var $jQQYu = parcelRequire("jQQYu");

const $7be97be7622c4c18$var$OBJECT_RESOLVER_SERVICE_NAME = 'object-resolver-service';
const $7be97be7622c4c18$var$OBJECT_RESOLVER_SERVICE_ARCHETYPE_NAME = 'object-resolver-service-archetype';
const $7be97be7622c4c18$export$206df200416da93b = async ({ url: url, userContext: userContext, body: body })=>{
    const { host: host, cloudId: cloudId, isBifrostIcRequest: isBifrostIcRequest } = (0, $60cDW.getSSRRenderInputs)();
    const fetchOptions = {
        method: 'POST',
        headers: {
            Cookie: (0, $jQQYu.createCookie)(userContext),
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Origin: host.startsWith('http') ? host : `https://${host}`,
            CloudId: cloudId,
            'X-Product': 'CONFLUENCE',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': $7be97be7622c4c18$var$OBJECT_RESOLVER_SERVICE_NAME,
                ...isBifrostIcRequest === true && (0, $6mKj3.expVal)('confluence_ssr_bifrost_ic', 'isEnabled', false) ? {
                    'x-archetype-name': $7be97be7622c4c18$var$OBJECT_RESOLVER_SERVICE_ARCHETYPE_NAME
                } : {}
            } : {}
        },
        body: body
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions);
};
module.exports["fetchORSForSSR"] = $7be97be7622c4c18$export$206df200416da93b;

});

parcelRegister("hR977", function(module, exports) {

var $8XUSS = parcelRequire("8XUSS");

const $ef12576e8da2e6e5$export$53ac33307b5acee9 = (smartLinksResponse)=>{
    // If we didn't get a response from SmartLinks endpoint, exit
    if (!Array.isArray(smartLinksResponse) || smartLinksResponse?.length < 1) return {};
    return smartLinksResponse?.reduce((map, metadata)=>{
        const status = metadata?.status;
        const body = metadata?.body;
        const url = metadata?.body?.data?.url;
        if (!url) {
            // failed to resolve url
            window['__SSR_SMARTLINKS_ERRORS__'] = window['__SSR_SMARTLINKS_ERRORS__'] || {};
            const smartLinksSSRErrorsByStatus = window['__SSR_SMARTLINKS_ERRORS__'];
            smartLinksSSRErrorsByStatus[status] = smartLinksSSRErrorsByStatus[status] ? smartLinksSSRErrorsByStatus[status] + 1 : 1;
            return map;
        }
        const cardState = {
            status: (0, $8XUSS.getStatus)(status, metadata?.body?.meta?.access),
            details: body
        };
        return {
            ...map,
            [url]: cardState
        };
    }, {});
};
module.exports["getInitialState"] = $ef12576e8da2e6e5$export$53ac33307b5acee9;

});

parcelRegister("bFNdd", function(module, exports) {
$parcel$export(module.exports, "preloadPostOfficeConfluenceSideNav", () => (parcelRequire("cdE3K")).preloadPostOfficeConfluenceSideNav);

var $cdE3K = parcelRequire("cdE3K");


});

parcelRegister("2fsJn", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $dYU3e = parcelRequire("dYU3e");


var $euL71 = parcelRequire("euL71");


var $BrMrN = parcelRequire("BrMrN");

async function $c17fd2752a43fba2$export$350d5cfce01a6908({ spaceKey: spaceKey }, skipSpaceQuery = false) {
    const { edition: edition, isLicensed: isLicensed, userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    return (0, $dYU3e.query)({
        query: (0, $BrMrN.default),
        variables: {
            spaceKey: spaceKey,
            skipLicenseQuery: isFreeEdition || !isLicensed || !userId || skipSpaceQuery,
            skipSpaceQuery: !spaceKey
        },
        __callerPackage__: "persistent-invite-button"
    });
}
module.exports["preloadPersistentInviteButtonEligible"] = $c17fd2752a43fba2$export$350d5cfce01a6908;

});

parcelRegister("fdq4F", function(module, exports) {
parcelRequire("6SsN4");


var $as9lu = parcelRequire("as9lu");


var $30Qx8 = parcelRequire("30Qx8");




var $xwvlW = parcelRequire("xwvlW");


var $9wGTI = parcelRequire("9wGTI");

// Page size values from get-page-size-value.relayprovider.ts
const $90cf40f3681ab23a$var$DEFAULT_PAGE_SIZE = 100;
const $90cf40f3681ab23a$export$b4265157cf8cb2bd = async ()=>{
    if (!(0, $9wGTI.fg)('navx-global-side-nav-confluence')) return;
    const { cloudId: cloudId, activationId: activationId, userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!cloudId || !activationId) return;
    // Anonymous users have no userId — use an empty ownerAri so the query still runs.
    // This matches the runtime behaviour of RawGlobalSideNavigationAGGRelayConnection,
    // which passes ownerAri as-is (undefined → '') when no user is present.
    // Without preloading, anonymous users hit a 401 because useLazyLoadQuery falls back
    // to a network fetch on an unauthenticated SSR context (NAVX-5391).
    const ownerAri = userId ? (0, $as9lu.IdentityUserAri).create({
        userId: userId
    }).toString() : '';
    const entityAriUserSideNavSettings = '';
    const fetchOldEntityRecord = false;
    // Use NavigationSettingAri to exactly match what buildNavigationAriForMenuData /
    // buildNavigationAriForSidebarData produce inside GlobalSideNavigationAGGRelayConnection.
    const navPlatMenuDataEntityAri = (0, $30Qx8.NavigationSettingAri).create({
        firstPartyApp: 'confluence',
        siteId: cloudId,
        activationId: activationId,
        settingId: 'nav-plat-l1-menu-data'
    }).toString();
    const navPlatSidebarDataEntityAri = (0, $30Qx8.NavigationSettingAri).create({
        firstPartyApp: 'confluence',
        siteId: cloudId,
        activationId: activationId,
        settingId: 'nav-plat-sidebar-data'
    }).toString();
    // The relay provider variable must match what GlobalSideNavigationAGGRelayConnectionQuery
    // sends at runtime — otherwise Relay's store lookup will miss.
    // See: get-page-size-value.relayprovider.ts
    const pageSizeValue = $90cf40f3681ab23a$var$DEFAULT_PAGE_SIZE;
    const variables = {
        cloudId: cloudId,
        entityAriUserSideNavSettings: // Must match RawGlobalSideNavigationAGGRelayConnection: entityAri is ConfluenceWorkspaceAri,
        // and fetchOldEntityRecord is true when entityAri is truthy.
        entityAriUserSideNavSettings,
        fetchGlobalShortcutsAvailableProducts: Boolean(cloudId && ownerAri && (0, $9wGTI.fg)('navx-4515-jira-gsn-gas-ssr')),
        fetchOldEntityRecord: fetchOldEntityRecord,
        navPlatMenuDataEntityAri: navPlatMenuDataEntityAri,
        navPlatSidebarDataEntityAri: navPlatSidebarDataEntityAri,
        ownerAri: ownerAri,
        __relay_internal__pv__getpagesizevaluerelayproviderts: pageSizeValue
    };
    var e;
};
module.exports["preloadPlatformNavigationQuery"] = $90cf40f3681ab23a$export$b4265157cf8cb2bd;

});

parcelRegister("ezNhb", function(module, exports) {
parcelRequire("6SsN4");



var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $xwvlW = parcelRequire("xwvlW");



var $cwUrm = parcelRequire("cwUrm");


const $b02fa5e4d909fb6a$export$32b9754061eac9f5 = async ()=>{
    // Split the kill-switch gate from the experiment so non-cohort users skip the preload.
    // No-exposure evaluation: exposure is logged at render time (ConfluenceGSN), not here.
    const isInvitedAppShortcutsCohort = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('twcg-460-preload-grs-invited-app-shortcuts-gate') && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('twcg-460-preload-grs-invited-app-shortcuts', 'isEnabled', true);
    if (!isInvitedAppShortcutsCohort) return;
    const { cloudId: cloudId, userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    // Cohort prerequisites: both are required by the recommendations renderer.
    if (!cloudId || !userId) return;
    // Shared builder — keeps these byte-identical to the render-time consumer.
    const variables = (0, $cwUrm.buildInvitedAppShortcutsRecommendationsVariables)(cloudId);
    var e;
};
module.exports["preloadInvitedAppShortcutsRecommendationsQuery"] = $b02fa5e4d909fb6a$export$32b9754061eac9f5;

});

parcelRegister("7A94k", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $3AeIf = parcelRequire("3AeIf");


var $e5i8U = parcelRequire("e5i8U");

function $5600fd3490744a04$export$d5a6f6937168d07d(spaceKey, isLicensed) {
    const queries = [];
    queries.push((0, $dYU3e.query)({
        query: (0, $e5i8U.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "space-views"
    }));
    if (isLicensed) queries.push((0, $dYU3e.query)({
        query: (0, $3AeIf.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "space-views"
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}
module.exports["preloadSpaceViews"] = $5600fd3490744a04$export$d5a6f6937168d07d;

});

parcelRegister("22UVa", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $gRzR4 = parcelRequire("gRzR4");

function $30395b5fc2e6a8bf$export$c15cbaa44f10b9f1(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $gRzR4.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "editor-action-bar"
    });
}
module.exports["preloadSmartCreateFeedbackBanner"] = $30395b5fc2e6a8bf$export$c15cbaa44f10b9f1;

});

parcelRegister("3HGWr", function(module, exports) {

var $9WAeG = parcelRequire("9WAeG");


var $wPrRK = parcelRequire("wPrRK");


var $47TZD = parcelRequire("47TZD");


var $6U179 = parcelRequire("6U179");


var $dYU3e = parcelRequire("dYU3e");


var $3mugH = parcelRequire("3mugH");




// The bounded incoming-links sample: up to `INCOMING_LINKS_SAMPLE_LIMIT` source ARIs that reference
// this page. It warms the AGG query cache so the client can read the same query `cache-only` after
// SSR hydration, mirroring the outbound byline preload.
const $45c73f7306a9f0f4$var$IncomingLinksSampleQuery = (0, $6U179.default);
const $45c73f7306a9f0f4$var$unavailable = (reason)=>({
        status: 'unavailable',
        reason: reason
    });
const $45c73f7306a9f0f4$var$reportUnavailable = (reason, cause)=>{
    const causeCategory = cause == null ? 'none' : cause instanceof Error ? cause.name === 'GraphQLError' ? 'graphql' : 'error' : 'non-error';
    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Incoming links sample unavailable: ${reason}`, {
        cause: cause
    }), {
        operation: 'preload-incoming-links-sample',
        reason: reason,
        causeCategory: causeCategory
    });
};
const $45c73f7306a9f0f4$export$500023c3e6447b44 = async ({ cloudId: cloudId, contentId: contentId })=>{
    const variables = (0, $47TZD.buildIncomingLinksSampleVariables)(cloudId, contentId);
    if (!variables) return $45c73f7306a9f0f4$var$unavailable('invalid-input');
    try {
        // No `no-cache`: the sample warms the AGG query cache so the client can read the same query
        // `cache-only` after SSR hydration, mirroring the outbound byline preload.
        const { data: data, errors: errors, hasErrors: hasErrors } = await (0, $dYU3e.queryAgg)({
            query: $45c73f7306a9f0f4$var$IncomingLinksSampleQuery,
            variables: variables,
            context: {
                headers: {
                    'X-Query-Context': `ari:cloud:platform::site/${cloudId}`
                }
            },
            __callerPackage__: "byline-connections"
        });
        if (hasErrors || errors?.length) {
            $45c73f7306a9f0f4$var$reportUnavailable('query-error', errors?.[0]);
            return $45c73f7306a9f0f4$var$unavailable('query-error');
        }
        const result = (0, $47TZD.normalizeIncomingLinksSampleData)(data);
        if (result.status === 'unavailable') $45c73f7306a9f0f4$var$reportUnavailable('malformed-response');
        return result;
    } catch (cause) {
        $45c73f7306a9f0f4$var$reportUnavailable('query-error', cause);
        return $45c73f7306a9f0f4$var$unavailable('query-error');
    }
};


const $eeb344134099a229$var$INCOMING_LINKS_SAMPLE_OUTCOME_MEASURE = 'ssr-app/prepare/incomingLinksSample';
const $eeb344134099a229$var$recordIncomingLinksSampleOutcome = (result, route)=>{
    let outcome;
    if (result.status === 'unavailable') outcome = result.reason;
    else if (result.count === 0) outcome = 'empty';
    else if (result.count >= (0, $47TZD.INCOMING_LINKS_SAMPLE_LIMIT)) outcome = 'limit-reached';
    else outcome = 'one-or-two';
    (0, $9WAeG.SSRMeasures).addMeasure(`${$eeb344134099a229$var$INCOMING_LINKS_SAMPLE_OUTCOME_MEASURE}/${route}/outcome:${outcome}`, 0);
};
const $eeb344134099a229$var$createStateFromSample = (contentId, result)=>{
    if (result.status === 'unavailable') return (0, $47TZD.createIncomingLinksSsrState)(contentId, 'unavailable');
    return (0, $47TZD.createIncomingLinksSsrState)(contentId, result.count > 0 ? 'present' : 'empty');
};
const $eeb344134099a229$export$551acfc222caa145 = async ({ cloudId: cloudId, contentId: contentId, route: route })=>{
    let samplePromise;
    const getSample = ()=>{
        samplePromise ?? (samplePromise = (0, $45c73f7306a9f0f4$export$500023c3e6447b44)({
            cloudId: cloudId,
            contentId: contentId
        }));
        return samplePromise;
    };
    const completedWithinGuard = await (0, $wPrRK.slowQueryGuard)('preloadIncomingLinksSample', async ()=>{
        await getSample();
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    if (!completedWithinGuard) {
        (0, $9WAeG.SSRMeasures).addMeasure(`${$eeb344134099a229$var$INCOMING_LINKS_SAMPLE_OUTCOME_MEASURE}/${route}/outcome:timeout`, 0);
        return (0, $47TZD.createIncomingLinksSsrState)(contentId, 'unavailable');
    }
    const sample = await getSample();
    $eeb344134099a229$var$recordIncomingLinksSampleOutcome(sample, route);
    return $eeb344134099a229$var$createStateFromSample(contentId, sample);
};
module.exports["preloadIncomingLinksSsrState"] = $eeb344134099a229$export$551acfc222caa145;

});

parcelRegister("cHjca", function(module, exports) {

var $66MEr = parcelRequire("66MEr");


var $7Sm4c = parcelRequire("7Sm4c");


var $dYU3e = parcelRequire("dYU3e");


var $8tmcF = parcelRequire("8tmcF");


var $3mugH = parcelRequire("3mugH");


var $3C8hL = parcelRequire("3C8hL");

const $90a5da4a06a2f919$var$OUTBOUND_BYLINE_PRELOAD_TIMEOUT_MS = 300;
const $90a5da4a06a2f919$var$OUTBOUND_BYLINE_PRELOAD_TIMED_OUT = Symbol('outbound-byline-preload-timed-out');
const $90a5da4a06a2f919$var$OutboundBylineSsrStateQuery = (0, $66MEr.default);
const $90a5da4a06a2f919$var$preloadOutgoingLinks = (contentId)=>(0, $dYU3e.query)({
        query: $90a5da4a06a2f919$var$OutboundBylineSsrStateQuery,
        variables: {
            contentId: contentId
        },
        __callerPackage__: "byline-connections"
    });
const $90a5da4a06a2f919$var$isNullOrUndefined = (value)=>{
    if (value === null) return true;
    return value === undefined;
};
const $90a5da4a06a2f919$var$getUnavailableCauseCategory = (cause)=>{
    if ($90a5da4a06a2f919$var$isNullOrUndefined(cause)) return 'none';
    if (!(cause instanceof Error)) return 'non-error';
    if (cause.name === 'GraphQLError') return 'graphql';
    return 'error';
};
const $90a5da4a06a2f919$var$reportUnavailable = (reason, cause)=>{
    const causeCategory = $90a5da4a06a2f919$var$getUnavailableCauseCategory(cause);
    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Outbound byline SSR state unavailable: ${reason}`, {
        cause: cause
    }), {
        operation: 'preload-outbound-byline-ssr-state',
        reason: reason,
        causeCategory: causeCategory
    });
    if (cause instanceof Error) (0, $7Sm4c.markErrorAsHandled)(cause);
};
const $90a5da4a06a2f919$var$normalizeOutgoingLinks = (contentId, result)=>{
    if (result.hasErrors || result.errors?.length) {
        $90a5da4a06a2f919$var$reportUnavailable('query-error', result.errors?.[0]);
        return (0, $3C8hL.createOutboundBylineSsrState)(contentId, 'unavailable');
    }
    const state = (0, $3C8hL.normalizeOutboundBylineSsrState)(contentId, result.data);
    if (state.status === 'unavailable') $90a5da4a06a2f919$var$reportUnavailable('malformed-response');
    return state;
};
const $90a5da4a06a2f919$export$b2ddc3374087c410 = async (contentId)=>{
    try {
        const outgoingLinksPromise = $90a5da4a06a2f919$var$preloadOutgoingLinks(contentId);
        const result = await (0, $8tmcF.timeGuard)(()=>outgoingLinksPromise, $90a5da4a06a2f919$var$OUTBOUND_BYLINE_PRELOAD_TIMED_OUT, $90a5da4a06a2f919$var$OUTBOUND_BYLINE_PRELOAD_TIMEOUT_MS);
        if (result === $90a5da4a06a2f919$var$OUTBOUND_BYLINE_PRELOAD_TIMED_OUT) {
            $90a5da4a06a2f919$var$reportUnavailable('timeout');
            return (0, $3C8hL.createOutboundBylineSsrState)(contentId, 'unavailable');
        }
        return $90a5da4a06a2f919$var$normalizeOutgoingLinks(contentId, result);
    } catch (cause) {
        $90a5da4a06a2f919$var$reportUnavailable('query-error', cause);
        return (0, $3C8hL.createOutboundBylineSsrState)(contentId, 'unavailable');
    }
};
module.exports["preloadOutboundBylineSsrState"] = $90a5da4a06a2f919$export$b2ddc3374087c410;

});

parcelRegister("1QSQz", function(module, exports) {

let $15953138b70b1ff7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $15953138b70b1ff7$var$load("gnalD"),
    $15953138b70b1ff7$var$load("gA528")
]).then(()=>parcelRequire('cS7ok'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("2QBQR", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CONTRIBUTORS_FETCH_LIMIT", () => (parcelRequire("80xNa")).DEFAULT_CONTRIBUTORS_FETCH_LIMIT);
$parcel$export(module.exports, "CONFLUENCE_EDITION", () => (parcelRequire("80xNa")).CONFLUENCE_EDITION);

var $80xNa = parcelRequire("80xNa");


});

parcelRegister("2JYae", function(module, exports) {

var $bmTgR = parcelRequire("bmTgR");

const $ea5e64ad86524752$export$e31fbf0af7c148e4 = ()=>{
    return {
        isDesktop: (0, $bmTgR.isDesktop)()
    };
};
module.exports["useIsDesktop"] = $ea5e64ad86524752$export$e31fbf0af7c148e4;

});

parcelRegister("7f6xB", function(module, exports) {
/* HeadingLinksStyleWrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64491970f5adad44$var$wrapperStyles = null;
const $64491970f5adad44$export$b5a9f673a8d428df = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4kgjVzYbGa _1Fd2WLRAKS _2aHVTB7zJH _05yfn7ey7F _3cjL8m7fCs _205p2PLYhK _3tbrnSS8kF _2yb7ueS8kF _0jTkDOS8kF _2xeOx9S8kF _1UuWMsS8kF _4acwgsS8kF _2YARJPLYhK _2BEJEuWVPG _4fH3107zJH _27bYmNz1DK _1PT64W5EN9 _3t1huMaEKB _0BUQrpPCsv _2yzOdZSPN1 _0UJhViSPN1 _2pMqhKEbN9 _35BS3aEbN9"
        ])
    }, children);
};
module.exports["HeadingLinksStyleWrapper"] = $64491970f5adad44$export$b5a9f673a8d428df;

});

parcelRegister("6gbpH", function(module, exports) {
/* HubEditorWrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $biMIt = parcelRequire("biMIt");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values
const $47430e4f2bc1319c$var$HubEditorWrapperStyle = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2YgrGrP0S5 _1GrDiSmhAQ _1uH2r5lfZc _0UI22gBrVY _2m6rrJGDfn _3O6apjDIqT _2G7ozJIZbP _4lAFjsqhUL _0RJjNzVa5s _29RLfINHnM _38Jaj4dnbC _01dyko1Y8M",
            __cmplp.className
        ])
    });
});
const $47430e4f2bc1319c$export$ce728530374e0386 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $biMIt.AudienceSegmentationContextProvider), {
        isCompanyHub: true,
        shouldFetchUserGroups: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47430e4f2bc1319c$var$HubEditorWrapperStyle, null, children));
};
module.exports["HubEditorWrapper"] = $47430e4f2bc1319c$export$ce728530374e0386;

});

parcelRegister("e4SgJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $38a3c326d7f5e2fd$export$df61b30b684217c0 = new (0, $kCECX.PluginKey)('offlineMode');
const $38a3c326d7f5e2fd$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $38a3c326d7f5e2fd$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    browserState: 'online',
                    externalState: undefined
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($38a3c326d7f5e2fd$export$df61b30b684217c0);
                if (meta) {
                    const { externalState: externalState, browserState: browserState } = meta;
                    return {
                        browserState: browserState ?? pluginState?.browserState,
                        externalState: externalState === null ? undefined : externalState ?? pluginState?.externalState
                    };
                }
                return pluginState;
            }
        }
    });
};


const $076ce6bf17d5ec42$export$aa1854019a007ea9 = ()=>{
    let previousMode;
    return {
        name: 'connectivity',
        getSharedState (editorState) {
            if (!editorState) return {
                mode: 'online'
            };
            const pluginState = (0, $38a3c326d7f5e2fd$export$df61b30b684217c0).getState(editorState);
            return {
                mode: pluginState?.externalState ?? pluginState?.browserState ?? 'online'
            };
        },
        commands: {
            setMode: (mode)=>({ tr: tr })=>{
                    // Leave early if the mode has not changed
                    if (mode === previousMode) return null;
                    previousMode = mode;
                    return tr.setMeta((0, $38a3c326d7f5e2fd$export$df61b30b684217c0), {
                        externalState: mode
                    });
                }
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'connectivity',
                    plugin: (0, $38a3c326d7f5e2fd$export$ae829ec7b2625219)
                }
            ];
        },
        usePluginHook: ({ editorView: editorView })=>{
            (0, $cozmU.useEffect)(()=>{
                const dispatch = (value)=>{
                    const { dispatch: dispatch, state: { tr: tr } } = editorView;
                    dispatch(tr.setMeta((0, $38a3c326d7f5e2fd$export$df61b30b684217c0), {
                        browserState: value
                    }));
                };
                const handleOnline = ()=>dispatch('online');
                const handleOffline = ()=>dispatch('offline');
                if (window.navigator.onLine === false) dispatch('offline');
                const cleanupOnlineListener = (0, $cbY7C.bind)(window, {
                    type: 'online',
                    listener: handleOnline
                });
                const cleanupOfflineListener = (0, $cbY7C.bind)(window, {
                    type: 'offline',
                    listener: handleOffline
                });
                return ()=>{
                    cleanupOnlineListener();
                    cleanupOfflineListener();
                };
            }, [
                editorView
            ]);
        }
    };
};
module.exports["connectivityPlugin"] = $076ce6bf17d5ec42$export$aa1854019a007ea9;

});

parcelRegister("iFdOW", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $4o0zT = parcelRequire("4o0zT");

const $9d2ef2f22d81738a$var$viewModePluginKey = new (0, $kCECX.PluginKey)('editorViewMode');
const $9d2ef2f22d81738a$var$createPlugin = ({ initialMode: initialMode })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $9d2ef2f22d81738a$var$viewModePluginKey,
        state: {
            init: ()=>({
                    mode: initialMode ?? 'edit'
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($9d2ef2f22d81738a$var$viewModePluginKey);
                if (meta) return meta;
                return pluginState;
            }
        },
        props: {
            attributes: (state)=>{
                const mode = $9d2ef2f22d81738a$var$viewModePluginKey.getState(state)?.mode ?? initialMode ?? 'edit';
                const ariaReadonly = mode === 'view' && (0, $4o0zT.isExperimentEnabled)('platform_editor_viewmode_aria_readonly_a11y');
                return ariaReadonly ? {
                    'aria-readonly': 'true'
                } : {};
            },
            // If we set to undefined it respects the previous value.
            // Prosemirror doesn't have this typed correctly for this type of behaviour
            // We will fast-follow to consolidate the logic with `editor-disabled` so we don't
            // need this workaround.
            // @ts-expect-error
            editable: (state)=>{
                const mode = $9d2ef2f22d81738a$var$viewModePluginKey.getState(state)?.mode;
                return mode === 'view' ? false : undefined;
            }
        }
    });
};
const $9d2ef2f22d81738a$export$cc1df4562f7c69ec = ({ config: options, api: api })=>{
    return {
        name: 'editorViewMode',
        getSharedState (editorState) {
            if (!editorState) return {
                mode: options?.mode === 'view' ? 'view' : 'edit'
            }; // Skipping type safety for the deprecated mode property
            return {
                mode: $9d2ef2f22d81738a$var$viewModePluginKey.getState(editorState)?.mode ?? 'edit'
            }; // Skipping type safety for the deprecated mode property
        },
        commands: {
            updateViewMode: (mode)=>({ tr: tr })=>{
                    return tr.setMeta($9d2ef2f22d81738a$var$viewModePluginKey, {
                        mode: mode
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'editorViewMode',
                    plugin: ()=>$9d2ef2f22d81738a$var$createPlugin({
                            initialMode: options?.mode
                        })
                }
            ];
        }
    };
};
module.exports["editorViewModePlugin"] = $9d2ef2f22d81738a$export$cc1df4562f7c69ec;

});

parcelRegister("47YIB", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $kCECX = parcelRequire("kCECX");

const $13aee4489509c071$export$236b6da1fbb1c083 = new (0, $kCECX.PluginKey)('engagementPlatformPmPlugin');


const $e9b8b8fc3397316e$export$a47559fd89434a3 = (command)=>({ tr: tr })=>{
        const currentMeta = tr.getMeta((0, $13aee4489509c071$export$236b6da1fbb1c083)) ?? {
            commands: []
        };
        const newMeta = {
            ...currentMeta,
            commands: [
                ...currentMeta.commands,
                command
            ]
        };
        return tr.setMeta((0, $13aee4489509c071$export$236b6da1fbb1c083), newMeta);
    };


function $24893d25c5808c81$export$7a77c9a7b182680b(api, coordinationClient) {
    return (messageId, variationId)=>{
        if (!api) return Promise.resolve(false);
        // If the message is already started (even with `false` state), return the state
        const messageStates = api.engagementPlatform.sharedState.currentState()?.messageStates ?? {};
        const messageState = messageStates[messageId];
        if (messageState !== undefined) return Promise.resolve(messageState);
        // If there is already a start message promise, return it to prevent multiple start requests
        const startMessagePromises = api.engagementPlatform.sharedState.currentState()?.startMessagePromises ?? {};
        const startMessagePromise = startMessagePromises[messageId];
        if (startMessagePromise) return startMessagePromise;
        const newStartedMessagePromise = coordinationClient.start(messageId, variationId).then((isStarted)=>{
            // Update the message state in the shared state
            api.core.actions.execute((0, $e9b8b8fc3397316e$export$a47559fd89434a3)({
                type: 'setMessageState',
                messageId: messageId,
                state: isStarted
            }));
            return isStarted;
        }).catch((error)=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ENGAGEMENT_PLATFORM,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: error instanceof Error ? error.message : `${error}`,
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            });
            return false;
        }).finally(()=>{
            // Remove the promise from the state after it has been resolved
            api.core.actions.execute((0, $e9b8b8fc3397316e$export$a47559fd89434a3)({
                type: 'setStartMessagePromise',
                messageId: messageId,
                promise: undefined
            }));
        });
        // Store the promise in the shared state to prevent multiple start requests for the same message
        api.core.actions.execute((0, $e9b8b8fc3397316e$export$a47559fd89434a3)({
            type: 'setStartMessagePromise',
            messageId: messageId,
            promise: newStartedMessagePromise
        }));
        return newStartedMessagePromise;
    };
}






function $f45f90062533a9ea$export$159ff839f1f095d2(api, coordinationClient) {
    return (messageId)=>{
        if (!api) return Promise.resolve(false);
        // If the message is already stopped, return `true`
        const messageStates = api.engagementPlatform.sharedState.currentState()?.messageStates ?? {};
        const isActive = messageStates[messageId];
        if (isActive === false) return Promise.resolve(true);
        // If there is already a stop message promise, return it to prevent multiple stop requests
        const stopMessagePromises = api.engagementPlatform.sharedState.currentState()?.stopMessagePromises ?? {};
        const stopMessagePromise = stopMessagePromises[messageId];
        if (stopMessagePromise) return stopMessagePromise;
        const newStopMessagePromise = coordinationClient.stop(messageId).then((isStopped)=>{
            // Update the message state in the shared state
            if (isStopped) api.core.actions.execute((0, $e9b8b8fc3397316e$export$a47559fd89434a3)({
                type: 'setMessageState',
                messageId: messageId,
                state: false
            }));
            return isStopped;
        }).catch((error)=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ENGAGEMENT_PLATFORM,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: error instanceof Error ? error.message : `${error}`,
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            });
            return false;
        }).finally(()=>{
            // Remove the promise from the state after it has been resolved
            api.core.actions.execute((0, $e9b8b8fc3397316e$export$a47559fd89434a3)({
                type: 'setStopMessagePromise',
                messageId: messageId,
                promise: undefined
            }));
        });
        // Store the promise in the shared state to prevent multiple stop requests for the same message
        api.core.actions.execute((0, $e9b8b8fc3397316e$export$a47559fd89434a3)({
            type: 'setStopMessagePromise',
            messageId: messageId,
            promise: newStopMessagePromise
        }));
        return newStopMessagePromise;
    };
}



var $kpCD8 = parcelRequire("kpCD8");


const $108459fac776b66b$export$33825561da15aa81 = (pluginConfig)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $13aee4489509c071$export$236b6da1fbb1c083),
        state: {
            init: ()=>{
                return {
                    messageStates: {},
                    startMessagePromises: {},
                    stopMessagePromises: {},
                    epComponents: pluginConfig.epComponents,
                    epHooks: pluginConfig.epHooks,
                    coordinationClient: pluginConfig.coordinationClient
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $13aee4489509c071$export$236b6da1fbb1c083));
                if (!meta) return pluginState;
                let state = {
                    ...pluginState
                };
                for (const command of meta.commands)switch(command.type){
                    case 'setMessageState':
                        state = {
                            ...state,
                            messageStates: {
                                ...state.messageStates,
                                [command.messageId]: command.state
                            }
                        };
                        break;
                    case 'setStartMessagePromise':
                        if (command.promise !== undefined) {
                            state = {
                                ...state,
                                startMessagePromises: {
                                    ...state.startMessagePromises,
                                    [command.messageId]: command.promise
                                }
                            };
                            break;
                        } else {
                            // If the promise is undefined, remove it from the state
                            const { [command.messageId]: _, ...startMessagePromises } = state.startMessagePromises;
                            state = {
                                ...state,
                                startMessagePromises: startMessagePromises
                            };
                        }
                        break;
                    case 'setStopMessagePromise':
                        if (command.promise !== undefined) {
                            state = {
                                ...state,
                                stopMessagePromises: {
                                    ...state.stopMessagePromises,
                                    [command.messageId]: command.promise
                                }
                            };
                            break;
                        } else {
                            // If the promise is undefined, remove it from the state
                            const { [command.messageId]: _, ...stopMessagePromises } = state.stopMessagePromises;
                            state = {
                                ...state,
                                stopMessagePromises: stopMessagePromises
                            };
                        }
                        break;
                }
                return state;
            }
        }
    });
};



const $c20ab678dd07da37$export$5dda357eeee894b1 = ({ config: config, api: api })=>{
    return {
        name: 'engagementPlatform',
        actions: {
            startMessage: (0, $24893d25c5808c81$export$7a77c9a7b182680b)(api, config.coordinationClient),
            stopMessage: (0, $f45f90062533a9ea$export$159ff839f1f095d2)(api, config.coordinationClient)
        },
        pmPlugins () {
            return [
                {
                    name: 'engagementPlatformPmPlugin',
                    plugin: ()=>(0, $108459fac776b66b$export$33825561da15aa81)(config)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $13aee4489509c071$export$236b6da1fbb1c083).getState(editorState);
        }
    };
};
module.exports["engagementPlatformPlugin"] = $c20ab678dd07da37$export$5dda357eeee894b1;

});

parcelRegister("4OMM6", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $cbY7C = parcelRequire("cbY7C");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");




const $3c966cf591950b96$var$ACTIVE_SESSION_IDLE_TIME = 5000;
class $3c966cf591950b96$export$533c4bb863159234 {
    constructor(api){
        this.timerId = void 0;
        this.api = void 0;
        this.startTimer = ()=>{
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = window.setTimeout(()=>{
                if (this.api) this.api.core.actions.execute(this.api.metrics?.commands.stopActiveSession());
                this.cleanupTimer();
            }, $3c966cf591950b96$var$ACTIVE_SESSION_IDLE_TIME);
        };
        this.cleanupTimer = ()=>{
            if (this.timerId) {
                clearTimeout(this.timerId);
                this.timerId = null;
            }
        };
        this.timerId = null;
        this.api = api;
    }
}



var $krYZG = parcelRequire("krYZG");

function $2dcb0e0c8c7a2276$var$countNodesByType(fragment) {
    const counts = {};
    fragment.forEach((node)=>{
        counts[node.type.name] = (counts[node.type.name] || 0) + 1;
    });
    return counts;
}
const $2dcb0e0c8c7a2276$export$19c1cd683a3a7719 = ({ currentContent: currentContent, pluginState: pluginState })=>{
    if (pluginState?.initialContent) {
        const initialCounts = $2dcb0e0c8c7a2276$var$countNodesByType(pluginState.initialContent);
        const currentCounts = $2dcb0e0c8c7a2276$var$countNodesByType(currentContent);
        const netChanges = Object.keys({
            ...initialCounts,
            ...currentCounts
        }).filter((value)=>![
                'paragraph',
                'heading'
            ].includes(value)).reduce((changes, nodeType)=>{
            const change = (currentCounts[nodeType] || 0) - (initialCounts[nodeType] || 0);
            if (change !== 0) changes[nodeType] = change;
            return changes;
        }, {});
        return netChanges;
    }
    return {};
};


const $d1a007782642c427$export$4feda93c1c6b2d80 = ({ currentContent: currentContent, pluginState: pluginState, toolbarDocking: toolbarDocking })=>{
    const nodeChanges = (0, $2dcb0e0c8c7a2276$export$19c1cd683a3a7719)({
        currentContent: currentContent,
        pluginState: pluginState
    });
    const getActionCountByTypeSum = ()=>{
        let actionCountByTypeSum = 0;
        Object.entries(pluginState.actionTypeCount).forEach(([_actionType, count])=>{
            actionCountByTypeSum += count;
        });
        return pluginState.totalActionCount - actionCountByTypeSum;
    };
    let nodeInsertionCount = 0;
    let nodeDeletionCount = 0;
    Object.entries(nodeChanges).forEach(([_, change])=>{
        if (change > 0) nodeInsertionCount += change;
        else if (change < 0) nodeDeletionCount += Math.abs(change);
    });
    return {
        action: (0, $krYZG.ACTION).ENDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).ACTIVITY_SESSION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ACTIVITY,
        attributes: {
            efficiency: {
                totalActiveTime: pluginState.activeSessionTime / 1000,
                totalActionCount: pluginState.totalActionCount,
                actionByTypeCount: {
                    ...pluginState.actionTypeCount ?? {},
                    nodeDeletionCount: nodeDeletionCount,
                    nodeInsertionCount: nodeInsertionCount,
                    other: getActionCountByTypeSum()
                }
            },
            effectiveness: {
                undoCount: pluginState.actionTypeCount.undoCount,
                repeatedActionCount: pluginState.repeatedActionCount,
                safeInsertCount: pluginState.safeInsertCount
            },
            contentSizeChanged: pluginState.contentSizeChanged,
            toolbarDocking: toolbarDocking
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
};



var $eOaGc = parcelRequire("eOaGc");


var $1b8435ecd9a2213c$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["TEXT_INPUT"] = "textInput";
    ActionType["EMPTY_LINE_ADDED_OR_DELETED"] = "emptyLineAddedOrDeleted";
    ActionType["INSERTED_FROM_TYPE_AHEAD"] = "insertedFromTypeAhead";
    ActionType["INSERTING_NEW_LIST_TYPE_NODE"] = "insertingNewListTypeNode";
    ActionType["UPDATING_NEW_LIST_TYPE_ITEM"] = "updatingNewListItem";
    ActionType["ADDING_LINK"] = "addingLink";
    ActionType["UPDATING_STATUS"] = "updatingStatus";
    ActionType["CHANGING_MARK"] = "changingMark";
    ActionType["CHANGING_ATTRS"] = "changingAttrs";
    ActionType["MOVING_CONTENT"] = "contentMoved";
    ActionType["PASTING_CONTENT"] = "contentPasted";
    ActionType["DELETING_CONTENT"] = "deletingContent";
    ActionType["SAFE_INSERT"] = "safeInsert";
    ActionType["UNDO"] = "undo";
    return ActionType;
}({});


const $b0d4fe33de63375c$var$UI_EVENT = 'uiEvent';
const $b0d4fe33de63375c$var$PASTE_EVENT = 'paste';
const $b0d4fe33de63375c$export$dd95ad7faeb49efb = (tr)=>{
    const isContentMoved = tr.getMeta((0, $72d4c7ad938eab5b$export$25eda213007f3f3b))?.contentMoved;
    const isContentPasted = tr.getMeta($b0d4fe33de63375c$var$UI_EVENT) === $b0d4fe33de63375c$var$PASTE_EVENT;
    if (isContentMoved) return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).MOVING_CONTENT
    };
    if (isContentPasted) return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).PASTING_CONTENT
    };
    return undefined;
};



const $4399309ce5f933ad$export$37e6d8d5ff035b23 = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const isDeletingContent = to !== from && content.childCount === 0;
    if (!isDeletingContent) return undefined;
    return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).DELETING_CONTENT
    };
};



const $86f46c8c874067bb$export$3b8bead5689e4d0b = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const isEmptyLineDeleted = to - from === 2 && content.size === 0;
    if (isEmptyLineDeleted) return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
    };
    let isEmptyLineAdded = false;
    content.forEach((node)=>{
        isEmptyLineAdded = node.type.name === 'paragraph' && node.content.size === 0;
    });
    if (!isEmptyLineAdded) return undefined;
    return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
    };
};



const $75c4b51b4b7a3f21$export$3dd64ceb881e5e4e = (step)=>{
    const { slice: { content: content } } = step;
    const childCount = content.childCount;
    if (childCount < 1) return undefined;
    for (const node of content.content){
        const isListTypeNode = [
            'decisionList',
            'decisionItem',
            'bulletList',
            'listItem',
            'orderedList',
            'taskList',
            'taskItem'
        ].includes(node.type.name);
        if (isListTypeNode) return childCount === 1 ? {
            type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).INSERTING_NEW_LIST_TYPE_NODE
        } : {
            type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM
        };
    }
    return undefined;
};






const $7353893ce1e07ce6$export$c93a5d700df353f0 = (step)=>{
    if (!(step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep))) return undefined;
    return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).CHANGING_MARK
    };
};



const $cda9ff6f2f0b4de8$var$compareAttributes = (prevAttr, newAttr)=>{
    const allKeys = new Set([
        ...Object.keys(prevAttr),
        ...Object.keys(newAttr)
    ]);
    for (const key of allKeys){
        const prevValue = prevAttr[key];
        const newValue = newAttr[key];
        if (prevValue !== newValue && key !== 'localId') return key;
    }
    return undefined;
};
const $cda9ff6f2f0b4de8$var$compareMarks = (prevMarks, newMarks)=>{
    if (!prevMarks && !newMarks) return undefined;
    const previousMarksArr = new Map(prevMarks.map((mark)=>[
            mark.type.name,
            mark.attrs
        ]));
    const newMarksArr = new Map(newMarks.map((mark)=>[
            mark.type.name,
            mark.attrs
        ]));
    const allMarks = new Set([
        ...previousMarksArr.keys(),
        ...newMarksArr.keys()
    ]);
    for (const key of allMarks){
        const previousValue = previousMarksArr.get(key);
        const newValue = newMarksArr.get(key);
        if (JSON.stringify(previousValue) !== JSON.stringify(newValue)) return key;
    }
    return undefined;
};
const $cda9ff6f2f0b4de8$export$460c78c4e7d0df18 = (tr, step)=>{
    const { slice: slice, from: from, to: to } = step;
    const oldNode = tr.docs[0].nodeAt(from);
    const newNode = slice.content.firstChild;
    if (!oldNode || !newNode) return undefined;
    if (oldNode.type.name !== newNode.type.name) return undefined;
    // We need to compare the attributes of the node
    const changedAttr = $cda9ff6f2f0b4de8$var$compareAttributes(oldNode.attrs, newNode.attrs);
    if (changedAttr) return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: changedAttr,
            from: from,
            to: to
        }
    };
    // For some changes, we need to compare the marks of the node
    // e.g. Media Border, Links
    const changedMarks = $cda9ff6f2f0b4de8$var$compareMarks(oldNode.marks, newNode.marks);
    if (changedMarks) return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: changedMarks,
            from: from,
            to: to
        }
    };
    return undefined;
};



const $b2e6adf84f490a28$export$dfe6977d1be089c2 = (step)=>{
    const { slice: slice } = step;
    const firstChild = slice.content.firstChild;
    if (!firstChild) return undefined;
    // Get statusId so that we can track whether edits are performed on same status node
    return firstChild.type.name === 'status' ? {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).UPDATING_STATUS,
        extraData: {
            statusId: firstChild.attrs.localId
        }
    } : undefined;
};



var $hdvEd = parcelRequire("hdvEd");





const $a4b0aa0d49350657$export$99fad7bb37d9329a = (tr)=>{
    const COL_WIDTH_ATTR = 'colwidth';
    const steps = tr.steps;
    // Find the step that is changing the column width
    const resizingColumnStep = steps.find((step)=>step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $hdvEd.BatchAttrsStep));
    if (!resizingColumnStep) return undefined;
    let pos;
    // Find the position of the first column in the step that is being resized
    if (resizingColumnStep instanceof (0, $hdvEd.BatchAttrsStep)) {
        if (resizingColumnStep.data.length === 0) return undefined;
        const { attrs: attrs, nodeType: nodeType, position: position } = resizingColumnStep.data[0];
        if ([
            'tableHeader',
            'tableCell'
        ].includes(nodeType) && attrs?.[COL_WIDTH_ATTR]) pos = position;
    } else if (resizingColumnStep instanceof (0, $eOaGc.AttrStep) && resizingColumnStep.attr === COL_WIDTH_ATTR) pos = resizingColumnStep.pos;
    if (!pos) return undefined;
    // Find the range of the table that is being resized
    const $pos = tr.doc.resolve(pos);
    const blockRange = $pos.blockRange();
    if (!blockRange) return undefined;
    const from = blockRange.start;
    const to = from + blockRange.parent.content.size;
    // Use to and from position of table to check whether column width of same table is being resized
    return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: COL_WIDTH_ATTR,
            from: from,
            to: to
        }
    };
};



const $482628e63999f8c5$export$1a2f61e1ac72166a = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const node = content.firstChild;
    const isAddingCharacter = from === to && content.childCount === 1 && !!node && !!node.text && node.text.length === 1;
    const isDeletingCharacter = to - from === 1 && content.childCount === 0;
    const isTextInput = isAddingCharacter || isDeletingCharacter;
    if (!isTextInput) return undefined;
    return {
        type: (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).TEXT_INPUT
    };
};


const $17b513980ed8a17b$export$ea477ab911425d3e = (tr)=>{
    const stepsLength = tr.steps.length;
    if (stepsLength <= 0) return undefined;
    const contentPastedOrMoved = (0, $b0d4fe33de63375c$export$dd95ad7faeb49efb)(tr);
    if (contentPastedOrMoved) return contentPastedOrMoved;
    // Resized column data is either AttrStep or BatchAttrsStep, so we want to check it first
    const resizedColumnData = (0, $a4b0aa0d49350657$export$99fad7bb37d9329a)(tr);
    if (resizedColumnData) return resizedColumnData;
    // Since we are looking at editor actions, we want to look at the first step only
    const [firstStep] = tr.steps;
    const isReplaceStep = firstStep instanceof (0, $eOaGc.ReplaceStep);
    const isReplaceAroundStep = firstStep instanceof (0, $eOaGc.ReplaceAroundStep);
    // Check if mark is added or removed, this is for text formatting changes
    const marksChanged = (0, $7353893ce1e07ce6$export$c93a5d700df353f0)(firstStep);
    if (marksChanged) return marksChanged;
    // Return early if it's not a replace step or replace around step as following checks are for these steps only
    if (!(isReplaceStep || isReplaceAroundStep)) return undefined;
    if (isReplaceStep) {
        // Check if tr is text input as we want to ignore continuous typing actions
        const textInput = (0, $482628e63999f8c5$export$1a2f61e1ac72166a)(firstStep);
        if (textInput) return textInput;
        // Check if tr is adding/ removing empty lines as we want to ignore continuous typing actions
        const emptyLineAddedOrDeleted = (0, $86f46c8c874067bb$export$3b8bead5689e4d0b)(firstStep);
        if (emptyLineAddedOrDeleted) return emptyLineAddedOrDeleted;
        //Check if tr is removing content
        const isDeletingContent = (0, $4399309ce5f933ad$export$37e6d8d5ff035b23)(firstStep);
        if (isDeletingContent) return isDeletingContent;
        // Status nodes save status content in attributes and a new transaction is fired each keypress
        // Check if tr is updating status so we can handle actionCount correctly
        const status = (0, $b2e6adf84f490a28$export$dfe6977d1be089c2)(firstStep);
        if (status) return status;
    }
    // Check if tr is updating list type node because we want to ignore continuous typing actions and adding new list items
    const updatingListTypeNode = (0, $75c4b51b4b7a3f21$export$3dd64ceb881e5e4e)(firstStep);
    if (updatingListTypeNode) return updatingListTypeNode;
    // Check if tr is updating node attributes so we can track nodeAttributeChangeCount
    const nodeAttributeChange = (0, $cda9ff6f2f0b4de8$export$460c78c4e7d0df18)(tr, firstStep);
    if (nodeAttributeChange) return nodeAttributeChange;
    return undefined;
};






const $2190ed9eaff58293$export$8e97e3f7bfe68ba6 = (tr)=>{
    if (tr.getMeta('undoRedoPlugin$') === undefined) return false;
    let hasNonTextChange = false;
    tr.steps.forEach((step)=>{
        if (step instanceof (0, $eOaGc.ReplaceStep)) {
            const { slice: slice } = step;
            if (slice.content) slice.content.forEach((node)=>{
                if (node.type.name !== 'text') hasNonTextChange = true;
            });
        } else hasNonTextChange = true;
    });
    return hasNonTextChange;
};





const $48a3bee9e27bb8de$export$70c169bac24eb87d = (tr, insertPos, trType)=>{
    // Exclude the cases where trType is defined, as it is a specific action
    // that should not be considered for safe insert actions
    if (trType) return false;
    if (insertPos > tr.doc.content.size) return false;
    const [firstStep] = tr.steps;
    if (!(firstStep instanceof (0, $eOaGc.ReplaceStep))) return false;
    const firstStepPos = firstStep.from;
    if (firstStepPos === insertPos) return false;
    const $firstStepPos = tr.doc.resolve(firstStepPos);
    if ($firstStepPos.node().type.name === 'paragraph') return false;
    const firstStepParentNodeType = $firstStepPos.node($firstStepPos.depth)?.type.name;
    const $insertPos = tr.doc.resolve(insertPos);
    const parentNodeType = $insertPos.node($insertPos.depth - 1)?.type.name;
    return parentNodeType !== firstStepParentNodeType;
};


const $0432475e1c0f4fc4$var$textInputActions = [
    (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).TEXT_INPUT,
    (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
];
const $0432475e1c0f4fc4$var$listActions = [
    (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM,
    (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).INSERTING_NEW_LIST_TYPE_NODE
];
const $0432475e1c0f4fc4$var$continuousActions = [
    ...$0432475e1c0f4fc4$var$textInputActions,
    ...$0432475e1c0f4fc4$var$listActions,
    (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).UPDATING_STATUS
];
const $0432475e1c0f4fc4$var$checkIsDesiredAction = (trType, desiredActions)=>{
    return trType && desiredActions.includes(trType.type);
};
const $0432475e1c0f4fc4$var$getNewActionTypeCount = (shouldIncrement, currentCount)=>{
    return shouldIncrement ? currentCount + 1 : currentCount;
};
const $0432475e1c0f4fc4$export$e128bc0c2209d622 = ({ now: now, intentToStartEditTime: intentToStartEditTime, shouldPersistActiveSession: shouldPersistActiveSession, tr: tr, pluginState: pluginState, oldState: oldState, newState: newState })=>{
    const { actionTypeCount: actionTypeCount, timeOfLastTextInput: timeOfLastTextInput, totalActionCount: totalActionCount, previousTrType: previousTrType, safeInsertCount: safeInsertCount, contentSizeChanged: contentSizeChanged } = pluginState;
    const newPluginState = {
        ...pluginState,
        activeSessionTime: now - intentToStartEditTime,
        contentSizeChanged: contentSizeChanged + Math.abs(newState.doc.content.size - oldState.doc.content.size),
        intentToStartEditTime: intentToStartEditTime,
        shouldPersistActiveSession: shouldPersistActiveSession
    };
    const trType = (0, $17b513980ed8a17b$export$ea477ab911425d3e)(tr);
    const newSafeInsertCount = $0432475e1c0f4fc4$var$getNewActionTypeCount((0, $48a3bee9e27bb8de$export$70c169bac24eb87d)(tr, oldState.tr.selection.from, trType?.type), safeInsertCount);
    const newUndoCount = $0432475e1c0f4fc4$var$getNewActionTypeCount((0, $2190ed9eaff58293$export$8e97e3f7bfe68ba6)(tr), actionTypeCount.undoCount);
    if (!trType) return {
        ...newPluginState,
        totalActionCount: totalActionCount + 1,
        timeOfLastTextInput: undefined,
        actionTypeCount: {
            ...actionTypeCount,
            undoCount: newUndoCount
        },
        previousTrType: trType,
        safeInsertCount: newSafeInsertCount
    };
    // Below are conditions for special cases which should not increase action count if the previous action was the same or was textInput
    // Check if tr is updating the same status node
    const isNotNewStatus = trType.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).UPDATING_STATUS && previousTrType?.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).UPDATING_STATUS && trType?.extraData?.statusId === previousTrType?.extraData?.statusId;
    // Check if tr is adding text after adding a list node
    const isAddingTextToListNode = trType.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).TEXT_INPUT && $0432475e1c0f4fc4$var$checkIsDesiredAction(previousTrType, $0432475e1c0f4fc4$var$listActions);
    // Check if tr is adding new list item after text input
    const isAddingNewListItemAfterTextInput = previousTrType?.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).TEXT_INPUT && trType.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM;
    // Check if tr is textInput
    const isTextInput = $0432475e1c0f4fc4$var$textInputActions.includes(trType.type);
    // Don't increment action count if tr is text input, not a new status, adding text to list node or adding new list item if timeOfLastTextInput is set
    const shouldNotIncrementActionCount = timeOfLastTextInput && (isTextInput || isNotNewStatus || isAddingTextToListNode || isAddingNewListItemAfterTextInput);
    const newTotalActionCount = $0432475e1c0f4fc4$var$getNewActionTypeCount(!shouldNotIncrementActionCount, totalActionCount);
    // Increment textInputCount if tr is text input and previous action was not text input or list action
    const newTextInputCount = $0432475e1c0f4fc4$var$getNewActionTypeCount(isTextInput && !(timeOfLastTextInput && $0432475e1c0f4fc4$var$checkIsDesiredAction(previousTrType, [
        ...$0432475e1c0f4fc4$var$textInputActions,
        ...$0432475e1c0f4fc4$var$listActions
    ])), actionTypeCount.textInputCount);
    const newNodeAttrCount = $0432475e1c0f4fc4$var$getNewActionTypeCount(trType?.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).CHANGING_ATTRS, actionTypeCount.nodeAttributeChangeCount);
    const isRepeatedAttrAction = trType?.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).CHANGING_ATTRS && previousTrType?.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).CHANGING_ATTRS && trType.extraData.attr === previousTrType.extraData.attr && trType.extraData.from === previousTrType.extraData.from && trType.extraData.to === previousTrType.extraData.to;
    const newRepeatedActionCount = $0432475e1c0f4fc4$var$getNewActionTypeCount(isRepeatedAttrAction, pluginState.repeatedActionCount);
    const contentMoved = $0432475e1c0f4fc4$var$getNewActionTypeCount(trType?.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).MOVING_CONTENT, actionTypeCount.contentMovedCount);
    const newMarkChangeCount = $0432475e1c0f4fc4$var$getNewActionTypeCount(trType?.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).CHANGING_MARK, actionTypeCount.markChangeCount);
    const newContentDeletedCount = $0432475e1c0f4fc4$var$getNewActionTypeCount(trType?.type === (0, $1b8435ecd9a2213c$export$e4a712fff93fb00f).DELETING_CONTENT, actionTypeCount.contentDeletedCount);
    // timeOfLastTextInput should be set if tr includes continuous text input on the same node
    const shouldSetTimeOfLastTextInput = $0432475e1c0f4fc4$var$continuousActions.includes(trType.type) || isNotNewStatus;
    return {
        ...newPluginState,
        totalActionCount: newTotalActionCount,
        timeOfLastTextInput: shouldSetTimeOfLastTextInput ? now : undefined,
        actionTypeCount: {
            ...actionTypeCount,
            textInputCount: newTextInputCount,
            undoCount: newUndoCount,
            nodeAttributeChangeCount: newNodeAttrCount,
            contentMovedCount: contentMoved,
            markChangeCount: newMarkChangeCount,
            contentDeletedCount: newContentDeletedCount
        },
        previousTrType: trType,
        repeatedActionCount: newRepeatedActionCount,
        safeInsertCount: newSafeInsertCount
    };
};








const $fbfb509c045d6140$export$d18f9a4086c7ba4 = (tr)=>tr.steps.length > 0 && tr.steps?.some((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep) || step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $eOaGc.RemoveMarkStep) || step instanceof (0, $hdvEd.BatchAttrsStep));



var $gT4iv = parcelRequire("gT4iv");


var $73Kv0 = parcelRequire("73Kv0");




const $1ba19eb52c52f9d9$var$isResolvingLink = (tr)=>{
    // When links are added, there are two transactions that are fired and we want to ignore the last one where the link is resolved
    const linkStep = tr.steps.find((step)=>step instanceof (0, $73Kv0.LinkMetaStep));
    const hasReplaceStep = tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep));
    return Boolean(hasReplaceStep && linkStep instanceof (0, $73Kv0.LinkMetaStep) && linkStep.getMetadata()?.cardAction === 'RESOLVE');
};
const $1ba19eb52c52f9d9$var$checkTypeAheadStepStage = (tr)=>{
    // When nodes are inserted from typeahead, there are multiple transactions that are fired that changes the document
    // We want to ignore all but the last transaction where the node is inserted
    if (tr.getMeta('typeAheadPlugin$')?.action === 'INSERT_RAW_QUERY') return 'INSERT_RAW_QUERY';
    if (!tr.getMeta('appendedTransaction')) return false;
    const insertTypeAheadStep = tr.steps.find((step)=>step instanceof (0, $gT4iv.InsertTypeAheadStep));
    const replaceStep = tr.steps.find((step)=>step instanceof (0, $eOaGc.ReplaceStep));
    if (!insertTypeAheadStep || !replaceStep) return false;
    return insertTypeAheadStep instanceof (0, $gT4iv.InsertTypeAheadStep) && insertTypeAheadStep.stage;
};
const $1ba19eb52c52f9d9$export$54b973d42577e602 = (tr)=>{
    if ($1ba19eb52c52f9d9$var$isResolvingLink(tr)) return true;
    const typeAheadStepStage = $1ba19eb52c52f9d9$var$checkTypeAheadStepStage(tr);
    if (typeAheadStepStage) return typeAheadStepStage !== 'INSERTING_ITEM';
    else // Ignore all appended transactions apart from when typeahead is inserting an item
    return tr.getMeta('appendedTransaction');
};


const $72d4c7ad938eab5b$export$25eda213007f3f3b = new (0, $kCECX.PluginKey)('metricsPlugin');
const $72d4c7ad938eab5b$export$730217bf68c4a14 = {
    intentToStartEditTime: undefined,
    lastSelection: undefined,
    activeSessionTime: 0,
    totalActionCount: 0,
    contentSizeChanged: 0,
    shouldPersistActiveSession: undefined,
    timeOfLastTextInput: undefined,
    initialContent: undefined,
    actionTypeCount: {
        textInputCount: 0,
        nodeInsertionCount: 0,
        nodeAttributeChangeCount: 0,
        contentMovedCount: 0,
        nodeDeletionCount: 0,
        undoCount: 0,
        markChangeCount: 0,
        contentDeletedCount: 0
    },
    repeatedActionCount: 0,
    safeInsertCount: 0
};
const $72d4c7ad938eab5b$export$ae829ec7b2625219 = (api, userPreferencesProvider)=>{
    const timer = new (0, $3c966cf591950b96$export$533c4bb863159234)(api);
    return new (0, $kpCD8.SafePlugin)({
        key: $72d4c7ad938eab5b$export$25eda213007f3f3b,
        state: {
            init: (_, state)=>{
                return {
                    ...$72d4c7ad938eab5b$export$730217bf68c4a14,
                    initialContent: state.doc.content
                };
            },
            // eslint-disable-next-line @typescript-eslint/max-params
            apply (tr, pluginState, oldState, newState) {
                // Return if transaction is remote or replaceDocument is set
                if (tr.getMeta('isRemote') || tr.getMeta('replaceDocument')) return pluginState;
                const meta = tr.getMeta($72d4c7ad938eab5b$export$25eda213007f3f3b);
                // If the active session is stopped, reset the plugin state, and set initialContent to new doc content
                if (meta && meta.stopActiveSession) return {
                    ...$72d4c7ad938eab5b$export$730217bf68c4a14,
                    initialContent: newState.doc.content
                };
                const shouldPersistActiveSession = meta?.shouldPersistActiveSession ?? pluginState.shouldPersistActiveSession;
                const hasDocChanges = (0, $fbfb509c045d6140$export$d18f9a4086c7ba4)(tr);
                let intentToStartEditTime = meta?.intentToStartEditTime || pluginState.intentToStartEditTime;
                const now = performance.now();
                // If there is no intentToStartEditTime and there are no doc changes, return the plugin state
                if (!intentToStartEditTime && !hasDocChanges && !tr.storedMarksSet) return {
                    ...pluginState,
                    shouldPersistActiveSession: shouldPersistActiveSession
                };
                // Set intentToStartEditTime if it is not set and there are doc changes or marks are set
                if (!intentToStartEditTime && (hasDocChanges || tr.storedMarksSet)) intentToStartEditTime = now;
                // Start active session timer if intentToStartEditTime is defined, shouldStartTimer is true and shouldPersistActiveSession is false
                // shouldPersistActiveSession is true when dragging block controls and when insert menu is open as user is interacting with the editor without making doc changes
                // Timer should start when menu closes or dragging stops
                if (intentToStartEditTime && meta?.shouldStartTimer && !shouldPersistActiveSession) timer.startTimer();
                if (hasDocChanges) {
                    timer.startTimer();
                    if ((0, $1ba19eb52c52f9d9$export$54b973d42577e602)(tr)) return {
                        ...pluginState,
                        shouldPersistActiveSession: shouldPersistActiveSession
                    };
                    const newPluginState = (0, $0432475e1c0f4fc4$export$e128bc0c2209d622)({
                        now: now,
                        intentToStartEditTime: intentToStartEditTime,
                        shouldPersistActiveSession: shouldPersistActiveSession,
                        tr: tr,
                        pluginState: pluginState,
                        oldState: oldState,
                        newState: newState
                    });
                    return newPluginState;
                }
                return {
                    ...pluginState,
                    lastSelection: meta?.newSelection || pluginState.lastSelection,
                    intentToStartEditTime: intentToStartEditTime,
                    shouldPersistActiveSession: shouldPersistActiveSession
                };
            }
        },
        view (view) {
            const fireAnalyticsEvent = ()=>{
                const pluginState = $72d4c7ad938eab5b$export$25eda213007f3f3b.getState(view.state);
                if (!pluginState) return;
                let toolbarDocking;
                if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) toolbarDocking = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                const payloadToSend = (0, $d1a007782642c427$export$4feda93c1c6b2d80)({
                    currentContent: view.state.doc.content,
                    pluginState: pluginState,
                    toolbarDocking: toolbarDocking || undefined
                });
                if (pluginState && pluginState.totalActionCount > 0 && pluginState.activeSessionTime > 0) api?.analytics?.actions?.fireAnalyticsEvent(payloadToSend, undefined, {
                    immediate: true
                });
            };
            const unbindBeforeUnload = (0, $cbY7C.bind)(window, {
                type: 'beforeunload',
                listener: ()=>{
                    fireAnalyticsEvent();
                }
            });
            return {
                destroy () {
                    fireAnalyticsEvent();
                    timer.cleanupTimer();
                    unbindBeforeUnload();
                }
            };
        },
        props: {
            handleDOMEvents: {
                click: (view)=>{
                    const newSelection = view.state.tr.selection;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (pluginState?.lastSelection?.from !== newSelection.from && pluginState?.lastSelection?.to !== newSelection.to) api?.core.actions.execute(api?.metrics.commands.handleIntentToStartEdit({
                        newSelection: newSelection
                    }));
                    return false;
                }
            }
        }
    });
};



const $a7418b317b2666fe$export$3353f6727450fd85 = ({ config: config, api: api })=>({
        name: 'metrics',
        pmPlugins () {
            return [
                {
                    name: 'metrics',
                    plugin: ()=>(0, $72d4c7ad938eab5b$export$ae829ec7b2625219)(api, config?.userPreferencesProvider)
                }
            ];
        },
        commands: {
            setContentMoved: ()=>({ tr: tr })=>{
                    return tr.setMeta((0, $72d4c7ad938eab5b$export$25eda213007f3f3b), {
                        contentMoved: true
                    });
                },
            startActiveSessionTimer: ()=>({ tr: tr })=>{
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (!pluginState?.intentToStartEditTime) return tr;
                    return tr.setMeta((0, $72d4c7ad938eab5b$export$25eda213007f3f3b), {
                        shouldStartTimer: true,
                        shouldPersistActiveSession: false
                    });
                },
            stopActiveSession: ()=>({ tr: tr })=>{
                    if (!api) return tr;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (pluginState?.shouldPersistActiveSession) return tr;
                    if (pluginState && pluginState.totalActionCount > 0 && pluginState.activeSessionTime > 0) {
                        let toolbarDocking;
                        if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) toolbarDocking = toolbarDocking = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : config?.userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                        const payloadToSend = (0, $d1a007782642c427$export$4feda93c1c6b2d80)({
                            currentContent: tr.doc.content,
                            pluginState: pluginState,
                            toolbarDocking: toolbarDocking || undefined
                        });
                        api?.analytics?.actions.attachAnalyticsEvent(payloadToSend)(tr);
                    }
                    tr.setMeta((0, $72d4c7ad938eab5b$export$25eda213007f3f3b), {
                        stopActiveSession: true
                    });
                    tr.setMeta('scrollIntoView', false);
                    tr.setMeta('addToHistory', false);
                    return tr;
                },
            handleIntentToStartEdit: ({ newSelection: newSelection, shouldStartTimer: shouldStartTimer = true, shouldPersistActiveSession: shouldPersistActiveSession })=>({ tr: tr })=>{
                    if (!api) return tr;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (shouldPersistActiveSession && pluginState?.intentToStartEditTime) return tr.setMeta((0, $72d4c7ad938eab5b$export$25eda213007f3f3b), {
                        shouldPersistActiveSession: shouldPersistActiveSession
                    });
                    if (!pluginState || pluginState.intentToStartEditTime) return tr;
                    tr.setMeta((0, $72d4c7ad938eab5b$export$25eda213007f3f3b), {
                        intentToStartEditTime: performance.now(),
                        shouldStartTimer: shouldStartTimer,
                        newSelection: newSelection,
                        shouldPersistActiveSession: shouldPersistActiveSession
                    });
                    return tr;
                }
        },
        getSharedState (editorState) {
            if (!editorState) return 0, $72d4c7ad938eab5b$export$730217bf68c4a14;
            return (0, $72d4c7ad938eab5b$export$25eda213007f3f3b).getState(editorState);
        }
    });
module.exports["metricsPlugin"] = $a7418b317b2666fe$export$3353f6727450fd85;

});

parcelRegister("dvcAA", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $8bmf7 = parcelRequire("8bmf7");


var $kpCD8 = parcelRequire("kpCD8");


var $1KOhB = parcelRequire("1KOhB");


var $jkcNT = parcelRequire("jkcNT");


var $aPdNQ = parcelRequire("aPdNQ");

const $f6fb298cd14cf64f$export$60dfa91bf509272e = (nodeAdf)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        try {
            const docEnd = state.doc.content.size;
            const modifiedNode = (0, $aPdNQ.Node).fromJSON(schema, nodeAdf);
            modifiedNode.check();
            tr.insert(tr.mapping.map(docEnd), modifiedNode).scrollIntoView();
            dispatch(tr);
            return {
                status: 'success'
            };
        } catch  {
            return {
                status: 'failed'
            };
        }
    };





var $a0cf507b715ddff8$export$4e6955c142f7044d = /*#__PURE__*/ function(SelectionExtensionActionTypes) {
    SelectionExtensionActionTypes["SET_ACTIVE_EXTENSION"] = "set-active-extension";
    SelectionExtensionActionTypes["UPDATE_ACTIVE_EXTENSION_COORDS"] = "update-active-extension-coords";
    SelectionExtensionActionTypes["CLEAR_ACTIVE_EXTENSION"] = "clear-active-extension";
    SelectionExtensionActionTypes["SET_SELECTED_NODE"] = "set-selected-node";
    SelectionExtensionActionTypes["START_TRACK_CHANGES"] = "start-track-changes";
    return SelectionExtensionActionTypes;
}({});






var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


const $58f46f17c0beb3e2$export$dcf960b4b6957ad0 = new (0, $kCECX.PluginKey)('selectionExtensionPlugin');
const $58f46f17c0beb3e2$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $58f46f17c0beb3e2$export$dcf960b4b6957ad0,
        state: {
            init: ()=>{
                return {
                    activeExtension: undefined
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($58f46f17c0beb3e2$export$dcf960b4b6957ad0);
                switch(meta?.type){
                    case (0, $a0cf507b715ddff8$export$4e6955c142f7044d).SET_ACTIVE_EXTENSION:
                        return {
                            ...pluginState,
                            activeExtension: meta.extension
                        };
                    case (0, $a0cf507b715ddff8$export$4e6955c142f7044d).CLEAR_ACTIVE_EXTENSION:
                        return {
                            ...pluginState,
                            activeExtension: undefined
                        };
                    case (0, $a0cf507b715ddff8$export$4e6955c142f7044d).SET_SELECTED_NODE:
                        return {
                            ...pluginState,
                            selectedNode: meta.selectedNode,
                            nodePos: meta.nodePos,
                            startTrackChanges: true,
                            docChangedAfterClick: false
                        };
                    case (0, $a0cf507b715ddff8$export$4e6955c142f7044d).START_TRACK_CHANGES:
                        return {
                            ...pluginState,
                            startTrackChanges: meta.startTrackChanges
                        };
                }
                const docChangedAfterClick = pluginState.startTrackChanges && tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
                if (docChangedAfterClick) return {
                    ...pluginState,
                    docChangedAfterClick: true,
                    startTrackChanges: false
                };
                // clear activeExtension if the selection has changed and not empty
                if (tr.selectionSet && !tr.selection.empty) return {
                    ...pluginState,
                    activeExtension: undefined
                };
                return pluginState;
            }
        }
    });
};


const $a2eadafa3d76af1c$export$c330a53bc779bb94 = (nodeAdf, api)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // we need to track if any changes were made since user click the toolbar button
        const docChangedAfterClick = (0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0).getState(state)?.docChangedAfterClick || false;
        tr.setMeta((0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0), {
            type: (0, $a0cf507b715ddff8$export$4e6955c142f7044d).START_TRACK_CHANGES,
            startTrackChanges: false
        });
        if (docChangedAfterClick) {
            dispatch(tr);
            return {
                status: 'document-changed'
            };
        }
        try {
            const selectedNode = (0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0).getState(state)?.selectedNode;
            const nodePos = (0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0).getState(state)?.nodePos;
            if (!selectedNode || nodePos === undefined) throw new Error('No selected node or node position found');
            const endPos = selectedNode.type.name === 'doc' ? nodePos + selectedNode.content.size : nodePos + selectedNode.nodeSize;
            const modifiedNode = (0, $aPdNQ.Node).fromJSON(schema, nodeAdf);
            modifiedNode.check();
            const updatedTr = tr.replaceWith(nodePos, endPos, modifiedNode).scrollIntoView();
            // Allow this transaction in view mode and apply changes
            dispatch(api?.editorViewModeEffects?.actions.allowViewModeTransaction(updatedTr) || updatedTr);
            return {
                status: 'success'
            };
        } catch  {
            dispatch(tr);
            return {
                status: 'failed-to-replace'
            };
        }
    };




var $jv11C = parcelRequire("jv11C");


var $2lPWP = parcelRequire("2lPWP");











var $7Y8M5 = parcelRequire("7Y8M5");


var $8HW7o = parcelRequire("8HW7o");

var $8Z43Z = parcelRequire("8Z43Z");


var $iDrrr = parcelRequire("iDrrr");

const $5703b9d7b886d324$export$7a43d8c578c062dc = (view, from, to, offset = {
    top: 0,
    bottom: 0
})=>{
    let top = Infinity, left = Infinity, bottom = -Infinity, right = -Infinity;
    // initial version
    for(let pos = from; pos <= to; pos++){
        const coords = view.coordsAtPos(pos);
        top = Math.min(top, coords.top);
        left = Math.min(left, coords.left);
        bottom = Math.max(bottom, coords.bottom);
        right = Math.max(right, coords.right);
    }
    top = top - offset.top;
    bottom = bottom - offset.bottom;
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right
    };
};








const $b75ddb4d871833c4$var$LIST_ITEM_TYPES = new Set([
    'taskItem',
    'decisionItem',
    'listItem'
]);
const $b75ddb4d871833c4$var$LIST_NODE_TYPES = new Set([
    'taskList',
    'bulletList',
    'orderedList',
    'decisionList'
]);
/**
 * Build a JSON pointer path for a node within the selectedNode structure.
 * @param pathIndices - Array of content indices representing the path to the node
 */ const $b75ddb4d871833c4$var$buildJsonPointer = (pathIndices)=>pathIndices.map((index)=>`/content/${index}`).join('');
const $b75ddb4d871833c4$export$e39cf9e18b11686e = (selectedNode, selectedNodePos, $from, $to)=>{
    const selectionStart = $from.pos;
    const selectionEnd = $to.pos;
    const tokenOffset = selectedNode.type.name === 'doc' ? 0 : 1;
    const nodeStart = selectedNodePos + tokenOffset;
    const nodeEnd = selectedNodePos + selectedNode.nodeSize - tokenOffset;
    // If selection spans entire content, return undefined (complete block selection)
    if (selectionStart <= nodeStart && selectionEnd >= nodeEnd) return undefined;
    const selectionRanges = [];
    // Traverse the selectedNode and find all nodes/text within the selection range
    const traverse = (node, nodePos, path)=>{
        const nodeEndPos = nodePos + node.nodeSize;
        // Skip nodes completely before or after selection
        if (nodeEndPos <= selectionStart || nodePos >= selectionEnd) return;
        if (node.isText) {
            const textStart = nodePos;
            const textEnd = nodePos + (node.text?.length || 0);
            const rangeStart = Math.max(textStart, selectionStart);
            const rangeEnd = Math.min(textEnd, selectionEnd);
            if (rangeStart < rangeEnd) {
                const pointer = `${$b75ddb4d871833c4$var$buildJsonPointer(path)}/text`;
                selectionRanges.push({
                    start: {
                        pointer: pointer,
                        position: rangeStart - textStart
                    },
                    end: {
                        pointer: pointer,
                        position: rangeEnd - textStart
                    }
                });
            }
        } else if (node.content.size > 0) {
            const contentStart = nodePos + 1;
            const contentEnd = nodeEndPos - 1;
            const isWholeBlockSelected = node.isBlock && !node.isTextblock && !$b75ddb4d871833c4$var$LIST_NODE_TYPES.has(node.type.name) && selectionStart <= contentStart && selectionEnd >= contentEnd;
            if (isWholeBlockSelected) {
                const pointer = $b75ddb4d871833c4$var$buildJsonPointer(path);
                selectionRanges.push({
                    start: {
                        pointer: pointer
                    },
                    end: {
                        pointer: pointer
                    }
                });
            } else {
                // Traverse children for textblocks, lists, or partial selections
                let childPos = nodePos + 1;
                for(let i = 0; i < node.content.childCount; i++){
                    traverse(node.content.child(i), childPos, [
                        ...path,
                        i
                    ]);
                    childPos += node.content.child(i).nodeSize;
                }
            }
        } else if (nodePos >= selectionStart && nodeEndPos <= selectionEnd) {
            // Handle leaf nodes (e.g., hardBreak, image)
            const pointer = $b75ddb4d871833c4$var$buildJsonPointer(path);
            selectionRanges.push({
                start: {
                    pointer: pointer
                },
                end: {
                    pointer: pointer
                }
            });
        }
    };
    // Traverse each child of the selectedNode
    let childPos = nodeStart;
    for(let i = 0; i < selectedNode.content.childCount; i++){
        const child = selectedNode.content.child(i);
        traverse(child, childPos, [
            i
        ]);
        childPos += child.nodeSize;
    }
    return selectionRanges.length > 0 ? selectionRanges : undefined;
};
/** Find the depth of the deepest common ancestor node. */ const $b75ddb4d871833c4$var$getCommonAncestorDepth = ($from, $to)=>{
    const minDepth = Math.min($from.depth, $to.depth);
    for(let d = 0; d <= minDepth; d++){
        if ($from.node(d) !== $to.node(d)) return d - 1;
    }
    return minDepth;
};
const $b75ddb4d871833c4$export$d78ea2c01bb8e82a = ($from, $to)=>{
    const commonDepth = $b75ddb4d871833c4$var$getCommonAncestorDepth($from, $to);
    // Single pass: look for topmost list OR first non-list parent
    let topMostList = null;
    let topMostListPos = -1;
    let firstNonListParent = null;
    let firstNonListParentPos = -1;
    for(let depth = commonDepth; depth > 0; depth--){
        const node = $from.node(depth);
        if ($b75ddb4d871833c4$var$LIST_NODE_TYPES.has(node.type.name)) {
            // Keep updating to find the topmost list (last one found going upward)
            topMostList = node;
            topMostListPos = $from.before(depth);
        } else if (!firstNonListParent && node.type.name !== 'doc') {
            // Only capture the first (innermost) non-list parent
            firstNonListParent = node;
            firstNonListParentPos = $from.before(depth);
        }
    }
    // Return topmost list if found, else first non-list parent
    if (topMostList) return {
        node: topMostList,
        pos: topMostListPos
    };
    return {
        node: firstNonListParent,
        pos: firstNonListParentPos
    };
};
const $b75ddb4d871833c4$export$d82d0b7f23147578 = (schema, nodes)=>{
    if (nodes.length === 0) return schema.nodes.doc.createChecked({}, (0, $aPdNQ.Fragment).empty);
    // Single node: return unwrapped
    if (nodes.length === 1) return nodes[0];
    // For multiple nodes, wrap in doc
    try {
        return schema.node('doc', null, (0, $aPdNQ.Fragment).from(nodes));
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
        return schema.nodes.doc.createChecked({}, (0, $aPdNQ.Fragment).empty);
    }
};
const $b75ddb4d871833c4$export$9234bebc22759e = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return {
        selectedNode: $from.node(),
        selectionRanges: [
            {
                start: {
                    pointer: `/content/${$from.index()}/text`,
                    position: $from.parentOffset
                },
                end: {
                    pointer: `/content/${$from.index()}/text`,
                    position: $to.parentOffset
                }
            }
        ],
        nodePos: $from.before()
    };
};
const $b75ddb4d871833c4$export$12cdfddaa8fbd6f3 = (selection, schema)=>{
    const { $from: $from, $to: $to } = selection;
    // For same parent selections but not the r, check for parent container
    if ($from.parent === $to.parent && $from.depth > 0) {
        const { node: parentNode, pos: parentNodePos } = $b75ddb4d871833c4$export$d78ea2c01bb8e82a($from, $to);
        if (parentNode) {
            const selectionRanges = $b75ddb4d871833c4$export$e39cf9e18b11686e(parentNode, parentNodePos, $from, $to);
            return {
                selectedNode: parentNode,
                nodePos: parentNodePos,
                selectionRanges: selectionRanges
            };
        }
        const nodePos = $from.before();
        const selectionRanges = $b75ddb4d871833c4$export$e39cf9e18b11686e($from.node(), nodePos, $from, $to);
        return {
            selectedNode: $from.node(),
            nodePos: nodePos,
            selectionRanges: selectionRanges
        };
    }
    // find the common ancestor
    const range = $from.blockRange($to);
    if (!range) return {
        selectedNode: $from.node(),
        nodePos: $from.depth > 0 ? $from.before() : $from.pos
    };
    if (range.parent.type.name !== 'doc') {
        // For lists, find topmost list parent; otherwise use immediate parent
        if ($b75ddb4d871833c4$var$LIST_NODE_TYPES.has(range.parent.type.name) || $b75ddb4d871833c4$var$LIST_ITEM_TYPES.has(range.parent.type.name)) {
            const { node: topList, pos: topListPos } = $b75ddb4d871833c4$export$d78ea2c01bb8e82a($from, $to);
            if (topList) {
                const selectionRanges = $b75ddb4d871833c4$export$e39cf9e18b11686e(topList, topListPos, $from, $to);
                return {
                    selectedNode: topList,
                    nodePos: topListPos,
                    selectionRanges: selectionRanges
                };
            }
        }
        const nodePos = range.depth > 0 ? $from.before(range.depth) : 0;
        const selectionRanges = $b75ddb4d871833c4$export$e39cf9e18b11686e(range.parent, nodePos, $from, $to);
        return {
            selectedNode: range.parent,
            nodePos: nodePos,
            selectionRanges: selectionRanges
        };
    }
    // Extract complete nodes within the block range
    const nodes = [];
    for(let i = range.startIndex; i < range.endIndex; i++)nodes.push(range.parent.child(i));
    const selectedNode = $b75ddb4d871833c4$export$d82d0b7f23147578(schema, nodes);
    const selectionRanges = $b75ddb4d871833c4$export$e39cf9e18b11686e(selectedNode, range.start, $from, $to);
    return {
        selectedNode: selectedNode,
        nodePos: range.start,
        selectionRanges: selectionRanges
    };
};


const $4f34341d167d1204$var$getSelectedRect = (selection)=>{
    const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
    const table = $anchorCell.node(-1);
    const map = (0, $8Z43Z.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    return rect;
};
const $4f34341d167d1204$var$getSelectionInfoFromCellSelection = (selection)=>{
    const selectedNode = selection.$anchorCell.node(-1);
    const nodePos = selection.$anchorCell.before(-1);
    const selectionRanges = [];
    const rect = $4f34341d167d1204$var$getSelectedRect(selection);
    for(let row = rect.top; row < rect.bottom; row++)selectionRanges.push({
        start: {
            pointer: `/content/${row}/content/${rect.left}`
        },
        end: {
            pointer: `/content/${row}/content/${rect.right - 1}`
        }
    });
    return {
        selectedNode: selectedNode,
        selectionRanges: selectionRanges,
        nodePos: nodePos
    };
};
const $4f34341d167d1204$export$6a4dcb7c65e25fd5 = (view, api)=>{
    const { selection: currentSelection } = view.state;
    const toolbarDocking = api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition;
    const isEditMode = Boolean(api?.editorViewMode?.sharedState.currentState()?.mode === 'edit');
    const shouldOffsetToolbarHeight = toolbarDocking === 'top' && isEditMode;
    const { from: from, to: to } = currentSelection;
    const text = view.state.doc.textBetween(from, to, '\n');
    const coords = (0, $5703b9d7b886d324$export$7a43d8c578c062dc)(view, from, to, {
        top: shouldOffsetToolbarHeight ? (0, $7Y8M5.akEditorFullPageToolbarHeight) : 0,
        bottom: shouldOffsetToolbarHeight ? (0, $7Y8M5.akEditorFullPageToolbarHeight) : 0
    });
    return {
        text: text,
        from: from,
        to: to,
        coords: coords
    };
};
const $4f34341d167d1204$export$d2b80e0fb1a7bb6 = (selection, view, api)=>{
    const toolbarDocking = (0, $iDrrr.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
    const isEditMode = Boolean(api?.editorViewMode?.sharedState.currentState()?.mode === 'edit');
    const shouldOffsetToolbarHeight = toolbarDocking === 'top' && isEditMode;
    const { from: from, to: to } = selection;
    const text = view.state.doc.textBetween(from, to, '\n');
    const coords = (0, $5703b9d7b886d324$export$7a43d8c578c062dc)(view, from, to, {
        top: shouldOffsetToolbarHeight ? (0, $7Y8M5.akEditorFullPageToolbarHeight) : 0,
        bottom: shouldOffsetToolbarHeight ? (0, $7Y8M5.akEditorFullPageToolbarHeight) : 0
    });
    return {
        text: text,
        from: from,
        to: to,
        coords: coords
    };
};
const $4f34341d167d1204$export$e842a552462e723a = (state)=>{
    const { schema: schema, selection: selection } = state;
    const slice = selection.content();
    let newDoc;
    try {
        const { schema: schema } = state;
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $eOaGc.Transform)(doc);
        newDoc = transform.replaceRange(0, 2, slice).doc;
    } catch (error) {
        newDoc = schema.nodes.doc.createChecked({}, (0, $aPdNQ.Fragment).empty);
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
    }
    const serializer = new (0, $2lPWP.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(newDoc);
    return {
        selectedNodeAdf: selectedNodeAdf
    };
};
const $4f34341d167d1204$export$a2bc00eaece873ac = (selection)=>{
    const { schema: schema } = selection.$from.doc.type;
    const slice = selection.content();
    let newDoc;
    try {
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $eOaGc.Transform)(doc);
        newDoc = transform.replaceRange(0, 2, slice).doc;
    } catch (error) {
        newDoc = schema.nodes.doc.createChecked({}, (0, $aPdNQ.Fragment).empty);
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
    }
    const serializer = new (0, $2lPWP.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(newDoc);
    return {
        selectedNodeAdf: selectedNodeAdf
    };
};
function $4f34341d167d1204$export$c794b208e2d52a35(state) {
    const selection = state.selection;
    let selectionInfo = {
        selectedNode: selection.$from.node(),
        nodePos: selection.$from.depth > 0 ? selection.$from.before() : selection.from
    };
    if (selection instanceof (0, $kCECX.TextSelection)) selectionInfo = (0, $b75ddb4d871833c4$export$12cdfddaa8fbd6f3)(selection, state.schema);
    else if (selection instanceof (0, $8HW7o.CellSelection)) selectionInfo = $4f34341d167d1204$var$getSelectionInfoFromCellSelection(selection);
    const serializer = new (0, $2lPWP.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(selectionInfo.selectedNode);
    return {
        ...selectionInfo,
        selectedNodeAdf: selectedNodeAdf
    };
}
function $4f34341d167d1204$export$a93a74bd28a4df9a(selection) {
    const schema = selection.$from.doc.type.schema;
    let selectionInfo = {
        selectedNode: selection.$from.node(),
        nodePos: selection.$from.depth > 0 ? selection.$from.before() : selection.from
    };
    if (selection instanceof (0, $kCECX.TextSelection)) selectionInfo = (0, $b75ddb4d871833c4$export$12cdfddaa8fbd6f3)(selection, schema);
    else if (selection instanceof (0, $8HW7o.CellSelection)) selectionInfo = $4f34341d167d1204$var$getSelectionInfoFromCellSelection(selection);
    else if (selection instanceof (0, $kCECX.NodeSelection)) selectionInfo = {
        selectedNode: selection.node,
        nodePos: selection.from
    };
    const serializer = new (0, $2lPWP.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(selectionInfo.selectedNode);
    return {
        ...selectionInfo,
        selectedNodeAdf: selectedNodeAdf
    };
}







var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");




const $a7603d5babff7b72$export$26a4fbd96883483b = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    const componentRef = (0, $cozmU.useRef)();
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { activeExtension: activeExtension, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selectionExtension',
        'editorViewMode'
    ], (states)=>({
            activeExtension: states.selectionExtensionState?.activeExtension,
            mode: states.editorViewModeState?.mode
        }));
    // Closed from active extension
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute(api?.selectionExtension.commands.clearActiveExtension());
        // Clears reference to active component
        componentRef.current = undefined;
        if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        });
    }, [
        editorAnalyticsAPI,
        api
    ]);
    // Closed from editor page mode change
    (0, $cozmU.useEffect)(()=>{
        if (componentRef.current !== undefined) handleOnClose();
    }, [
        handleOnClose,
        mode
    ]);
    // Viewed analytics event for component mount
    (0, $cozmU.useEffect)(()=>{
        const extension = activeExtension?.extension;
        if (!extension) return;
        if (isToolbarAIFCEnabled || (0, $jkcNT.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        })) {
            let currentComponent;
            if ('contentComponent' in extension && extension.contentComponent !== undefined) currentComponent = extension.contentComponent;
            else if ('component' in extension && extension.component !== undefined) currentComponent = extension.component;
            if (componentRef.current !== currentComponent && currentComponent !== undefined) {
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).VIEWED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                });
                // Sets reference to active component
                componentRef.current = currentComponent;
            }
            return;
        }
        // delete this when cleaning up platform_editor_toolbar_aifc
        if (extension && 'component' in extension && componentRef.current !== extension.component && extension.component !== undefined) {
            if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).VIEWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            });
            // Sets reference to active component
            componentRef.current = extension.component;
        }
    }, [
        activeExtension,
        editorAnalyticsAPI,
        isToolbarAIFCEnabled
    ]);
    const extension = activeExtension?.extension;
    if (!extension) return null;
    if (isToolbarAIFCEnabled || (0, $jkcNT.editorExperiment)('platform_editor_block_menu', true, {
        exposure: true
    })) {
        const hasContentComponent = (ext)=>{
            return 'contentComponent' in ext && ext.contentComponent !== undefined;
        };
        const hasComponent = (ext)=>{
            return 'component' in ext && ext.component !== undefined;
        };
        let ExtensionComponent;
        if (hasContentComponent(extension)) ExtensionComponent = extension.contentComponent;
        else if (hasComponent(extension)) ExtensionComponent = extension.component;
        if (!ExtensionComponent) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ExtensionComponent, {
            closeExtension: handleOnClose,
            selection: activeExtension.selection
        });
    }
    // delete this when cleaning up platform_editor_toolbar_aifc
    if (!('component' in extension) || !extension.component) return null;
    const ExtensionComponent = extension.component;
    return /*#__PURE__*/ (0, $8aG6j.jsx)(ExtensionComponent, {
        closeExtension: handleOnClose,
        selection: activeExtension.selection
    });
};


const $4669e6ae9628b150$export$7cddd6f4296c4a51 = (extensionList, toolbarType)=>{
    return extensionList.reduce((acc, extension)=>{
        const toolbarConfig = extension[toolbarType];
        if (toolbarConfig?.getToolbarItem) acc.push({
            getToolbarItem: toolbarConfig.getToolbarItem,
            getMenuItems: toolbarConfig.getMenuItems
        });
        return acc;
    }, []);
};
const $4669e6ae9628b150$export$1c1c89b40fcaaa6e = (extensionList, targetSource)=>{
    return extensionList.reduce((acc, extension)=>{
        const { source: source, inlineToolbar: inlineToolbar } = extension;
        if (source === targetSource && inlineToolbar?.getMenuItems && !inlineToolbar.getToolbarItem) {
            const menuItems = inlineToolbar.getMenuItems();
            menuItems.forEach((menuItem)=>{
                // Only process ExtensionMenuItemConfiguration, skip ExtensionMenuSectionConfiguration
                if ('label' in menuItem && 'icon' in menuItem) acc.push({
                    name: menuItem.label,
                    icon: menuItem.icon,
                    onClick: menuItem.onClick,
                    isDisabled: ()=>!!menuItem.isDisabled,
                    component: menuItem.contentComponent
                });
            });
        }
        return acc;
    }, []);
};









var $9RT19 = parcelRequire("9RT19");

var $gLi18 = parcelRequire("gLi18");

var $ldbHR = parcelRequire("ldbHR");

const $36ce839b55d5fa27$export$9b00cbcfa1039aae = ({ primaryToolbarItemExtensions: primaryToolbarItemExtensions })=>{
    // NEXT PR: need to render a separator after – if there are extensions added
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: primaryToolbarItemExtensions.map((toolbarItemExtension, _i)=>{
            const toolbarItem = toolbarItemExtension.getToolbarItem();
            return /*#__PURE__*/ (0, $8aG6j.jsx)($36ce839b55d5fa27$export$ac67b09b2512a582, {
                toolbarItem: toolbarItem
            }, toolbarItem.tooltip);
        })
    });
};
const $36ce839b55d5fa27$export$ac67b09b2512a582 = ({ toolbarItem: toolbarItem, getMenuItems: getMenuItems })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { icon: Icon, tooltip: tooltip, isDisabled: isDisabled, onClick: onClick, label: _label } = toolbarItem;
    if (!getMenuItems) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
        spacing: "default",
        disabled: isDisabled,
        selected: isOpen,
        title: tooltip,
        "aria-label": tooltip,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: tooltip
        })
    });
    const toggleOpen = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const toggleOpenByKeyboard = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleOpen();
        }
    };
    const handleItemActivated = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        item.onClick?.();
        if (shouldCloseMenu) setIsOpen(false);
    };
    const handleOnOpenChange = (attrs)=>{
        setIsOpen(!!attrs?.isOpen);
    };
    const items = isOpen ? // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    getMenuItems().map((menuItem, i)=>{
        // Only process ExtensionMenuItemConfiguration, skip ExtensionMenuSectionConfiguration
        if ('label' in menuItem) {
            const Icon = menuItem.icon;
            return {
                key: `menu-item-${i}`,
                content: menuItem.label,
                elemBefore: Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                    label: menuItem.label
                }) : undefined,
                onClick: ()=>{
                    menuItem.onClick?.();
                // NEXT PR: here we need to set the active extension so the contentComponent can render
                // menuItem.contentComponent
                },
                isDisabled: menuItem.isDisabled,
                'aria-label': menuItem.label,
                value: {
                    name: menuItem.label
                }
            };
        }
        return undefined;
    }).filter((item)=>item !== undefined) : [];
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gLi18.DropdownMenuWithKeyboardNavigation), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        items: [
            {
                items: items
            }
        ],
        isOpen: isOpen,
        onItemActivated: handleItemActivated,
        onOpenChange: handleOnOpenChange,
        fitWidth: 200,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
            spacing: "default",
            disabled: isDisabled,
            selected: isOpen,
            title: tooltip,
            "aria-label": tooltip,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            onClick: toggleOpen,
            onKeyDown: toggleOpenByKeyboard,
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                label: tooltip
            })
        })
    });
};





parcelRequire("cozmU");



const $450561cc69409a4c$export$6937b1e97e59d958 = ({ overflowOptions: overflowOptions, extensionList: extensionList = [] })=>{
    const inlineToolbarItemExtensions = (0, $4669e6ae9628b150$export$7cddd6f4296c4a51)(extensionList, 'inlineToolbar');
    return {
        items: [
            ...inlineToolbarItemExtensions.length ? [
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                ...inlineToolbarItemExtensions.map(({ getToolbarItem: getToolbarItem, getMenuItems: getMenuItems })=>({
                        type: 'custom',
                        render: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $36ce839b55d5fa27$export$ac67b09b2512a582), {
                                toolbarItem: getToolbarItem(),
                                getMenuItems: getMenuItems
                            }),
                        fallback: [],
                        supportsViewMode: true
                    }))
            ] : [],
            {
                type: 'separator',
                fullHeight: true,
                supportsViewMode: true
            },
            {
                type: 'overflow-dropdown',
                dropdownWidth: 240,
                supportsViewMode: true,
                options: overflowOptions
            }
        ],
        rank: -6
    };
};





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $ieeJu = parcelRequire("ieeJu");




parcelRequire("cozmU");


var $bFSJa = parcelRequire("bFSJa");


var $dVKvM = parcelRequire("dVKvM");


var $9KSWX = parcelRequire("9KSWX");


var $iMnC5 = parcelRequire("iMnC5");




const $a7e7f5c957f16d99$export$2ce376c2cc3355c8 = ({ extensionMenuItems: extensionMenuItems, api: api })=>{
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    if (!extensionMenuItems?.length || !editorView || !api) return null;
    const onClickHandle = (extension)=>()=>{
            if (extension.contentComponent) {
                const selection = (0, $4f34341d167d1204$export$6a4dcb7c65e25fd5)(editorView, api);
                api.core.actions.execute(api.selectionExtension.commands.setActiveExtension({
                    extension: extension,
                    selection: selection
                }));
            }
            api.core.actions.execute(({ tr: tr })=>{
                const { selectedNode: selectedNode, nodePos: nodePos } = (0, $4f34341d167d1204$export$a93a74bd28a4df9a)(tr.selection);
                tr.setMeta((0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0), {
                    type: (0, $a0cf507b715ddff8$export$4e6955c142f7044d).SET_SELECTED_NODE,
                    selectedNode: selectedNode,
                    nodePos: nodePos
                });
                return tr;
            });
            extension.onClick && extension.onClick();
        };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: extensionMenuItems.map((extension)=>{
            const Icon = extension.icon;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dVKvM.ToolbarDropdownItem), {
                elemBefore: Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                    size: "small",
                    label: ""
                }) : undefined,
                onClick: onClickHandle(extension),
                isDisabled: extension.isDisabled,
                children: [
                    extension.label,
                    extension.lozenge && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        as: "span",
                        paddingInline: "space.100",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                            appearance: 'new',
                            children: extension.lozenge.label
                        })
                    })
                ]
            }, extension.label);
        })
    });
};





parcelRequire("cozmU");









parcelRequire("cozmU");




const $5b4a6ca146c45f8d$var$SelectionExtensionComponentContext = (0, $cozmU.createContext)(undefined);
const $5b4a6ca146c45f8d$export$42992062fe8cb85b = $5b4a6ca146c45f8d$var$SelectionExtensionComponentContext.Provider;
const $5b4a6ca146c45f8d$export$770396a0bbb06d8d = ()=>{
    const context = (0, $cozmU.useContext)($5b4a6ca146c45f8d$var$SelectionExtensionComponentContext);
    if (!context) throw new Error('useSelectionExtensionComponentContext must be used within SelectionExtensionComponentContextProvider');
    return context;
};


const $c0ded49fa48eb8ed$export$6471b867609a4e38 = ({ api: api, editorView: editorView })=>{
    const menuTriggerByNode = api?.blockControls?.sharedState.currentState()?.menuTriggerByNode;
    const pos = menuTriggerByNode?.rootPos ?? menuTriggerByNode?.pos;
    if (!editorView || pos === undefined) return undefined;
    const extensionKey = editorView.state.doc.nodeAt(pos)?.attrs.extensionKey;
    return typeof extensionKey === 'string' ? extensionKey : undefined;
};


const $01725f2816e568a7$export$f65445bd85d2d8d3 = (item)=>{
    return 'getMenuItems' in item && typeof item.getMenuItems === 'function';
};


/* SelectionExtensionDropdownItem.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");








var $8i6M6 = parcelRequire("8i6M6");




var $lslMH = parcelRequire("lslMH");














const $41cb2516ccec76b8$var$styles = {
    svgOverflow: "_4xp0cqYvD1 _2QhaXDYvD1",
    contentWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _4ouGXIdnbC",
    label: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC"
};
const $41cb2516ccec76b8$export$b9803fa633175cb1 = ({ dropdownItem: dropdownItem })=>{
    const IconComponent = dropdownItem.icon;
    const { api: api, editorView: editorView, extensionKey: extensionKey, extensionSource: extensionSource, extensionLocation: extensionLocation } = (0, $5b4a6ca146c45f8d$export$770396a0bbb06d8d)();
    const handleClick = ()=>{
        const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
        const selection = preservedSelection || editorView.state.selection;
        if (dropdownItem.contentComponent) {
            const selectionInfo = (0, $4f34341d167d1204$export$d2b80e0fb1a7bb6)(selection, editorView, api);
            api.core.actions.execute(api.selectionExtension.commands.setActiveExtension({
                extension: dropdownItem,
                selection: selectionInfo
            }));
        }
        api.core.actions.execute(({ tr: tr })=>{
            const { selectedNode: selectedNode, nodePos: nodePos } = (0, $4f34341d167d1204$export$a93a74bd28a4df9a)(selection);
            tr.setMeta((0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0), {
                type: (0, $a0cf507b715ddff8$export$4e6955c142f7044d).SET_SELECTED_NODE,
                selectedNode: selectedNode,
                nodePos: nodePos
            });
            if (extensionLocation === 'block-menu') api?.blockControls?.commands.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            return tr;
        });
        dropdownItem.onClick?.();
        api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionKey: extensionKey,
                extensionSource: extensionSource,
                extensionLocation: extensionLocation,
                extensionElement: 'dropdown-item',
                extensionItemKey: dropdownItem.key
            }
        });
    };
    const labelRef = (0, $cozmU.useRef)(null);
    const [isTruncated, setIsTruncated] = (0, $cozmU.useState)(false);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        const el = labelRef.current;
        if (el) setIsTruncated(el.scrollWidth > el.clientWidth);
    }, []);
    const iconSize = extensionLocation === 'inline-toolbar' || extensionLocation === 'block-menu' ? 'small' : undefined;
    const iconElement = IconComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(IconComponent, {
        size: iconSize,
        label: ""
    }) : undefined;
    const lozengeLabel = dropdownItem.lozenge?.label;
    const elemAfterText = lozengeLabel ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
        appearance: (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
        children: lozengeLabel
    }) : undefined;
    const elemBeforeIcon = iconElement && extensionLocation === 'block-menu' ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            $41cb2516ccec76b8$var$styles.svgOverflow
        ]),
        children: iconElement
    }) : iconElement;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: isTruncated ? dropdownItem.label : null,
        position: "top",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
            elemBefore: elemBeforeIcon,
            elemAfterText: elemAfterText,
            onClick: handleClick,
            isDisabled: dropdownItem.isDisabled,
            testId: (0, $8i6M6.EXTENSION_MENU_ITEM_TEST_ID),
            "data-extension-item-key": dropdownItem.key,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $41cb2516ccec76b8$var$styles.contentWrapper,
                onMouseOver: handleMouseEnter,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    xcss: $41cb2516ccec76b8$var$styles.label,
                    ref: labelRef,
                    children: dropdownItem.label
                })
            })
        })
    });
};


/* SelectionExtensionNestedDropdownMenu.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("cozmU");








var $jgJIe = parcelRequire("jgJIe");

var $gk3KR = parcelRequire("gk3KR");


var $aDSIl = parcelRequire("aDSIl");












const $5f112e48a45b635f$var$BLOCK_MENU_TEMPLATES_SPOTLIGHT_PORTAL_SELECTOR = '[data-test-id="block-menu-templates-spotlight-portal-container"]';
const $5f112e48a45b635f$var$shouldIgnoreBlockMenuTemplatesSpotlightCloseEvent = (event)=>event.target instanceof Element && event.target.closest($5f112e48a45b635f$var$BLOCK_MENU_TEMPLATES_SPOTLIGHT_PORTAL_SELECTOR) !== null;
const $5f112e48a45b635f$var$styles = {
    lozenge: "_2XsHFMgVvo"
};
const $5f112e48a45b635f$var$ChildItems = ({ nestedDropdownMenu: nestedDropdownMenu })=>{
    const childItems = nestedDropdownMenu.getMenuItems();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        children: childItems.map((dropdownItem)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $41cb2516ccec76b8$export$b9803fa633175cb1), {
                dropdownItem: dropdownItem
            }, dropdownItem.key || dropdownItem.label))
    });
};
const $5f112e48a45b635f$export$6edafa8671941c08 = ({ nestedDropdownMenu: nestedDropdownMenu })=>{
    const IconComponent = nestedDropdownMenu.icon;
    const { api: api, extensionKey: extensionKey, extensionSource: extensionSource, extensionLocation: extensionLocation } = (0, $5b4a6ca146c45f8d$export$770396a0bbb06d8d)();
    const handleClick = ()=>{
        api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionKey: extensionKey,
                extensionSource: extensionSource,
                extensionLocation: extensionLocation,
                extensionElement: 'nested-dropdown',
                extensionItemKey: nestedDropdownMenu.key
            }
        });
    };
    const lozengeLabel = nestedDropdownMenu.lozenge?.label;
    const elemAfterText = lozengeLabel ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: $5f112e48a45b635f$var$styles.lozenge,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
            appearance: (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
            children: lozengeLabel
        })
    }) : undefined;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gk3KR.ToolbarNestedDropdownMenu), {
        testId: (0, $8i6M6.EXTENSION_MENU_ITEM_TEST_ID),
        text: nestedDropdownMenu.label,
        elemAfterText: elemAfterText,
        elemBefore: IconComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(IconComponent, {
            label: "",
            size: "small"
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        }),
        onClick: handleClick,
        dropdownTestId: "editor-selection-extension-menu",
        shouldTitleWrap: false,
        tooltipContent: nestedDropdownMenu.label,
        "data-extension-item-key": nestedDropdownMenu.key,
        shouldIgnoreCloseEvent: (0, $iDrrr.fg)('cc_blocks_changeboarding') ? $5f112e48a45b635f$var$shouldIgnoreBlockMenuTemplatesSpotlightCloseEvent : undefined,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($5f112e48a45b635f$var$ChildItems, {
            nestedDropdownMenu: nestedDropdownMenu
        })
    });
};


const $a3fe206cb970c3c3$export$6456f966307ab8fd = ({ getMenuItems: getMenuItems })=>{
    const { api: api, editorView: editorView, extensionKey: extensionKey, extensionLocation: extensionLocation, extensionSource: extensionSource } = (0, $5b4a6ca146c45f8d$export$770396a0bbb06d8d)();
    const extensionMenuItems = getMenuItems({
        blockMenuTriggerExtensionKey: (0, $c0ded49fa48eb8ed$export$6471b867609a4e38)({
            api: api,
            editorView: editorView
        }),
        extensionKey: extensionKey,
        extensionLocation: extensionLocation,
        extensionSource: extensionSource
    });
    if (!extensionMenuItems?.length) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: extensionMenuItems.map((item)=>{
            if ((0, $01725f2816e568a7$export$f65445bd85d2d8d3)(item)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5f112e48a45b635f$export$6edafa8671941c08), {
                nestedDropdownMenu: item
            }, item.key || item.label);
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $41cb2516ccec76b8$export$b9803fa633175cb1), {
                dropdownItem: item
            }, item.key || item.label);
        })
    });
};






parcelRequire("cozmU");





var $6t3CY = parcelRequire("6t3CY");



const $297d2702d3cef6b0$var$usePluginState = (_api)=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorToolbarDockingPreference: editorToolbarDockingPreference
    };
};
const $297d2702d3cef6b0$export$e5c1a33878e86e9e = ({ api: api, config: config })=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = $297d2702d3cef6b0$var$usePluginState(api);
    const isDockedAtTop = editorToolbarDockingPreference === 'top';
    if (isDockedAtTop) return null;
    const Icon = config.icon;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: config.tooltip,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                label: ""
            }),
            isDisabled: config.isDisabled,
            onClick: config.onClick,
            children: config.label
        })
    });
};





parcelRequire("cozmU");





var $a6nzD = parcelRequire("a6nzD");



const $bd436815b92be76f$var$usePluginState = (_api)=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorToolbarDockingPreference: editorToolbarDockingPreference
    };
};
const $bd436815b92be76f$export$1f4688db2a0d3d39 = ({ api: api, config: config, children: children })=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = $bd436815b92be76f$var$usePluginState(api);
    const isDockedAtTop = editorToolbarDockingPreference === 'top';
    if (isDockedAtTop) return null;
    const Icon = config.icon;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: ""
        }),
        isDisabled: config.isDisabled,
        onClick: config.onClick,
        tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: config.tooltip
        }),
        children: children
    });
};


const $58f62ed0dbc3ef7e$var$EXTENSION_RANK_MULTIPLIER = 100;
const $58f62ed0dbc3ef7e$var$InlineToolbarMenuItemComponent = ({ api: api, extension: extension, getMenuItems: getMenuItems })=>{
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    if (!editorView || !api) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5b4a6ca146c45f8d$export$42992062fe8cb85b), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        value: {
            api: api,
            editorView: editorView,
            extensionKey: extension.key,
            extensionSource: extension.source,
            extensionLocation: 'inline-toolbar'
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a3fe206cb970c3c3$export$6456f966307ab8fd), {
            getMenuItems: getMenuItems
        })
    });
};
const $58f62ed0dbc3ef7e$export$534fbf86ee38096a = ({ api: api, extension: extension, index: index })=>{
    const { key: key, inlineToolbar: inlineToolbar } = extension;
    const baseKey = `selection-extension-${key}`;
    const components = [];
    if (!inlineToolbar) return components;
    const { getToolbarItem: getToolbarItem, getMenuItems: getMenuItems } = inlineToolbar;
    const groupKey = `${baseKey}-toolbar-group`;
    const toolbarItemKey = `${baseKey}-toolbar-${getMenuItems ? 'menu' : 'button'}`;
    const menuSectionKey = `${baseKey}-toolbar-menu-section`;
    if (getToolbarItem) {
        // first we register the group for the button or menu to be added to
        components.push({
            type: 'group',
            key: groupKey,
            parents: [
                {
                    type: (0, $3nacY.APPS_SECTION).type,
                    key: (0, $3nacY.APPS_SECTION).key,
                    rank: (index + 1) * $58f62ed0dbc3ef7e$var$EXTENSION_RANK_MULTIPLIER
                }
            ]
        });
        const toolbarItemConfig = getToolbarItem();
        // if toolbar item has menu items, assume it's a menu
        if (getMenuItems) components.push({
            type: 'menu',
            key: toolbarItemKey,
            parents: [
                {
                    type: 'group',
                    key: groupKey,
                    rank: $58f62ed0dbc3ef7e$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bd436815b92be76f$export$1f4688db2a0d3d39), {
                    api: api,
                    config: toolbarItemConfig
                });
            }
        });
        else // else just regsiter a button
        components.push({
            type: 'button',
            key: toolbarItemKey,
            parents: [
                {
                    type: 'group',
                    key: groupKey,
                    rank: $58f62ed0dbc3ef7e$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $297d2702d3cef6b0$export$e5c1a33878e86e9e), {
                    api: api,
                    config: toolbarItemConfig
                });
            }
        });
    }
    if (getMenuItems) {
        if (getToolbarItem) components.push({
            type: 'menu-section',
            key: menuSectionKey,
            parents: [
                {
                    type: 'menu',
                    key: toolbarItemKey,
                    rank: $58f62ed0dbc3ef7e$var$EXTENSION_RANK_MULTIPLIER
                }
            ]
        });
        components.push({
            type: 'menu-item',
            key: key,
            parents: [
                {
                    type: 'menu-section',
                    // if we have a custom menu, place items in there, otherwise in the overflow menu
                    key: getToolbarItem ? menuSectionKey : (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                    rank: (index + 1) * $58f62ed0dbc3ef7e$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)($58f62ed0dbc3ef7e$var$InlineToolbarMenuItemComponent, {
                    api: api,
                    extension: extension,
                    getMenuItems: getMenuItems
                });
            }
        });
    }
    return components;
};


const $a3a3a333966acc7b$export$caa90b96cfb992a8 = (extension, api)=>{
    if (!extension.icon) return undefined;
    // Warning! These are inlined because the onClick handler must have up to date references to selection (which is awkwaradly set during extension.onClick invocation).
    const getSelection = ()=>{
        const sharedState = api?.selectionExtension.sharedState.currentState();
        return sharedState?.activeExtension?.selection;
    };
    return {
        label: extension.name,
        icon: extension.icon,
        isDisabled: extension.isDisabled && extension.isDisabled({
            selection: getSelection(),
            // pass undefined as no consumers use this
            selectedNodeAdf: undefined,
            selectionRanges: undefined
        }),
        /**
		 * SelectionExtension supports passing through selection, selectionAdf, and selectionRanges.
		 *
		 * To support backwards compatibility wrap the onClick with these parameters here and let MenuItem invoke onClick using its expected signature.
		 */ onClick: ()=>{
            const selectionAdf = api?.selectionExtension.actions.getSelectionAdf();
            extension.onClick && extension.onClick({
                selection: getSelection(),
                selectedNodeAdf: selectionAdf?.selectedNodeAdf,
                selectionRanges: selectionAdf?.selectionRanges
            });
        },
        contentComponent: extension.component
    };
};


const $2d2da74fcff33a29$export$a758406ca53b86a5 = ({ api: api, config: config })=>{
    const extensionToolbarComponents = config?.extensionList?.flatMap((extension, index)=>(0, $58f62ed0dbc3ef7e$export$534fbf86ee38096a)({
            api: api,
            extension: extension,
            index: index
        })) || [];
    /**
   * Continue to support firstParty apps for now as some apps haven't migrated yet, this simply converts apps to new ExtensionMenuItemConfiguration type
   * to process easier. extensionList and extensions?.firstParty will most likely be mutually exclusive.
   *
   * **Warning:** This is called on every selection change to ensure calls to api?.selectionExtension.actions.getSelectionAdf() are
   * fresh and up to date.
   */ const firstPartyExtensions = config?.extensions?.firstParty?.map((extension)=>(0, $a3a3a333966acc7b$export$caa90b96cfb992a8)(extension, api)).filter((extension)=>extension !== undefined) || [];
    const externalExtensions = config?.extensions?.external?.map((extension)=>(0, $a3a3a333966acc7b$export$caa90b96cfb992a8)(extension, api)).filter((extension)=>extension !== undefined) || [];
    return [
        {
            type: (0, $3nacY.APPS_SECTION).type,
            key: (0, $3nacY.APPS_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.APPS_SECTION).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.APPS_SECTION).key]
                }
            ]
        },
        ...extensionToolbarComponents,
        ...$2d2da74fcff33a29$var$registerFirstPartyExtensions(api, firstPartyExtensions),
        ...$2d2da74fcff33a29$var$registerExternalExtensions(api, externalExtensions)
    ];
};
const $2d2da74fcff33a29$var$registerFirstPartyExtensions = (api, extensions)=>{
    const components = [];
    if (extensions.length === 0 && (0, $ieeJu.expValEquals)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', true)) return components;
    components.push({
        type: (0, $3nacY.FIRST_PARTY_EXTENSIONS_MENU_ITEM).type,
        key: (0, $3nacY.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key,
        parents: [
            {
                type: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                key: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                rank: (0, $hVLmg.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $3nacY.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key]
            }
        ],
        component: ()=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a7e7f5c957f16d99$export$2ce376c2cc3355c8), {
                api: api,
                extensionMenuItems: extensions
            });
        }
    });
    return components;
};
const $2d2da74fcff33a29$var$registerExternalExtensions = (api, extensions)=>{
    const components = [];
    if (extensions.length === 0 && (0, $ieeJu.expValEquals)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', true)) return components;
    components.push({
        type: (0, $3nacY.EXTERNAL_EXTENSIONS_MENU_ITEM).type,
        key: (0, $3nacY.EXTERNAL_EXTENSIONS_MENU_ITEM).key,
        parents: [
            {
                type: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                key: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                rank: (0, $hVLmg.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $3nacY.EXTERNAL_EXTENSIONS_MENU_ITEM).key]
            }
        ],
        component: ()=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a7e7f5c957f16d99$export$2ce376c2cc3355c8), {
                api: api,
                extensionMenuItems: extensions
            });
        }
    });
    return components;
};





parcelRequire("cozmU");


var $cCXFd = parcelRequire("cCXFd");









function $44de9a48f730a692$export$8685820fcb2ea901({ extensionList: extensionList, api: api, editorViewRef: editorViewRef }) {
    const componentsToRegister = [];
    const registeredFeaturedSectionKeys = new Set();
    extensionList.forEach(({ source: source, key: key, blockMenu: blockMenu })=>{
        if (source !== 'first-party' || !blockMenu) return;
        if (!api?.blockMenu) return;
        const getMenuItemsContext = ()=>({
                blockMenuTriggerExtensionKey: (0, $c0ded49fa48eb8ed$export$6471b867609a4e38)({
                    api: api,
                    editorView: editorViewRef?.current
                }),
                extensionKey: key,
                extensionSource: source,
                extensionLocation: 'block-menu'
            });
        const getMenuItems = ()=>blockMenu.getMenuItems(getMenuItemsContext());
        /**
     * Renders the registered selection-extension menu items with the correct block-menu context.
     */ const makeItemComponent = ()=>{
            const editorView = editorViewRef?.current;
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5b4a6ca146c45f8d$export$42992062fe8cb85b), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                value: {
                    api: api,
                    editorView: editorView,
                    extensionKey: key,
                    extensionSource: source,
                    extensionLocation: 'block-menu'
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a3fe206cb970c3c3$export$6456f966307ab8fd), {
                    getMenuItems: blockMenu.getMenuItems
                })
            });
        };
        if (blockMenu.placement === 'featured-section') {
            // Block menu sections do not support isHidden. Check menu items before registering
            // the section to avoid rendering an orphan separator when there are no items.
            if (getMenuItems().length === 0 || !blockMenu.sectionKey) return;
            const sectionRank = (0, $cCXFd.MAIN_BLOCK_MENU_SECTION_RANK)[blockMenu.sectionKey];
            if (sectionRank === undefined) return;
            // Register as its own top-level section with a separator
            if (!registeredFeaturedSectionKeys.has(blockMenu.sectionKey)) {
                componentsToRegister.push({
                    type: 'block-menu-section',
                    key: blockMenu.sectionKey,
                    rank: sectionRank,
                    component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
                            hasSeparator: true,
                            children: children
                        })
                });
                registeredFeaturedSectionKeys.add(blockMenu.sectionKey);
            }
            componentsToRegister.push({
                type: 'block-menu-item',
                key: `selection-extension-${key}`,
                parent: {
                    type: 'block-menu-section',
                    key: blockMenu.sectionKey,
                    rank: (0, $cCXFd.BLOCK_ACTIONS_FEATURED_EXTENSION_ITEM_RANK)[(0, $8i6M6.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]
                },
                component: makeItemComponent
            });
        } else if (blockMenu.placement === 'featured') // Register as an item directly under TRANSFORM_MENU_SECTION
        componentsToRegister.push({
            type: 'block-menu-item',
            key: `selection-extension-${key}`,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_MENU_SECTION_RANK)[(0, $8i6M6.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]
            },
            component: makeItemComponent
        });
        else if (blockMenu.placement === 'structure') // Register under the Structure section in the nested Turn into menu
        componentsToRegister.push({
            type: 'block-menu-item',
            key: `selection-extension-${key}`,
            isHidden: ()=>getMenuItems().length === 0,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_EXTENSION_SLOT_MENU_ITEM).key]
            },
            component: makeItemComponent
        });
        else // Default: register under TRANSFORM_CREATE_MENU_SECTION
        componentsToRegister.push({
            type: 'block-menu-item',
            key: `selection-extension-${key}`,
            isHidden: ()=>getMenuItems().length === 0,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_CREATE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_CREATE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM).key]
            },
            component: makeItemComponent
        });
    });
    if (componentsToRegister.length > 0) api?.blockMenu?.actions.registerBlockMenuComponents(componentsToRegister);
}


const $1504c0a6936171f1$export$e35323fb8da5ccd6 = ({ api: api, config: config })=>{
    const editorViewRef = {};
    let cachedSelection;
    let cachedOverflowMenuOptions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { extensionList: extensionList = [], extensions: extensions = {} } = config || {};
    const { firstParty: firstParty = [], external: external = [] } = extensions || {};
    if (!isToolbarAIFCEnabled) {
        const primaryToolbarItemExtensions = (0, $4669e6ae9628b150$export$7cddd6f4296c4a51)(extensionList, 'primaryToolbar');
        if (primaryToolbarItemExtensions?.length) api?.primaryToolbar?.actions?.registerComponent({
            name: 'selectionExtension',
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $36ce839b55d5fa27$export$9b00cbcfa1039aae), {
                    primaryToolbarItemExtensions: primaryToolbarItemExtensions
                })
        });
    }
    if ((0, $jkcNT.editorExperiment)('platform_editor_block_menu', true, {
        exposure: true
    })) (0, $44de9a48f730a692$export$8685820fcb2ea901)({
        extensionList: extensionList,
        api: api,
        editorViewRef: editorViewRef
    });
    return {
        name: 'selectionExtension',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0).getState(editorState) || null;
        },
        commands: {
            setActiveExtension: (extension)=>({ tr: tr })=>{
                    return tr.setMeta((0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0), {
                        type: 'set-active-extension',
                        extension: extension
                    });
                },
            clearActiveExtension: ()=>({ tr: tr })=>{
                    return tr.setMeta((0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0), {
                        type: 'clear-active-extension'
                    });
                }
        },
        actions: {
            replaceWithAdf: (nodeAdf)=>{
                if (!editorViewRef.current) return {
                    status: 'failed-to-replace'
                };
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                return (0, $a2eadafa3d76af1c$export$c330a53bc779bb94)(nodeAdf, api)(state, dispatch);
            },
            insertAdfAtEndOfDoc: (nodeAdf)=>{
                if (!editorViewRef.current) return {
                    status: 'failed'
                };
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                return (0, $f6fb298cd14cf64f$export$60dfa91bf509272e)(nodeAdf)(state, dispatch);
            },
            getSelectionAdf: ()=>{
                if (!editorViewRef.current) return null;
                const { state: state } = editorViewRef.current;
                if ((0, $jkcNT.editorExperiment)('platform_editor_block_menu', true, {
                    exposure: true
                })) {
                    const selection = api?.blockControls?.sharedState.currentState()?.preservedSelection || state.selection;
                    return (0, $4f34341d167d1204$export$a93a74bd28a4df9a)(selection);
                }
                const { selectionRanges: selectionRanges, selectedNodeAdf: selectedNodeAdf } = (0, $4f34341d167d1204$export$c794b208e2d52a35)(state);
                return {
                    selectedNodeAdf: selectedNodeAdf,
                    selectionRanges: selectionRanges
                };
            },
            getDocumentFromSelection: ()=>{
                if (!editorViewRef.current) return null;
                const { state: state } = editorViewRef.current;
                if ((0, $jkcNT.editorExperiment)('platform_editor_block_menu', true, {
                    exposure: true
                })) {
                    const selection = api?.blockControls?.sharedState.currentState()?.preservedSelection || state.selection;
                    return (0, $4f34341d167d1204$export$a2bc00eaece873ac)(selection);
                }
                const { selectedNodeAdf: selectedNodeAdf } = (0, $4f34341d167d1204$export$e842a552462e723a)(state);
                return {
                    selectedNodeAdf: selectedNodeAdf
                };
            }
        },
        usePluginHook: ()=>{
            (0, $1KOhB.usePluginStateEffect)(api, [
                'selection'
            ], ()=>{
                if ((0, $4iudd.isSSR)()) return;
                if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $2d2da74fcff33a29$export$a758406ca53b86a5)({
                    api: api,
                    config: config
                }), true);
            });
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a7603d5babff7b72$export$26a4fbd96883483b), {
                editorView: editorView,
                api: api,
                editorAnalyticsAPI: api?.analytics?.actions
            });
        },
        pluginsOptions: {
            selectionToolbar: isToolbarAIFCEnabled ? undefined : (state, intl)=>{
                if (!config) return;
                const { pageModes: pageModes } = config;
                // Extensions Config Validation
                // Check whether plugin contains any selection extensions
                if (!firstParty?.length && !external?.length && !extensionList?.length) return;
                // Content Mode Validation
                // Check if pageModes is provided and matches against current content mode
                // This will eventually transition from mode to viewMode
                const editorViewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
                if (pageModes) {
                    // Early Exit: consumer has set pageModes but editorViewMode is undefined
                    if (!editorViewMode) return;
                    // Simplify traversion of pageModes which can be string or array of strings
                    const showOnModesCollection = Array.isArray(pageModes) ? pageModes : [
                        pageModes
                    ];
                    // Early Exit: consumer has set pageModes but current editorViewMode is not in the collection
                    if (!showOnModesCollection.includes(editorViewMode)) return;
                }
                // Active Extension
                // Check if there is an active extension and hide the selection extension dropdown
                const selectionExtensionState = (0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0).getState(state);
                if (selectionExtensionState?.activeExtension) return;
                const handleOnExtensionClick = (view)=>(extension)=>{
                        const selection = (0, $4f34341d167d1204$export$6a4dcb7c65e25fd5)(view, api);
                        if (extension.component) api?.core.actions.execute(api?.selectionExtension.commands.setActiveExtension({
                            extension: extension,
                            selection: selection
                        }));
                        const { selectedNodeAdf: selectedNodeAdf, selectionRanges: selectionRanges, selectedNode: selectedNode, nodePos: nodePos } = (0, $4f34341d167d1204$export$c794b208e2d52a35)(view.state);
                        const onClickCallbackOptions = {
                            selectedNodeAdf: selectedNodeAdf,
                            selectionRanges: selectionRanges
                        };
                        extension.onClick?.(onClickCallbackOptions);
                        api?.core?.actions.execute(({ tr: tr })=>{
                            tr.setMeta((0, $58f46f17c0beb3e2$export$dcf960b4b6957ad0), {
                                type: (0, $a0cf507b715ddff8$export$4e6955c142f7044d).SET_SELECTED_NODE,
                                selectedNode: selectedNode,
                                nodePos: nodePos
                            });
                            return tr;
                        });
                    };
                const convertExtensionToDropdownMenuItem = (extension, rank)=>{
                    const disabled = extension?.isDisabled instanceof Function ? extension?.isDisabled?.({
                        selection: editorViewRef.current ? (0, $4f34341d167d1204$export$6a4dcb7c65e25fd5)(editorViewRef.current, api) : undefined
                    }) : extension?.isDisabled;
                    return {
                        title: extension.name,
                        icon: extension.icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(extension.icon, {
                            label: ''
                        }) : undefined,
                        disabled: disabled,
                        rank: rank,
                        onClick: ()=>{
                            editorViewRef.current && handleOnExtensionClick(editorViewRef.current)(extension);
                            return true;
                        }
                    };
                };
                const getFirstPartyExtensions = (extensions)=>{
                    return extensions.map((extension)=>{
                        return convertExtensionToDropdownMenuItem(extension, 30);
                    });
                };
                // Add a heading to the external extensions
                const getExternalExtensions = (extensions)=>{
                    let externalExtensions = [];
                    if (extensions?.length) {
                        externalExtensions = extensions.map((extension)=>{
                            return convertExtensionToDropdownMenuItem(extension);
                        });
                        const externalExtensionsHeading = {
                            type: 'overflow-dropdown-heading',
                            title: intl.formatMessage((0, $8bmf7.selectionExtensionMessages).externalExtensionsHeading)
                        };
                        externalExtensions.unshift(externalExtensionsHeading);
                    }
                    return externalExtensions;
                };
                // NEXT PR: Make sure we cache the whole generated selection toolbar
                // also debug this to make sure it's actually preventing unnecessary re-renders / work
                if (cachedOverflowMenuOptions && state.selection.eq(cachedSelection)) return (0, $450561cc69409a4c$export$6937b1e97e59d958)({
                    overflowOptions: cachedOverflowMenuOptions,
                    extensionList: extensionList
                });
                const allFirstParty = [
                    ...firstParty,
                    ...(0, $4669e6ae9628b150$export$1c1c89b40fcaaa6e)(extensionList, 'first-party')
                ];
                const allExternal = [
                    ...external,
                    ...(0, $4669e6ae9628b150$export$1c1c89b40fcaaa6e)(extensionList, 'external')
                ];
                const groupedExtensionsArray = [
                    ...getFirstPartyExtensions(allFirstParty),
                    ...getExternalExtensions(allExternal)
                ];
                cachedOverflowMenuOptions = groupedExtensionsArray;
                cachedSelection = state.selection;
                return (0, $450561cc69409a4c$export$6937b1e97e59d958)({
                    overflowOptions: cachedOverflowMenuOptions,
                    extensionList: extensionList
                });
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'selectionExtension',
                    plugin: ()=>(0, $58f46f17c0beb3e2$export$ae829ec7b2625219)()
                },
                {
                    name: 'selectionExtensionGetEditorViewReferencePlugin',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                return {
                                    destroy: ()=>{
                                        delete editorViewRef.current;
                                    }
                                };
                            }
                        });
                    }
                }
            ]
    };
};
module.exports["selectionExtensionPlugin"] = $1504c0a6936171f1$export$e35323fb8da5ccd6;

});

parcelRegister("3RHCI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $4Qu9h = parcelRequire("4Qu9h");


var $anBbz = parcelRequire("anBbz");


var $jkcNT = parcelRequire("jkcNT");


var $55fM8 = parcelRequire("55fM8");


var $8dxef = parcelRequire("8dxef");


var $kpCD8 = parcelRequire("kpCD8");


var $iLrhi = parcelRequire("iLrhi");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");




const $a1d80eb96e11fa17$var$decorationStyle = `
    background-color: ${"var(--ds-background-neutral, #0515240F)"};
  `;
const $a1d80eb96e11fa17$var$decorationHighlightStyle = `
    background-color: ${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"};
    border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"};
  `;
const $a1d80eb96e11fa17$export$b6f731a5ef32d5cd = (doc, selection, isHighlight)=>{
    const selectionDecorations = [];
    doc.nodesBetween(selection.from, selection.to, (currentNode, nodePos)=>{
        if (!currentNode.isText) return true;
        let decorationFrom = selection.from;
        let decorationTo = selection.to;
        if (nodePos > selection.from) decorationFrom = nodePos;
        if (nodePos + currentNode.nodeSize < selection.to) decorationTo = nodePos + currentNode.nodeSize;
        selectionDecorations.push((0, $8nvEM.Decoration).inline(decorationFrom, decorationTo, {
            style: isHighlight ? $a1d80eb96e11fa17$var$decorationHighlightStyle : $a1d80eb96e11fa17$var$decorationStyle,
            'data-testid': 'selection-marker-selection'
        }));
        return true;
    });
    return selectionDecorations;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2438f45ad846183c$var$MS_PREFIX_REGEX = /^ms/;
const $2438f45ad846183c$var$NON_WHITESPACE_REGEX = /\S/u;
const $2438f45ad846183c$var$selectionMarkerHighlightStyles = {
    content: "''",
    position: 'absolute',
    backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K')",
    top: "var(--ds-space-0, 0px)",
    bottom: "var(--ds-space-negative-025, -2px)",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'contain',
    aspectRatio: '3/20',
    left: '0px',
    marginLeft: "var(--ds-space-negative-025, -2px)",
    right: '0px',
    marginRight: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none'
};
const $2438f45ad846183c$var$selectionMarkerBlockCursorStyles = {
    content: "''",
    position: 'absolute',
    background: "var(--ds-text, #292A2E)",
    width: '1px',
    display: 'inline-block',
    top: "var(--ds-space-0, 0px)",
    bottom: "var(--ds-space-negative-025, -2px)",
    left: '1px',
    marginLeft: "var(--ds-space-negative-025, -2px)",
    right: '0px',
    marginRight: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none'
};
// Same as above but defined as an inline element to avoid breaking long words
const $2438f45ad846183c$var$selectionMarkerInlineCursorStyles = {
    content: "''",
    position: 'relative',
    pointerEvents: 'none',
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-text, #292A2E)"}`,
    marginLeft: '-1px',
    left: '0.5px'
};
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $2438f45ad846183c$var$hyphenate(property) {
    // Ignored via go/ees005
    /* eslint-disable require-unicode-regexp */ return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace($2438f45ad846183c$var$MS_PREFIX_REGEX, '-ms');
/* eslint-enable require-unicode-regexp */ }
const $2438f45ad846183c$var$Widget = ({ type: type, isHighlight: isHighlight, isInWord: isInWord })=>{
    const span = document.createElement('span');
    const selectionMarkerCursorStyles = isInWord ? $2438f45ad846183c$var$selectionMarkerInlineCursorStyles : $2438f45ad846183c$var$selectionMarkerBlockCursorStyles;
    const styles = isHighlight ? $2438f45ad846183c$var$selectionMarkerHighlightStyles : selectionMarkerCursorStyles;
    for (const [rule, value] of Object.entries(styles))span.style.setProperty($2438f45ad846183c$var$hyphenate(rule), value);
    span.setAttribute('contentEditable', 'false');
    span.dataset.testid = `selection-marker-${type}-cursor`;
    return span;
};
const $2438f45ad846183c$var$toDOM = (type, isHighlight, isInWord)=>{
    const element = document.createElement('span');
    element.contentEditable = 'false';
    element.setAttribute('style', `position: relative;`);
    element.appendChild($2438f45ad846183c$var$Widget({
        type: type,
        isHighlight: isHighlight,
        isInWord: isInWord
    }));
    return element;
};
const $2438f45ad846183c$var$containsText = (resolvedPos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
    return nodeBefore?.isInline || nodeAfter?.isInline;
};
const $2438f45ad846183c$export$6428b9f2a07e29a5 = (resolvedPos, type, selection, isHighlight)=>{
    // We don't want the cursor to show if it's not text selection
    // ie. if it's on media selection
    if (!(selection instanceof (0, $kCECX.TextSelection)) || $2438f45ad846183c$var$containsText(resolvedPos) === false || !selection.empty) return [];
    // We're inside a word if the parent, before, and after nodes are all text nodes
    // and the before/after nodes are appended/prepended with non-whitespace characters
    // Also if we're making a selection and not just a cursor, this isn't relevant
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter, parent: parent } = resolvedPos;
    // Check if the parent is a text node and the before/after nodes are also text nodes
    const areTextNodes = parent.isTextblock && nodeBefore?.isText && nodeAfter?.isText;
    const lastCharacterOfBeforeNode = nodeBefore?.textContent?.slice(-1);
    const firstCharacterOfAfterNode = nodeAfter?.textContent?.slice(0, 1);
    const areAdjacentCharactersNonWhitespace = $2438f45ad846183c$var$NON_WHITESPACE_REGEX.test(lastCharacterOfBeforeNode || '') && $2438f45ad846183c$var$NON_WHITESPACE_REGEX.test(firstCharacterOfAfterNode || '');
    const isInWord = Boolean(areTextNodes && areAdjacentCharactersNonWhitespace);
    return [
        (0, $8nvEM.Decoration).widget(resolvedPos.pos, $2438f45ad846183c$var$toDOM(type, isHighlight, isInWord), {
            side: -1,
            key: `${type}WidgetDecoration`,
            stopEvent: ()=>true,
            ignoreSelection: true
        })
    ];
};


const $54fac118d3f9c9aa$export$df61b30b684217c0 = new (0, $kCECX.PluginKey)('selectionMarker');
function $54fac118d3f9c9aa$var$getDecorations(tr, type) {
    const { selection: selection } = tr;
    switch(type){
        case 'none':
            return (0, $8nvEM.DecorationSet).empty;
        case 'highlight':
            return (0, $8nvEM.DecorationSet).create(tr.doc, [
                ...(0, $2438f45ad846183c$export$6428b9f2a07e29a5)(selection.$anchor, 'anchor', selection, true),
                ...(0, $a1d80eb96e11fa17$export$b6f731a5ef32d5cd)(tr.doc, selection, true),
                ...(0, $2438f45ad846183c$export$6428b9f2a07e29a5)(selection.$head, 'head', selection, true)
            ]);
        case 'blur':
            return (0, $8nvEM.DecorationSet).create(tr.doc, [
                ...(0, $2438f45ad846183c$export$6428b9f2a07e29a5)(selection.$anchor, 'anchor', selection, false),
                ...(0, $a1d80eb96e11fa17$export$b6f731a5ef32d5cd)(tr.doc, selection, false)
            ]);
    }
}
function $54fac118d3f9c9aa$var$getDecorationType(tr, shouldHideDecorations) {
    if (shouldHideDecorations || (0, $iLrhi.isEmptyDocument)(tr.doc)) return 'none';
    // TODO: ED-26961 - implement "highlight" for AI features
    return 'blur';
}
const $54fac118d3f9c9aa$export$7dca04eb0e423bd = (tr, currentState, oldEditorState)=>{
    const meta = tr.getMeta($54fac118d3f9c9aa$export$df61b30b684217c0);
    if (!meta && !tr.selectionSet) return currentState;
    const forceHide = meta?.forceHide ?? currentState.forceHide;
    const shouldHideDecorations = meta?.shouldHideDecorations ?? currentState.shouldHideDecorations;
    const type = $54fac118d3f9c9aa$var$getDecorationType(tr, shouldHideDecorations);
    let nextDecorations = currentState.decorations;
    const hasSelectionChangedToRange = oldEditorState.selection.empty && !tr.selection.empty;
    if (hasSelectionChangedToRange || currentState.decorationType !== type) nextDecorations = $54fac118d3f9c9aa$var$getDecorations(tr, type);
    else nextDecorations = nextDecorations.map(tr.mapping, tr.doc, {});
    return {
        decorations: nextDecorations,
        shouldHideDecorations: shouldHideDecorations,
        forceHide: forceHide,
        decorationType: type
    };
};
const $54fac118d3f9c9aa$var$debouncedDecorations = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((state)=>{
    return $54fac118d3f9c9aa$export$df61b30b684217c0.getState(state)?.decorations;
}, 25);
const $54fac118d3f9c9aa$export$ae829ec7b2625219 = (api)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $54fac118d3f9c9aa$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    decorations: (0, $8nvEM.DecorationSet).empty,
                    shouldHideDecorations: true,
                    forceHide: false,
                    decorationType: 'none'
                };
            },
            apply: $54fac118d3f9c9aa$export$7dca04eb0e423bd
        },
        props: {
            decorations: (state)=>{
                const browser = (0, $8dxef.getBrowserInfo)();
                if (browser.ie) return $54fac118d3f9c9aa$var$debouncedDecorations(state);
                else return $54fac118d3f9c9aa$export$df61b30b684217c0.getState(state)?.decorations;
            }
        }
    });
};
function $54fac118d3f9c9aa$export$aaa3a3e05ac72aed(editorView, shouldHideDecorations) {
    const { dispatch: dispatch, state: state } = editorView;
    dispatch(state.tr.setMeta($54fac118d3f9c9aa$export$df61b30b684217c0, {
        shouldHideDecorations: shouldHideDecorations
    }));
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $lOiVq = parcelRequire("lOiVq");




function $f6d737d792ef6ca5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Unset the selection background color as we are using our own
 * Otherwise we might have a mix of grey + our selection marker depending on the state.
 *
 * Edge cases:
 * - We do not apply this reset to input fields or code blocks (ie. expand case) because otherwise
 * selection highlight will not show on those.
 * - We do not apply this reset when the editor is disabled
 */ const $f6d737d792ef6ca5$var$globalStyles = {
    name: "1dgyfx",
    styles: ".ProseMirror:not(:focus):not([contenteditable=\"false\"]) ::selection:not(input, .cm-editor){background:unset;}"
};
const $f6d737d792ef6ca5$var$hideSelectionStyles = {
    name: "1ors4v5",
    styles: ".ProseMirror  *.danger::selection{background:transparent;}"
};
const $f6d737d792ef6ca5$export$cc5403d58ddfa812 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        styles: [
            $f6d737d792ef6ca5$var$globalStyles,
            (0, $jkcNT.editorExperiment)('platform_editor_block_menu', true) && $f6d737d792ef6ca5$var$hideSelectionStyles
        ]
    });
};


const $b17e29228559f75a$export$9015f1b1ef870734 = ({ config: config, api: api })=>{
    return {
        name: 'selectionMarker',
        pmPlugins () {
            return [
                {
                    name: 'selectionMarkerPmPlugin',
                    plugin: ()=>(0, $54fac118d3f9c9aa$export$ae829ec7b2625219)(api)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return {
                isForcedHidden: (0, $54fac118d3f9c9aa$export$df61b30b684217c0).getState(editorState)?.forceHide ?? false,
                isMarkerActive: !(0, $54fac118d3f9c9aa$export$df61b30b684217c0).getState(editorState)?.shouldHideDecorations
            };
        },
        actions: {
            // For now this is a very simple locking mechanism that only allows one
            // plugin to hide / release at a time.
            hideDecoration: ()=>{
                if (api?.selectionMarker?.sharedState.currentState()?.isForcedHidden) return undefined;
                const success = api?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $54fac118d3f9c9aa$export$df61b30b684217c0), {
                        forceHide: true
                    }));
                if (!success) return undefined;
                return $b17e29228559f75a$var$cleanupHiddenDecoration(api);
            },
            queueHideDecoration: (setCleanup)=>{
                const result = api?.selectionMarker.actions.hideDecoration();
                if (result === undefined) {
                    const cleanup = api?.selectionMarker?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                        if (nextSharedState?.isForcedHidden === false && nextSharedState?.isMarkerActive === false) {
                            const result = api?.selectionMarker.actions.hideDecoration();
                            setCleanup(result);
                            cleanup?.();
                        }
                    });
                    return cleanup;
                }
                setCleanup(result);
                return ()=>{};
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const editorHasNotBeenFocused = (0, $cozmU.useRef)(true);
            (0, $cozmU.useEffect)(()=>{
                // relatch when editorView changes (pretty good signal for reinit)
                editorHasNotBeenFocused.current = true;
            }, [
                editorView
            ]);
            const { hasFocus: hasFocus, isOpen: isOpen, editorDisabled: editorDisabled, showToolbar: showToolbar, hasDangerDecorations: hasDangerDecorations, currentUserIntent: currentUserIntent } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
                'focus',
                'typeAhead',
                'editorDisabled',
                'toolbar',
                'decorations',
                'userIntent'
            ], (states)=>{
                return {
                    hasFocus: states.focusState?.hasFocus,
                    isOpen: states.typeAheadState?.isOpen,
                    editorDisabled: states.editorDisabledState?.editorDisabled,
                    showToolbar: states.toolbarState?.shouldShowToolbar,
                    hasDangerDecorations: (0, $anBbz.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? states.decorationsState?.hasDangerDecorations : undefined,
                    currentUserIntent: states.userIntentState?.currentUserIntent
                };
            });
            const isForcedHidden = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'selectionMarker.isForcedHidden');
            (0, $cozmU.useEffect)(()=>{
                // On editor init we should use this latch to keep the marker hidden until
                // editor has received focus. This means editor will be initially hidden until
                // the first focus occurs, and after first focus the normal above rules will
                // apply
                if (hasFocus === true) editorHasNotBeenFocused.current = false;
                const isBlockMenuOpen = currentUserIntent === 'blockMenuOpen' && (0, $jkcNT.editorExperiment)('platform_editor_block_menu', true);
                /**
         * There are a number of conditions we should not show the marker,
         * - Editor has not been focused: to keep the marker hidden until first focus if config is set
         * - Focus: to ensure it doesn't interrupt the normal cursor
         * - Typeahead Open: To ensure it doesn't show when we're typing in the typeahead
         * - Disabled: So that it behaves similar to the renderer in live pages/disabled
         * - Via the API: If another plugin has requested it to be hidden (force hidden).
         * - If danger styles is shown in decorationsPlugin, then we don't need to show the selection marker
         */ const shouldHide = config?.hideCursorOnInit && editorHasNotBeenFocused.current || hasFocus || (isOpen ?? false) || isForcedHidden || (editorDisabled ?? false) || (showToolbar ?? false) || !!hasDangerDecorations && (0, $jkcNT.editorExperiment)('platform_editor_block_menu', true) || isBlockMenuOpen;
                requestAnimationFrame(()=>(0, $54fac118d3f9c9aa$export$aaa3a3e05ac72aed)(editorView, shouldHide));
            }, [
                editorView,
                hasFocus,
                isOpen,
                isForcedHidden,
                editorDisabled,
                showToolbar,
                hasDangerDecorations,
                currentUserIntent
            ]);
        },
        contentComponent () {
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6d737d792ef6ca5$export$cc5403d58ddfa812), {});
        }
    };
};
function $b17e29228559f75a$var$cleanupHiddenDecoration(api) {
    let hasRun = false;
    return ()=>{
        if (!hasRun && api?.selectionMarker?.sharedState.currentState()?.isForcedHidden) {
            hasRun = true;
            return api?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $54fac118d3f9c9aa$export$df61b30b684217c0), {
                    forceHide: false
                }));
        }
    };
}
module.exports["selectionMarkerPlugin"] = $b17e29228559f75a$export$9015f1b1ef870734;

});

parcelRegister("7Krw2", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $kpCD8 = parcelRequire("kpCD8");


var $4Qu9h = parcelRequire("4Qu9h");


var $jkcNT = parcelRequire("jkcNT");

var $dee0f30c0d087121$export$b5b949bd8a2acfff = /*#__PURE__*/ function(AIDefinitionsActionType) {
    AIDefinitionsActionType["UPDATE_STATE"] = "UPDATE_STATE";
    AIDefinitionsActionType["UPDATE_KEYWORD_REGEX"] = "UPDATE_KEYWORD_REGEX";
    AIDefinitionsActionType["UPDATE_KEYWORD_DECORATIONS_SESSION_ID"] = "UPDATE_KEYWORD_DECORATIONS_SESSION_ID";
    AIDefinitionsActionType["UPDATE_KEYWORD_DECORATIONS"] = "UPDATE_KEYWORD_DECORATIONS";
    AIDefinitionsActionType["OPEN_READING_AIDS_POPUP"] = "OPEN_READING_AIDS_POPUP";
    AIDefinitionsActionType["CLOSE_READING_AIDS_POPUP"] = "CLOSE_READING_AIDS_POPUP";
    AIDefinitionsActionType["READING_AIDS_POPUP_LOADED"] = "READING_AIDS_POPUP_LOADED";
    return AIDefinitionsActionType;
}({});


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $cI8RZ = parcelRequire("cI8RZ");


var $l5rX3 = parcelRequire("l5rX3");


var $gT4iv = parcelRequire("gT4iv");


var $73Kv0 = parcelRequire("73Kv0");


var $1A89X = parcelRequire("1A89X");


var $eOaGc = parcelRequire("eOaGc");

function $cd9f6a021284c9c6$var$stepHasMarkConsideredAsContentChange(step) {
    const { name: name } = step.mark.type;
    return name === 'annotation';
}
function $cd9f6a021284c9c6$export$fd25270dcbdeb96d(step) {
    return(// bold will trigger AddMarkStep and RemoveMarkStep
    step instanceof (0, $eOaGc.AddMarkStep) && !$cd9f6a021284c9c6$var$stepHasMarkConsideredAsContentChange(step) || step instanceof (0, $eOaGc.RemoveMarkStep) && !$cd9f6a021284c9c6$var$stepHasMarkConsideredAsContentChange(step) || // add mark to node
    step instanceof (0, $eOaGc.AddNodeMarkStep) && !$cd9f6a021284c9c6$var$stepHasMarkConsideredAsContentChange(step) || step instanceof (0, $eOaGc.RemoveNodeMarkStep) && !$cd9f6a021284c9c6$var$stepHasMarkConsideredAsContentChange(step) || // update node attribute
    step instanceof (0, $eOaGc.AttrStep) || // update doc attribute
    step instanceof (0, $eOaGc.DocAttrStep) || // tick action item will trigger SetAttrsStep
    step instanceof (0, $1A89X.SetAttrsStep) || // change link text will trigger LinkMetaStep
    step instanceof (0, $73Kv0.LinkMetaStep) || // type / typeahead will trigger InsertTypeAheadStep
    step instanceof (0, $gT4iv.InsertTypeAheadStep) || step instanceof (0, $l5rX3.AnalyticsStep));
}



var $kCECX = parcelRequire("kCECX");

const $b1c303b59bfe1f32$export$319f57d42a2c6302 = new (0, $kCECX.PluginKey)('aiDefinitions');


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead




const $3ae8f60865049fe9$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).UPDATE_STATE:
            return {
                ...state,
                // action is partial state, so we default to current state if not provided
                enabled: action.enabled ?? state.enabled,
                autoHighlightEnabled: action.autoHighlightEnabled ?? state.autoHighlightEnabled,
                enablementSource: action.enablementSource ?? state.enablementSource
            };
        case (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).UPDATE_KEYWORD_REGEX:
            return {
                ...state,
                keywordRegex: action.keywordRegex
            };
        case (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS_SESSION_ID:
            return {
                ...state,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                keywordDecorationsSessionId: (0, $03RpJ.default)()
            };
        case (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS:
            return {
                ...state,
                keywordDecorations: action.keywordDecorations
            };
        case (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).OPEN_READING_AIDS_POPUP:
            return {
                ...state,
                currentKeywordId: action.keywordId,
                isReadingAidsPopupOpen: true,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                readingAidsPopupKey: (0, $03RpJ.default)(),
                readingAidsPopupProps: action.readingAidsPopupProps,
                isReadingAidsPopupLoading: true
            };
        case (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).CLOSE_READING_AIDS_POPUP:
            return {
                ...state,
                currentKeywordId: undefined,
                isReadingAidsPopupOpen: false,
                readingAidsPopupKey: undefined,
                readingAidsPopupProps: undefined
            };
        case (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).READING_AIDS_POPUP_LOADED:
            return {
                ...state,
                isReadingAidsPopupLoading: false
            };
        default:
            return state;
    }
};
var $3ae8f60865049fe9$export$2e2bcd8739ae039 = $3ae8f60865049fe9$var$reducer;


function $8981c0bdcff3b32a$var$mapping(tr, pluginState) {
    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
    let { keywordDecorations: keywordDecorations } = pluginState;
    if (!enabled || !autoHighlightEnabled) return pluginState;
    keywordDecorations = keywordDecorations.map(tr.mapping, tr.doc);
    return {
        ...pluginState,
        keywordDecorations: keywordDecorations
    };
}
function $8981c0bdcff3b32a$var$onDocChanged(tr, pluginState) {
    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, keywordDecorationsSessionCounter: keywordDecorationsSessionCounter } = pluginState;
    if (!enabled || !autoHighlightEnabled) return pluginState;
    // regex has been reset, reset counter only
    if (!pluginState.keywordRegex) return {
        ...pluginState,
        keywordDecorationsSessionCounter: keywordDecorationsSessionCounter + 1
    };
    // changes like bold or text color will also trigger onDocChanged,
    // but changes like these don't include real content change
    // so if there is no content changed, don't reset state
    const noContentChanged = tr.steps.every((step)=>(0, $cd9f6a021284c9c6$export$fd25270dcbdeb96d)(step));
    if (noContentChanged) return pluginState;
    // doc content changed, reset regex, sessionId and counter
    return {
        ...pluginState,
        keywordRegex: undefined,
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        keywordDecorationsSessionId: (0, $03RpJ.default)(),
        keywordDecorationsSessionCounter: keywordDecorationsSessionCounter + 1
    };
}
const $8981c0bdcff3b32a$var$dest = (0, $cI8RZ.pluginFactory)((0, $b1c303b59bfe1f32$export$319f57d42a2c6302), (0, $3ae8f60865049fe9$export$2e2bcd8739ae039), {
    mapping: $8981c0bdcff3b32a$var$mapping,
    onDocChanged: $8981c0bdcff3b32a$var$onDocChanged
});
const $8981c0bdcff3b32a$export$8d4021544bdece00 = $8981c0bdcff3b32a$var$dest.createCommand;
const $8981c0bdcff3b32a$export$f05434c51e3762e = $8981c0bdcff3b32a$var$dest.getPluginState;
const $8981c0bdcff3b32a$export$656c7661095efe2e = $8981c0bdcff3b32a$var$dest.createPluginState;



function $642612dafa9301b2$export$4971331372cec95a({ editorViewRef: editorViewRef }) {
    return (state)=>({ tr: tr })=>{
            if (!editorViewRef.current) return null;
            const pluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorViewRef.current.state);
            const keys = [
                'enabled',
                'autoHighlightEnabled',
                'enablementSource'
            ];
            const stateUnchanged = keys.every((key)=>{
                return state[key] === undefined || state[key] === pluginState[key];
            });
            if (stateUnchanged) return null;
            const action = {
                type: (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).UPDATE_STATE,
                ...state
            };
            return tr.setMeta((0, $b1c303b59bfe1f32$export$319f57d42a2c6302), action);
        };
}


// oxlint-disable-next-line @atlassian/no-restricted-imports

var $55fM8 = parcelRequire("55fM8");





var $8nvEM = parcelRequire("8nvEM");


var $krYZG = parcelRequire("krYZG");


var $1w4hj = parcelRequire("1w4hj");

const $66d5ed65dbed0ef4$var$defineButtonClickedPayload = (readingAidsSessionId, wordCount)=>({
        action: (0, $krYZG.ACTION).CLICKED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_DEFINITIONS_DEFINE_BUTTON,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            readingAidsSessionId: readingAidsSessionId,
            wordCount: wordCount
        }
    });
const $66d5ed65dbed0ef4$var$autoHighlightClickedPayload = (readingAidsSessionId)=>({
        action: (0, $krYZG.ACTION).CLICKED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DECORATION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_DEFINITIONS_AUTO_HIGHLIGHT,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            readingAidsSessionId: readingAidsSessionId
        }
    });
const $66d5ed65dbed0ef4$export$100e4d52f8971e06 = ({ source: source, readingAidsSessionId: readingAidsSessionId, wordCount: wordCount })=>{
    return source === 'define-button-click' ? $66d5ed65dbed0ef4$var$defineButtonClickedPayload(readingAidsSessionId, wordCount) : $66d5ed65dbed0ef4$var$autoHighlightClickedPayload(readingAidsSessionId);
};
const $66d5ed65dbed0ef4$export$aa3898e402a73b22 = ({ error: error, errorInfo: errorInfo })=>{
    return {
        action: (0, $krYZG.ACTION).ERRORED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_DEFINITIONS,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error),
            componentStack: errorInfo?.componentStack || ''
        }
    };
};







// id for ReadingAidsPopup portal container
const $e5c338c49b3f8f39$export$5e663b7e0d8861d1 = 'editor-ai-definitions-reading-aids-popup-portal-container';
const $e5c338c49b3f8f39$export$6fa82fd5fa91c059 = 'ai-definitions-keyword-decoration';
const $e5c338c49b3f8f39$export$e6a305940f3628e3 = 'ai-definitions-keyword-styler';
const $e5c338c49b3f8f39$export$785bdb9ccf5c31c1 = 'ai-definitions-keyword-styler-hover';
const $e5c338c49b3f8f39$export$bb7bab4b8547d886 = 'ai-definitions-keyword-styler-loading';



const $81bd472d0ee59a6e$var$WHITESPACE_REGEX = /\s+/u;
const $81bd472d0ee59a6e$var$getSelectedText = (editorState)=>{
    const { from: from, to: to } = editorState.selection;
    const text = editorState.doc.textBetween(from, to, '\n');
    return text.trim();
};
const $81bd472d0ee59a6e$export$4615c92e40b4fcd9 = (editorState)=>{
    if (editorState.selection.empty) return false;
    const text = $81bd472d0ee59a6e$var$getSelectedText(editorState);
    return text.length > 0;
};
const $81bd472d0ee59a6e$var$selectionWordCount = (editorState)=>{
    const text = $81bd472d0ee59a6e$var$getSelectedText(editorState);
    return text.split($81bd472d0ee59a6e$var$WHITESPACE_REGEX).length;
};
const $81bd472d0ee59a6e$var$DEFAULT_MAX_WORD_COUNT = 1;
const $81bd472d0ee59a6e$export$8e4734431f48a29a = (editorState, config)=>{
    const wordCount = $81bd472d0ee59a6e$var$selectionWordCount(editorState);
    return wordCount > (config.readingAidsMaxWordCount ?? $81bd472d0ee59a6e$var$DEFAULT_MAX_WORD_COUNT);
};
function $81bd472d0ee59a6e$export$aa946c0ed562e2ed(range) {
    const portalContainer = document.getElementById((0, $e5c338c49b3f8f39$export$5e663b7e0d8861d1));
    if (!portalContainer) return null;
    const portalRect = portalContainer.getBoundingClientRect();
    const rect = range.getBoundingClientRect();
    const selectionRect = {
        top: rect.top - portalRect.top,
        left: rect.left - portalRect.left,
        width: rect.width,
        height: rect.height
    };
    return selectionRect;
}
const $81bd472d0ee59a6e$export$449a1ad28b94e2e3 = (editorView, from, to)=>{
    try {
        const fromDom = editorView.domAtPos(from);
        const toDom = editorView.domAtPos(to);
        if (!fromDom?.node || !toDom?.node) return {
            selectionRect: null
        };
        const range = document.createRange();
        range.setStart(fromDom.node, fromDom.offset);
        range.setEnd(toDom.node, toDom.offset);
        const selectionRect = $81bd472d0ee59a6e$export$aa946c0ed562e2ed(range);
        return {
            selectionRange: range,
            selectionRect: selectionRect
        };
    } catch  {
        return {
            selectionRect: null
        };
    }
};
const $81bd472d0ee59a6e$export$fba2e0e287e213ab = (state)=>{
    if (!state || !state.selection || state.selection.empty) return null;
    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) return null;
    const range = selection.getRangeAt(0);
    if (!range || range.collapsed) return null;
    const { from: from, to: to } = state.selection;
    const selectedText = state.doc.textBetween(from, to, '\n');
    const selectionRect = $81bd472d0ee59a6e$export$aa946c0ed562e2ed(range);
    return {
        selectionRange: range,
        selectionRect: selectionRect,
        selectedText: selectedText,
        // ReadingAidsPopup will apply a position shift to the popup.
        // - see file next/packages/contextual-reading-aids/src/ReadingAidsPopup.tsx
        isEditor: true
    };
};






const $731b45a6880c6d58$export$49efb2449afa2765 = (id)=>{
    const styler = document.querySelector(`.${(0, $e5c338c49b3f8f39$export$e6a305940f3628e3)}-${id}`);
    if (styler) styler.classList.add(`${(0, $e5c338c49b3f8f39$export$bb7bab4b8547d886)}`);
};
const $731b45a6880c6d58$export$9d5d65b673a5731e = ()=>{
    const stylerArr = document.querySelectorAll(`.${(0, $e5c338c49b3f8f39$export$bb7bab4b8547d886)}`);
    for (const styler of stylerArr)styler.classList.remove(`${(0, $e5c338c49b3f8f39$export$bb7bab4b8547d886)}`);
};
const $731b45a6880c6d58$export$61e1ef05609254a7 = (event)=>{
    const { target: target } = event;
    if ((0, $b774ed999997e9e9$export$ec65e27b8f279045)(target) && target.dataset.id) {
        const id = target.dataset.id;
        const styler = document.querySelector(`.${(0, $e5c338c49b3f8f39$export$e6a305940f3628e3)}-${id}`);
        if (styler) styler.classList.add(`${(0, $e5c338c49b3f8f39$export$785bdb9ccf5c31c1)}`);
    }
};
const $731b45a6880c6d58$export$67fd1109fb9d83c0 = (event)=>{
    const { target: target } = event;
    if ((0, $b774ed999997e9e9$export$ec65e27b8f279045)(target) && target.dataset.id) {
        const id = target.dataset.id;
        const styler = document.querySelector(`.${(0, $e5c338c49b3f8f39$export$e6a305940f3628e3)}-${id}`);
        if (styler) styler.classList.remove(`${(0, $e5c338c49b3f8f39$export$785bdb9ccf5c31c1)}`);
    }
};
const $731b45a6880c6d58$export$ec86b17ba41fd0b4 = (styler)=>{
    const id = styler.dataset.id;
    if (!id) return;
    // there might be multiple consecutive keyword inline decorations if there are other decorations on the keyword text
    const keywordDecorationArr = document.querySelectorAll(`.${(0, $e5c338c49b3f8f39$export$6fa82fd5fa91c059)}-${id}`);
    const keywordStart = keywordDecorationArr[0];
    const keywordEnd = keywordDecorationArr[keywordDecorationArr.length - 1];
    if (styler && styler instanceof HTMLSpanElement && (0, $b774ed999997e9e9$export$ec65e27b8f279045)(keywordStart) && (0, $b774ed999997e9e9$export$ec65e27b8f279045)(keywordEnd)) {
        const range = document.createRange();
        range.setStartBefore(keywordStart);
        range.setEndAfter(keywordEnd);
        const rect = range.getBoundingClientRect();
        styler.style.setProperty('--ai-definitions-keyword-styler-width', `${rect.width}px`);
        styler.style.setProperty('--ai-definitions-keyword-styler-height', `${rect.height}px`);
    }
};
function $731b45a6880c6d58$export$eb69c22734bde9b4() {
    const containers = document.querySelectorAll(`.${(0, $e5c338c49b3f8f39$export$e6a305940f3628e3)}`);
    for (const container of containers)if (container instanceof HTMLSpanElement) $731b45a6880c6d58$export$ec86b17ba41fd0b4(container);
}
function $731b45a6880c6d58$export$941ff97b157be2e9(dom) {
    const observer = new MutationObserver((records)=>{
        for (const record of records){
            for (const node of record.addedNodes)if (node instanceof HTMLSpanElement && node.classList.contains((0, $e5c338c49b3f8f39$export$e6a305940f3628e3))) $731b45a6880c6d58$export$ec86b17ba41fd0b4(node);
        }
    });
    observer.observe(dom, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer.disconnect();
    };
}
const $731b45a6880c6d58$export$fa50e52a0393d089 = ({ id: id })=>{
    // add an extra relative container to make the positioning easier
    const container = document.createElement('span');
    container.classList.add((0, $e5c338c49b3f8f39$export$e6a305940f3628e3), `${(0, $e5c338c49b3f8f39$export$e6a305940f3628e3)}-${id}`);
    container.dataset.id = id;
    return container;
};


function $b774ed999997e9e9$export$ec65e27b8f279045(node) {
    return Boolean(node && node instanceof HTMLSpanElement && node.classList.contains((0, $e5c338c49b3f8f39$export$6fa82fd5fa91c059)));
}
// props here is not a complete list, other common props are passed when rendering ReadingAidsPopup
// props are aligned with confluence/next/packages/contextual-reading-aids/src/ReadingAidsAcronymsHighlighter.tsx
// - some of which are from confluence/next/packages/contextual-reading-aids/src/RendererTextHighlighter.tsx
// props for AI define button are from confluence/next/packages/highlight-actions/src/HighlightActions.tsx
function $b774ed999997e9e9$var$getReadingAidsPopupPropsForKeyword({ keywordStart: keywordStart, keywordEnd: keywordEnd, editorView: editorView }) {
    const range = document.createRange();
    range.setStartBefore(keywordStart);
    range.setEndAfter(keywordEnd);
    const selectionRect = (0, $81bd472d0ee59a6e$export$aa946c0ed562e2ed)(range);
    const selectedContext = keywordStart.parentElement;
    const additionalContext = selectedContext ? selectedContext.textContent || selectedContext.innerText : '';
    return {
        selectedText: range.toString(),
        additionalContext: additionalContext,
        selectionRange: range,
        selectionRect: selectionRect,
        onResult: ()=>{},
        onLoad: ()=>{
            (0, $731b45a6880c6d58$export$9d5d65b673a5731e)();
            (0, $bcf33f2d1863510f$export$4879e261232d25a5)()(editorView.state, editorView.dispatch);
        },
        onClose: ()=>{
            (0, $bcf33f2d1863510f$export$1a54981d304e6ea8)({
                editorView: editorView
            });
        },
        isAutohighlighted: true,
        isEditor: true
    };
}
function $b774ed999997e9e9$var$handleOpenReadingAidsPopup({ event: event, editorView: editorView, api: api, id: id }) {
    // there might be multiple consecutive keyword inline decorations if there are other decorations on the keyword text
    const keywordDecorationArr = document.querySelectorAll(`.${(0, $e5c338c49b3f8f39$export$6fa82fd5fa91c059)}-${id}`);
    const keywordStart = keywordDecorationArr[0];
    const keywordEnd = keywordDecorationArr[keywordDecorationArr.length - 1];
    if ($b774ed999997e9e9$export$ec65e27b8f279045(keywordStart) && $b774ed999997e9e9$export$ec65e27b8f279045(keywordEnd)) {
        const readingAidsPopupProps = $b774ed999997e9e9$var$getReadingAidsPopupPropsForKeyword({
            keywordStart: keywordStart,
            keywordEnd: keywordEnd,
            editorView: editorView
        });
        (0, $731b45a6880c6d58$export$49efb2449afa2765)(id);
        (0, $bcf33f2d1863510f$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'auto-highlight-click',
            keywordId: id,
            readingAidsPopupProps: readingAidsPopupProps
        })(editorView.state, editorView.dispatch);
        event.preventDefault();
        event.stopPropagation();
        return true;
    }
    return false;
}
const $b774ed999997e9e9$export$78fb7b30edc4d46 = ({ event: event, editorView: editorView, api: api })=>{
    const { target: target } = event;
    const aiDefinitionsPluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorView.state);
    const { isReadingAidsPopupOpen: isReadingAidsPopupOpen, currentKeywordId: currentKeywordId, isReadingAidsPopupLoading: isReadingAidsPopupLoading } = aiDefinitionsPluginState;
    // click keyword
    if ($b774ed999997e9e9$export$ec65e27b8f279045(target) && target.dataset.id) {
        const id = target.dataset.id;
        // click the same keyword while loading, do nothing
        if (id === currentKeywordId && isReadingAidsPopupLoading) {
            // prevent the click event from propagating to the popup to close it
            event.stopPropagation();
            event.preventDefault();
            return true;
        }
        // only open popup if there's no popup open
        if (!isReadingAidsPopupOpen) return $b774ed999997e9e9$var$handleOpenReadingAidsPopup({
            event: event,
            editorView: editorView,
            api: api,
            id: id
        });
    }
    // all other cases, if there is a ReadingAidsPopup open, close it
    if (isReadingAidsPopupOpen) (0, $bcf33f2d1863510f$export$1a54981d304e6ea8)({
        editorView: editorView
    });
    return false;
};
// the confluence example is setup to match I&<>"'`.-D as a keyword, visit the example to see the generated ID
function $b774ed999997e9e9$var$encodeID(s) {
    if (s === '') return '_';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return s.replace(/[^a-zA-Z0-9-]/g, function(match) {
        return '_' + match[0].charCodeAt(0).toString(16);
    });
}
const $b774ed999997e9e9$export$cbc65810ed6fb565 = ({ keywordMatch: keywordMatch })=>{
    const { from: from, to: to, text: text } = keywordMatch;
    const id = `${from}-${to}-${$b774ed999997e9e9$var$encodeID(text)}`;
    return [
        (0, $8nvEM.Decoration).inline(from, to, {
            class: `${(0, $e5c338c49b3f8f39$export$6fa82fd5fa91c059)} ${(0, $e5c338c49b3f8f39$export$6fa82fd5fa91c059)}-${id}`,
            'data-id': id,
            'data-testid': (0, $e5c338c49b3f8f39$export$6fa82fd5fa91c059)
        }, {
            type: 'keyword',
            key: `${(0, $e5c338c49b3f8f39$export$6fa82fd5fa91c059)}-${id}`
        }),
        (0, $8nvEM.Decoration).widget(to, ()=>{
            return (0, $731b45a6880c6d58$export$fa50e52a0393d089)({
                id: id
            });
        }, {
            type: 'keywordStyler',
            key: `${(0, $e5c338c49b3f8f39$export$e6a305940f3628e3)}-${id}`,
            stopEvent: ()=>true,
            ignoreSelection: true
        })
    ];
};
/**
 * Exclude the following nodes from keyword matching
 * - code
 * - status
 */ function $b774ed999997e9e9$var$excludeNode(node) {
    const { name: name } = node.type;
    return name === 'codeBlock' || name === 'status';
}
/**
 * Check if the text node conflict with keyword decoration
 * - annotation mark
 * - link mark
 * - code mark
 */ function $b774ed999997e9e9$var$isTextNodeConflictWithKeywordDecoration(node) {
    return node.isText && node.marks.some((mark)=>{
        const { name: name } = mark.type;
        return name === 'annotation' || name === 'link' || name === 'code';
    });
}
function $b774ed999997e9e9$export$80de22890b760cf9({ content: content, keywordRegex: keywordRegex, contentIndex: contentIndex = 0 }) {
    // each keyword is matched only once
    const set = new Set();
    const matches = [];
    let textGrouping = null;
    const collectMatch = (textGrouping)=>{
        if (!textGrouping) return;
        const { text: text, pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        const regexMatches = text.matchAll(keywordRegex);
        for (const regexMatch of regexMatches){
            const text = regexMatch[0];
            const textKey = keywordRegex.ignoreCase ? text.toUpperCase() : text;
            if (!set.has(textKey)) {
                set.add(textKey);
                matches.push({
                    from: pos + regexMatch.index,
                    to: pos + regexMatch.index + text.length,
                    text: text
                });
            }
        }
    };
    content.descendants((node, pos)=>{
        if ($b774ed999997e9e9$var$excludeNode(node)) return false;
        if (node.isText && node.text) {
            let text = node.text;
            if ($b774ed999997e9e9$var$isTextNodeConflictWithKeywordDecoration(node)) text = ' '.repeat(text.length);
            if (textGrouping === null) textGrouping = {
                pos: pos,
                text: text
            };
            else textGrouping.text += text;
        } else {
            if (textGrouping) collectMatch(textGrouping);
            textGrouping = null;
        }
    });
    // if there's a dangling text grouping and no non-text node to trigger collectMatch, manually collectMatch
    if (textGrouping) collectMatch(textGrouping);
    return matches;
}
function $b774ed999997e9e9$export$88a01eac2e110b7d({ editorView: editorView, keywordRegex: keywordRegex }) {
    let decorations = (0, $8nvEM.DecorationSet).empty;
    const keywordMatches = $b774ed999997e9e9$export$80de22890b760cf9({
        content: editorView.state.doc,
        keywordRegex: keywordRegex
    });
    for (const keywordMatch of keywordMatches){
        const keywordDecorations = $b774ed999997e9e9$export$cbc65810ed6fb565({
            keywordMatch: keywordMatch
        });
        decorations = decorations.add(editorView.state.doc, keywordDecorations);
    }
    return decorations;
}



const $bcf33f2d1863510f$var$WHITESPACE_REGEX = /\s+/u;
const $bcf33f2d1863510f$export$b4ed80ad73192385 = ({ keywordRegex: keywordRegex })=>{
    return (0, $8981c0bdcff3b32a$export$8d4021544bdece00)({
        type: (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).UPDATE_KEYWORD_REGEX,
        keywordRegex: keywordRegex
    });
};
const $bcf33f2d1863510f$export$75983c7c2acffd7c = ()=>{
    return (0, $8981c0bdcff3b32a$export$8d4021544bdece00)({
        type: (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS_SESSION_ID
    });
};
const $bcf33f2d1863510f$export$e98d7ec2d44e59f9 = ({ api: api, source: source, keywordId: keywordId, readingAidsPopupProps: readingAidsPopupProps })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const readingAidsSessionId = (0, $03RpJ.default)();
    return (0, $8981c0bdcff3b32a$export$8d4021544bdece00)({
        type: (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).OPEN_READING_AIDS_POPUP,
        keywordId: keywordId,
        readingAidsPopupProps: {
            ...readingAidsPopupProps,
            sessionId: readingAidsSessionId
        }
    }, (tr)=>{
        if (api) {
            const wordCount = readingAidsPopupProps.selectedText.split($bcf33f2d1863510f$var$WHITESPACE_REGEX).length;
            const payload = (0, $66d5ed65dbed0ef4$export$100e4d52f8971e06)({
                source: source,
                readingAidsSessionId: readingAidsSessionId,
                wordCount: wordCount
            });
            api.analytics?.actions.attachAnalyticsEvent(payload)(tr);
        }
        return tr;
    });
};
const $bcf33f2d1863510f$export$af4a70fda35c1da2 = ({ smartlinkUrl: smartlinkUrl, selectionRect: selectionRect, selectionRange: selectionRange, sourceProduct: sourceProduct, has3pSources: has3pSources, invokedFrom: invokedFrom })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const readingAidsSessionId = (0, $03RpJ.default)();
    return (0, $8981c0bdcff3b32a$export$8d4021544bdece00)({
        type: (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).OPEN_READING_AIDS_POPUP,
        readingAidsPopupProps: {
            mode: 'summarize',
            smartlinkUrl: smartlinkUrl,
            sourceProduct: sourceProduct,
            has3pSources: has3pSources,
            invokedFrom: invokedFrom,
            selectedText: '',
            selectionRect: selectionRect,
            selectionRange: selectionRange,
            isEditor: true,
            sessionId: readingAidsSessionId
        }
    });
};
const $bcf33f2d1863510f$export$309af81d3a816631 = ()=>{
    return (0, $8981c0bdcff3b32a$export$8d4021544bdece00)({
        type: (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).CLOSE_READING_AIDS_POPUP
    });
};
const $bcf33f2d1863510f$export$4879e261232d25a5 = ()=>{
    return (0, $8981c0bdcff3b32a$export$8d4021544bdece00)({
        type: (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).READING_AIDS_POPUP_LOADED
    });
};
const $bcf33f2d1863510f$export$2d7dadf7eed07e1e = ({ keywordDecorations: keywordDecorations })=>{
    return (0, $8981c0bdcff3b32a$export$8d4021544bdece00)({
        type: (0, $dee0f30c0d087121$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS,
        keywordDecorations: keywordDecorations
    });
};
const $bcf33f2d1863510f$export$be9d3c2006420ec4 = ()=>{
    return $bcf33f2d1863510f$export$2d7dadf7eed07e1e({
        keywordDecorations: (0, $8nvEM.DecorationSet).empty
    });
};
function $bcf33f2d1863510f$var$isKeywordDecorationsSessionIdChanged({ editorView: editorView, keywordDecorationsSessionId: keywordDecorationsSessionId }) {
    const aiDefinitionsPluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorView.state);
    return keywordDecorationsSessionId !== aiDefinitionsPluginState.keywordDecorationsSessionId;
}
const $bcf33f2d1863510f$export$30568dc20d74a453 = async ({ api: api, config: config, editorView: editorView })=>{
    try {
        const aiDefinitionsPluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorView.state);
        let { keywordRegex: keywordRegex } = aiDefinitionsPluginState;
        // if keywordRegex is not available, fetch it and update decorations
        if (!keywordRegex) {
            const { keywordDecorationsSessionId: keywordDecorationsSessionId } = aiDefinitionsPluginState;
            const res = await config.queryHighlightAcronyms?.({
                cacheKey: keywordDecorationsSessionId
            });
            // if sessionId changed, abandon the response
            if ($bcf33f2d1863510f$var$isKeywordDecorationsSessionIdChanged({
                editorView: editorView,
                keywordDecorationsSessionId: keywordDecorationsSessionId
            })) return;
            if (res && res.acronymRegex) {
                keywordRegex = res.acronymRegex;
                $bcf33f2d1863510f$export$b4ed80ad73192385({
                    keywordRegex: keywordRegex
                })(editorView.state, editorView.dispatch);
                const keywordDecorations = (0, $b774ed999997e9e9$export$88a01eac2e110b7d)({
                    editorView: editorView,
                    keywordRegex: keywordRegex
                });
                $bcf33f2d1863510f$export$2d7dadf7eed07e1e({
                    keywordDecorations: keywordDecorations
                })(editorView.state, editorView.dispatch);
            }
        }
    } catch (error) {
        api?.analytics?.actions.fireAnalyticsEvent((0, $66d5ed65dbed0ef4$export$aa3898e402a73b22)({
            error: error
        }));
    }
};
const $bcf33f2d1863510f$export$8bb569df7c4f70df = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))($bcf33f2d1863510f$export$30568dc20d74a453, 1000);
function $bcf33f2d1863510f$export$1a54981d304e6ea8({ editorView: editorView }) {
    (0, $731b45a6880c6d58$export$9d5d65b673a5731e)();
    $bcf33f2d1863510f$export$309af81d3a816631()(editorView.state, editorView.dispatch);
}
const $bcf33f2d1863510f$export$13cfc45f69ed2500 = ({ api: api, config: config, editorView: editorView, autoHighlightEnabled: autoHighlightEnabled, livePageMode: livePageMode })=>{
    // we want to closeReadingAidsPopup if there is one opened
    $bcf33f2d1863510f$export$1a54981d304e6ea8({
        editorView: editorView
    });
    // currently, only show auto-highlights in view mode
    if (autoHighlightEnabled && livePageMode === 'view') {
        const cleanObserver = (0, $731b45a6880c6d58$export$941ff97b157be2e9)(editorView.dom);
        // when the decorations aren't changed, the DOM nodes are already inserted when `view` is called
        // - only happens on Hello (not locally)
        // so there must be time racing somehow
        // so update DOM nodes positions here to make sure they are all positioned correctly
        (0, $731b45a6880c6d58$export$eb69c22734bde9b4)();
        $bcf33f2d1863510f$export$30568dc20d74a453({
            api: api,
            config: config,
            editorView: editorView
        });
        return cleanObserver;
    }
};











// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead






function $96af6f462a1a8493$export$53ac33307b5acee9({ config: config }) {
    return {
        enabled: config.enabled ?? true,
        autoHighlightEnabled: config.autoHighlightEnabled ?? true,
        enablementSource: config.enablementSource,
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        keywordDecorationsSessionId: (0, $03RpJ.default)(),
        keywordDecorationsSessionCounter: 0,
        keywordDecorations: (0, $8nvEM.DecorationSet).empty,
        isReadingAidsPopupOpen: false,
        isReadingAidsPopupLoading: false
    };
}




const $e86beec52f1d35da$export$e1b2f721e11eb39 = ({ dispatch: dispatch }, { api: api, config: config })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $b1c303b59bfe1f32$export$319f57d42a2c6302),
        state: (0, $8981c0bdcff3b32a$export$656c7661095efe2e)(dispatch, ()=>(0, $96af6f462a1a8493$export$53ac33307b5acee9)({
                config: config
            })),
        view: (editorView)=>{
            return {
                update: (editorView, prevState)=>{
                    const pluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    const { keywordRegex: keywordRegex, keywordDecorationsSessionCounter: keywordDecorationsSessionCounter } = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorView.state);
                    const prevPluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(prevState);
                    // if it's view mode, and there is no keywordRegex, and it's a new session, update keywords and decorations
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view' && !keywordRegex && keywordDecorationsSessionCounter !== prevPluginState.keywordDecorationsSessionCounter) (0, $bcf33f2d1863510f$export$8bb569df7c4f70df)({
                        api: api,
                        config: config,
                        editorView: editorView
                    });
                }
            };
        },
        props: {
            decorations (state) {
                const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, keywordDecorations: keywordDecorations } = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(state);
                if (!enabled || !autoHighlightEnabled) return;
                // currently, only show auto-highlights in view mode
                if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') return keywordDecorations;
                return (0, $8nvEM.DecorationSet).empty;
            },
            // currently, only show auto-highlights in view mode
            // so we only need to handle DOM events in view mode
            // reading mode outside of callbacks is not accurate, so need to read it in callbacks
            handleDOMEvents: {
                mouseover: (editorView, event)=>{
                    const pluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $731b45a6880c6d58$export$61e1ef05609254a7)(event);
                },
                mouseout: (editorView, event)=>{
                    const pluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $731b45a6880c6d58$export$67fd1109fb9d83c0)(event);
                },
                click: (editorView, event)=>{
                    const pluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $b774ed999997e9e9$export$78fb7b30edc4d46)({
                        editorView: editorView,
                        event: event,
                        api: api
                    });
                }
            }
        }
    });
};







parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $0b5e77027a09f64b$export$bd23a517b9ded82f = (0, $kSwu1.defineMessages)({
    aiDefineToolbarButtonTitle: {
        id: "fabric.editor.ai.selectionToolbar.define.title",
        defaultMessage: "Define"
    },
    aiDefineToolbarButtonDisabledTooltip: {
        id: "fabric.editor.ai.selectionToolbar.define.disabled.tooltip",
        defaultMessage: "Highlight a term, acronym, or abbreviation"
    }
});



var $320o0 = parcelRequire("320o0");


var $NlHoa = parcelRequire("NlHoa");


var $bltJZ = parcelRequire("bltJZ");




const $9b198d93fea607e3$export$b1a3c792af85451 = ({ intl: intl, state: state, config: config, api: api })=>{
    const pluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(state);
    const readingAidsPopupProps = (0, $81bd472d0ee59a6e$export$fba2e0e287e213ab)(state);
    const disabled = (0, $81bd472d0ee59a6e$export$8e4734431f48a29a)(state, config) || !readingAidsPopupProps;
    return {
        title: intl.formatMessage((0, $0b5e77027a09f64b$export$bd23a517b9ded82f).aiDefineToolbarButtonTitle),
        type: 'button',
        showTitle: true,
        testId: 'ak-editor-ai-selection-toolbar-define-button',
        icon: ()=>pluginState.enablementSource === 'rovo' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bltJZ.RovoIcon), {
                size: "small"
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                label: ""
            }),
        iconFallback: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $NlHoa.AtlassianIcon), {
                size: "small"
            }),
        tooltipContent: disabled ? intl.formatMessage((0, $0b5e77027a09f64b$export$bd23a517b9ded82f).aiDefineToolbarButtonDisabledTooltip) : undefined,
        disabled: disabled,
        onClick: readingAidsPopupProps ? (0, $bcf33f2d1863510f$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'define-button-click',
            readingAidsPopupProps: readingAidsPopupProps
        }) : undefined,
        supportsViewMode: true
    };
};
const $9b198d93fea607e3$export$e3893182b22560a6 = ({ intl: intl, state: state, config: config, api: api })=>{
    const pluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(state);
    const readingAidsPopupProps = (0, $81bd472d0ee59a6e$export$fba2e0e287e213ab)(state);
    const disabled = (0, $81bd472d0ee59a6e$export$8e4734431f48a29a)(state, config) || !readingAidsPopupProps;
    return {
        title: intl.formatMessage((0, $0b5e77027a09f64b$export$bd23a517b9ded82f).aiDefineToolbarButtonTitle),
        icon: pluginState.enablementSource === 'rovo' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bltJZ.RovoIcon), {
            size: "small"
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
            label: ""
        }),
        iconFallback: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $NlHoa.AtlassianIcon), {
                size: "small"
            }),
        tooltipContent: disabled ? intl.formatMessage((0, $0b5e77027a09f64b$export$bd23a517b9ded82f).aiDefineToolbarButtonDisabledTooltip) : undefined,
        disabled: disabled,
        onClick: readingAidsPopupProps ? (0, $bcf33f2d1863510f$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'define-button-click',
            readingAidsPopupProps: readingAidsPopupProps
        }) : undefined,
        rank: 20
    };
};


/* AIDefinitions.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");





var $3k5Tv = parcelRequire("3k5Tv");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");





parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

function $f51c48173dbccee8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/ensure-design-token-usage -- Ignored via go/DSP-18766
const $f51c48173dbccee8$var$aiDefinitionsStyle = {
    name: "yu6qqn",
    styles: ".ai-definitions-keyword-decoration{position:relative;cursor:pointer;}.ai-definitions-keyword-styler{--ai-definitions-keyword-styler-width:0;--ai-definitions-keyword-styler-height:0;position:relative;&::after{content:' ';position:absolute;top:0;right:0;width:var(--ai-definitions-keyword-styler-width);height:var(--ai-definitions-keyword-styler-height);cursor:pointer;pointer-events:none;border-image:linear-gradient(to right, #0065ff, #bf63f3, #f5e6a8) 0 0 100% 0;border-width:var(--ds-border-width-selected, 2px);border-bottom-style:solid;}&-hover{&::after{background:linear-gradient(to right, rgba(0, 101, 255, 0.1), rgba(191, 99, 243, 0.1));}}&-loading{&::after{border-color:transparent;border-image:none;}}}"
};
function $f51c48173dbccee8$export$982108a47f208f5a() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOiVq.Global), {
        styles: $f51c48173dbccee8$var$aiDefinitionsStyle
    });
}






function $a8d4d927722b7a50$export$3d264a8b1343e9d3({ api: api, show: show }) {
    (0, $cozmU.useEffect)(()=>{
        if (show) api?.selectionToolbar.actions?.suppressToolbar?.();
        else api?.selectionToolbar.actions?.unsuppressToolbar?.();
        return ()=>{
            api?.selectionToolbar.actions?.unsuppressToolbar?.();
        };
    }, [
        api,
        show
    ]);
}


const $1d0157fd2e70d19a$var$readingAidsPopupPortalContainerStyle = null;
function $1d0157fd2e70d19a$var$canShowReadingAidsPopup({ props: props, enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, readingAidsPopupProps: readingAidsPopupProps, readingAidsPopupKey: readingAidsPopupKey, isReadingAidsPopupOpen: isReadingAidsPopupOpen }) {
    const { contentId: contentId, ReadingAidsPopup: ReadingAidsPopup, editorView: editorView } = props;
    if (editorView && enabled !== undefined && autoHighlightEnabled !== undefined && contentId && ReadingAidsPopup && isReadingAidsPopupOpen && readingAidsPopupKey && readingAidsPopupProps) return {
        show: true,
        contentId: contentId,
        ReadingAidsPopup: ReadingAidsPopup,
        isReadingAidsPopupOpen: isReadingAidsPopupOpen,
        readingAidsPopupKey: readingAidsPopupKey,
        readingAidsPopupProps: readingAidsPopupProps
    };
    return {
        show: false,
        contentId: undefined,
        ReadingAidsPopup: undefined,
        isReadingAidsPopupOpen: false,
        readingAidsPopupKey: undefined,
        readingAidsPopupProps: undefined
    };
}
const $1d0157fd2e70d19a$export$fc2b565ec08fe192 = (props)=>{
    const { api: api, editorView: editorView } = props;
    const { enabled: sharedEnabled, autoHighlightEnabled: sharedAutoHighlightEnabled, readingAidsPopupProps: sharedReadingAidsPopupProps, readingAidsPopupKey: sharedReadingAidsPopupKey, isReadingAidsPopupOpen: sharedIsReadingAidsPopupOpen, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiDefinitions',
        'editorViewMode'
    ], (states)=>{
        return {
            enabled: states.aiDefinitionsState?.enabled,
            autoHighlightEnabled: states.aiDefinitionsState?.autoHighlightEnabled,
            readingAidsPopupProps: states.aiDefinitionsState?.readingAidsPopupProps,
            readingAidsPopupKey: states.aiDefinitionsState?.readingAidsPopupKey,
            isReadingAidsPopupOpen: states.aiDefinitionsState?.isReadingAidsPopupOpen,
            mode: states.editorViewModeState?.mode
        };
    });
    const defaultOnResult = (0, $cozmU.useCallback)(()=>{}, []);
    const onLoad = (0, $cozmU.useCallback)(()=>{
        sharedReadingAidsPopupProps?.onLoad?.(); // maybe log analytics event here in the future if needed
    }, [
        sharedReadingAidsPopupProps
    ]);
    const defaultOnClose = (0, $cozmU.useCallback)(()=>{
        (0, $bcf33f2d1863510f$export$309af81d3a816631)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const { show: show, contentId: contentId, ReadingAidsPopup: ReadingAidsPopup, readingAidsPopupKey: readingAidsPopupKey, readingAidsPopupProps: readingAidsPopupProps } = $1d0157fd2e70d19a$var$canShowReadingAidsPopup({
        props: props,
        enabled: sharedEnabled,
        autoHighlightEnabled: sharedAutoHighlightEnabled,
        readingAidsPopupProps: sharedReadingAidsPopupProps,
        readingAidsPopupKey: sharedReadingAidsPopupKey,
        isReadingAidsPopupOpen: sharedIsReadingAidsPopupOpen
    });
    (0, $a8d4d927722b7a50$export$3d264a8b1343e9d3)({
        api: api,
        show: show
    });
    if (!sharedEnabled || !sharedAutoHighlightEnabled) return null;
    if (!(0, $iDrrr.fg)('platform_editor_ai_aifc_streaming')) {
        // Summarize popups are triggered from the smartlink floating toolbar,
        // which only shows in edit mode — allow them to render here regardless
        // of the view-mode gate (only when the smartlink-toolbar experiment is
        // on, since that's the only surface that produces summarize-mode popups).
        const isSummarizeMode = sharedReadingAidsPopupProps?.mode === 'summarize' && (0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
        if (mode !== 'view' && !isSummarizeMode) return null;
    }
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f51c48173dbccee8$export$982108a47f208f5a), {}),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                id: (0, $e5c338c49b3f8f39$export$5e663b7e0d8861d1),
                className: (0, $hekY6.default)([
                    "_1mT5xdRAKS"
                ])
            }),
            show ? /*#__PURE__*/ (0, $8aG6j.jsx)(ReadingAidsPopup, {
                ...readingAidsPopupProps,
                isReadingAidsOpen: true,
                popupPortalContainerId: (0, $e5c338c49b3f8f39$export$5e663b7e0d8861d1),
                contentId: contentId,
                onResult: readingAidsPopupProps?.onResult || defaultOnResult,
                onLoad: onLoad,
                onClose: readingAidsPopupProps?.onClose || defaultOnClose
            }, readingAidsPopupKey) : null
        ]
    });
};






class $b5d0872c35fd535b$export$3e783c4264baeca1 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.api?.analytics?.actions.fireAnalyticsEvent((0, $66d5ed65dbed0ef4$export$aa3898e402a73b22)({
            error: error,
            errorInfo: errorInfo
        }));
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}



const $a2c85224ab344c5f$export$cfdfeacb0c6e55a6 = ({ api: api, config: config })=>{
    const editorViewRef = {
        current: undefined
    };
    return {
        name: 'aiDefinitions',
        usePluginHook: ({ editorView: editorView })=>{
            const enabled = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'aiDefinitions.enabled');
            const autoHighlightEnabled = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'aiDefinitions.autoHighlightEnabled');
            const livePageMode = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'editorViewMode.mode');
            (0, $cozmU.useEffect)(()=>{
                if (!enabled) return;
                // pass autoHighlightEnabled here, so that
                // when command updateState is called, it will trigger usePluginHook to rerun
                return (0, $bcf33f2d1863510f$export$13cfc45f69ed2500)({
                    api: api,
                    config: config,
                    editorView: editorView,
                    livePageMode: livePageMode,
                    autoHighlightEnabled: autoHighlightEnabled
                });
            }, [
                editorView,
                enabled,
                autoHighlightEnabled,
                livePageMode
            ]);
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'aiDefinitionsEditorViewRef',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ];
            pmPlugins.push({
                name: 'aiDefinitions',
                plugin: (params)=>(0, $e86beec52f1d35da$export$e1b2f721e11eb39)(params, {
                        api: api,
                        config: config
                    })
            });
            return pmPlugins;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const pluginState = (0, $b1c303b59bfe1f32$export$319f57d42a2c6302).getState(editorState);
            if (!pluginState) return null;
            return {
                enabled: pluginState.enabled,
                autoHighlightEnabled: pluginState.autoHighlightEnabled,
                isReadingAidsPopupOpen: pluginState.isReadingAidsPopupOpen,
                readingAidsPopupKey: pluginState.readingAidsPopupKey,
                readingAidsPopupProps: pluginState.readingAidsPopupProps
            };
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b5d0872c35fd535b$export$3e783c4264baeca1), {
                api: api,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1d0157fd2e70d19a$export$fc2b565ec08fe192), {
                    api: api,
                    editorView: editorView,
                    contentId: config.contentId,
                    ReadingAidsPopup: config.ReadingAidsPopup
                })
            });
        },
        pluginsOptions: {
            selectionToolbar: (state, intl)=>{
                const pluginState = (0, $8981c0bdcff3b32a$export$f05434c51e3762e)(state);
                if (!pluginState.enabled) return;
                const items = [];
                // only show AI define button in consumption mode
                if (api && (0, $81bd472d0ee59a6e$export$4615c92e40b4fcd9)(state)) {
                    const aiDefinitionItem = api?.editorViewMode.sharedState.currentState()?.mode === 'view' ? (0, $9b198d93fea607e3$export$b1a3c792af85451)({
                        intl: intl,
                        state: state,
                        config: config,
                        api: api
                    }) : null;
                    aiDefinitionItem && items.push(aiDefinitionItem);
                }
                if (items.length) return {
                    rank: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? 10 : -10,
                    isToolbarAbove: true,
                    items: items
                };
            }
        },
        commands: {
            // this will update the plugin state and trigger the usePluginHook to rerun
            updateState: (0, $642612dafa9301b2$export$4971331372cec95a)({
                editorViewRef: editorViewRef
            })
        },
        actions: {
            openReadingAidsPopup: ()=>{
                const readingAidsPopupProps = (0, $81bd472d0ee59a6e$export$fba2e0e287e213ab)(editorViewRef.current?.state);
                if (editorViewRef.current && editorViewRef.current.state && editorViewRef.current.dispatch && readingAidsPopupProps) (0, $bcf33f2d1863510f$export$e98d7ec2d44e59f9)({
                    api: api,
                    readingAidsPopupProps: readingAidsPopupProps,
                    source: 'define-button-click'
                })(editorViewRef.current.state, editorViewRef.current.dispatch);
            },
            openSmartLinkSummarizePopup: ({ from: from, smartlinkUrl: smartlinkUrl, to: to, sourceProduct: sourceProduct, has3pSources: has3pSources, invokedFrom: invokedFrom })=>{
                const editorView = editorViewRef.current;
                if (!editorView || !editorView.state || !editorView.dispatch) return;
                const { selectionRect: selectionRect, selectionRange: selectionRange } = (0, $81bd472d0ee59a6e$export$449a1ad28b94e2e3)(editorView, from, to);
                (0, $bcf33f2d1863510f$export$af4a70fda35c1da2)({
                    smartlinkUrl: smartlinkUrl,
                    selectionRect: selectionRect,
                    selectionRange: selectionRange,
                    sourceProduct: sourceProduct,
                    has3pSources: has3pSources,
                    invokedFrom: invokedFrom
                })(editorView.state, editorView.dispatch);
            },
            selectionExceedsMaxWordCount: ()=>{
                const state = editorViewRef.current?.state;
                if (!state) return false;
                return (0, $81bd472d0ee59a6e$export$8e4734431f48a29a)(state, config);
            }
        }
    };
};
module.exports["aiDefinitionsPlugin"] = $a2c85224ab344c5f$export$cfdfeacb0c6e55a6;

});

parcelRegister("7WOVi", function(module, exports) {

var $wPrRK = parcelRequire("wPrRK");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $4vyfK = parcelRequire("4vyfK");


var $3D1KL = parcelRequire("3D1KL");




var $5rHrW = parcelRequire("5rHrW");


var $3Tnjq = parcelRequire("3Tnjq");




/**
 * @generated SignedSource<<20db4a469ef7b42c319a2c99f14f060b>>
 * @relayHash 6ea58338105a015fd443972b8fa8bd85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64
const $05607cbb6652fe1b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6ea58338105a015fd443972b8fa8bd85",
            "id": "c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64",
            "metadata": {},
            "name": "GrantAccessDialogLoaderQuery",
            "operationKind": "query",
            "text": "query GrantAccessDialogLoaderQuery($contentId:ID!,$accountId:ID!){singleContent(id:$contentId){id,title},user:confluence_atlassianUser(id:$accountId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$05607cbb6652fe1b$var$node.hash = "65e9fca072feda54403e4da52299bc66";
var $05607cbb6652fe1b$export$2e2bcd8739ae039 = $05607cbb6652fe1b$var$node;


function $5aaba4497ca7f117$export$57e3b4d699814923(contentId, accountId) {
    return (0, $dYU3e.query)({
        query: (0, $05607cbb6652fe1b$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId,
            accountId: accountId
        },
        __callerPackage__: "grant-access-dialog"
    });
}



var $3cpum = parcelRequire("3cpum");





var $8EyOs = parcelRequire("8EyOs");

async function $211ceb0d96c4c9d7$export$b64510f17befad98(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $8EyOs.default),
        variables: {
            contentId: contentId,
            isDraft: false,
            format: 'USER_FRIENDLY'
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "content-state"
    });
}





var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");



var $1xpoY = parcelRequire("1xpoY");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");

function $f78a51e3eee2d07c$export$4a035f320f010fac({ spaceKey: spaceKey, contentId: contentId, username: username, edition: edition, isPrevEditRoute: isPrevEditRoute = false, useNewContentTopper: useNewContentTopper = false, isLivePageRoute: isLivePageRoute = false, isContentTypePublicLinkEligible: isContentTypePublicLinkEligible = false, hasDocumentContractMetadata: hasDocumentContractMetadata = false, hasDocumentContractClassification: hasDocumentContractClassification = false, hasDocumentContractBody: hasDocumentContractBody = false, hasDocumentContractAnalyticsByline: hasDocumentContractAnalyticsByline = false, hasDocumentContractContentHeader: hasDocumentContractContentHeader = false }) {
    const queries = [];
    const shouldUseContentHeaderFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasDocumentContractContentHeader && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('confluence_vp_header_frag_reader');
    // The compatibility query is preloaded when the document-contract reader is unavailable.
    // On restricted pages we do not render or use its result.
    // Hence mute the restriction errors on preloading to avoid unnecessary noise.
    // The mute logic is done in muteExpectedGraphQLErrors, here we just want to know if errors happened.
    let hasErrors = false;
    const checkHasGraphQLErrors = (result)=>{
        hasErrors || (hasErrors = Boolean(result?.hasErrors));
        return result;
    };
    // Don't preload queries that will be updated by editor if previous route is edit_page
    if (!isPrevEditRoute) {
        if (!shouldUseContentHeaderFragment) queries.push((0, $dYU3e.query)({
            query: (0, $fxLAA.default),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                versionOverride: null,
                embeddedContentRender: null,
                limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                useNewContentTopper: useNewContentTopper,
                isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
                includeDevDocsBylineConnection: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment') && (0, $6mKj3.isExperimentEnabled)('confluence_dev_docs'),
                useObjectHeaderFragment: (0, $9wGTI.fg)('confluence_vp_obj_header_frag_dedup'),
                useEditButtonFragment: (0, $9wGTI.fg)('confluence_vp_edit_frag_reader'),
                useAccessButtonFragment: (0, $9wGTI.fg)('confluence_vp_access_frag_reader'),
                includePublicLink: isContentTypePublicLinkEligible && (0, $9wGTI.fg)('confluence_vp_access_frag_reader'),
                includeClassification: isLivePageRoute && (0, $9wGTI.fg)('confluence_vp_classification_context_frag_reader')
            },
            __callerPackage__: "content-header"
        }).then(checkHasGraphQLErrors));
        // Editor will preload the content state if it's a live page
        if (!isLivePageRoute) {
            const shouldUseRendererContentStateFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            hasDocumentContractMetadata && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('confluence_vp_title_byline_frag_dedup') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('confluence_vp_meta_frag_reader');
            if (!shouldUseRendererContentStateFragment) queries.push((0, $211ceb0d96c4c9d7$export$b64510f17befad98)(contentId).then(checkHasGraphQLErrors));
            // The approvals experience still needs editor content state data.
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) queries.push((0, $3cpum.preloadEditorContentState)({
                contentId: contentId,
                useCache: false,
                shouldGetDraftVersion: false
            }).then(checkHasGraphQLErrors));
        }
        // SSR Grant Access Restrictions button
        // username is a legacy URL parameter that actually represents accountId in the grant access flow
        if (contentId && username) queries.push((0, $5aaba4497ca7f117$export$57e3b4d699814923)(contentId, username));
        //unlike SPA, no need to check the route since preloadContentHeader is fired only when its VIEW_PAGE.
        const includeAncestors = edition === (0, $80xNa.CONFLUENCE_EDITION).FREE;
        queries.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, includeAncestors));
    }
    const contentHeaderTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_content_header_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const shouldUseAnalyticsBylineFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasDocumentContractAnalyticsByline && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('confluence_vp_analytics_byline_frag_reader');
    if (!(0, $9wGTI.fg)('confluence_vp_edit_frag_reader')) queries.push((0, $3D1KL.preloadEditButton)({
        spaceKey: spaceKey,
        contentId: contentId
    }));
    queries.push(...shouldUseAnalyticsBylineFragment ? [] : [
        (0, $wPrRK.slowQueryGuard)('preloadContentAnalyticsViewers', ()=>(0, $5rHrW.preloadContentAnalyticsViewers)(contentId).then(checkHasGraphQLErrors), contentHeaderTimeout)
    ]);
    if (!isLivePageRoute) // preload data for whether "unpublished changes" label should show in view page object header
    queries.push((0, $4vyfK.preloadWebItemLocation)({
        location: 'page.metadata.banner',
        contentId: contentId
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(queries).then((errors)=>Boolean(errors || hasErrors));
}
module.exports["preloadContentHeader"] = $f78a51e3eee2d07c$export$4a035f320f010fac;

});

parcelRegister("8XUSS", function(module, exports) {
// Exported for testing
const $6f18789dfc68c5f3$export$483989a9813b3c0d = 'resolved';
const $6f18789dfc68c5f3$export$a3269a3914b007e3 = 'forbidden';
const $6f18789dfc68c5f3$export$67d19e9a991baa07 = 'unauthorized';
const $6f18789dfc68c5f3$export$8bca792d963eb0ef = 'not_found';
const $6f18789dfc68c5f3$export$b70265791d2079d4 = (statusCode, access)=>{
    const statusMap = {
        200: $6f18789dfc68c5f3$export$483989a9813b3c0d,
        401: $6f18789dfc68c5f3$export$67d19e9a991baa07,
        403: $6f18789dfc68c5f3$export$a3269a3914b007e3,
        404: $6f18789dfc68c5f3$export$8bca792d963eb0ef
    };
    if (access === $6f18789dfc68c5f3$export$a3269a3914b007e3 || access === $6f18789dfc68c5f3$export$67d19e9a991baa07) return access;
    return statusMap[statusCode] || 'errored';
};
module.exports["RESOLVED"] = $6f18789dfc68c5f3$export$483989a9813b3c0d;
module.exports["FORBIDDEN"] = $6f18789dfc68c5f3$export$a3269a3914b007e3;
module.exports["getStatus"] = $6f18789dfc68c5f3$export$b70265791d2079d4;

});

parcelRegister("cdE3K", function(module, exports) {

var $MyxIQ = parcelRequire("MyxIQ");


var $9WAeG = parcelRequire("9WAeG");


var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");

const $5983b7a8cf0f433d$export$5607995cc5080e70 = async ()=>{
    const tasks = [];
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    if (userId) {
        const preloadPostOfficeSideNav = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceSideNav', async ()=>{
                return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('confluence-side-nav');
            });
        };
        tasks.push(preloadPostOfficeSideNav());
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
module.exports["preloadPostOfficeConfluenceSideNav"] = $5983b7a8cf0f433d$export$5607995cc5080e70;

});


$parcel$global.rlb("iYnSD")
//# sourceMappingURL=FullPageEditorComponent.d8aac839.js.map
